export default {
  plane: [
    {
      "x": 50.46,
      "y": 28.56,
      "r": -0.0011981999999999939
    },
    {
      "x": 50.71,
      "y": 28.66,
      "r": -0.0013975499999999696
    },
    {
      "x": 51.05,
      "y": 28.79,
      "r": -0.0016764719999999844
    },
    {
      "x": 51.09,
      "y": 28.81,
      "r": -0.0017163019999999918
    },
    {
      "x": 51.24,
      "y": 28.86,
      "r": -0.0018357680000000267
    },
    {
      "x": 51.29,
      "y": 28.88,
      "r": -0.0018755820000000202
    },
    {
      "x": 52.07,
      "y": 29.18,
      "r": -0.0025120619999999816
    },
    {
      "x": 52.12,
      "y": 29.2,
      "r": -0.0025518079999999888
    },
    {
      "x": 52.85,
      "y": 29.48,
      "r": -0.003147518000000016
    },
    {
      "x": 52.9,
      "y": 29.5,
      "r": -0.0031872000000000124
    },
    {
      "x": 53.77,
      "y": 29.83,
      "r": -0.0039007920000000197
    },
    {
      "x": 53.82,
      "y": 29.85,
      "r": -0.003940398000000012
    },
    {
      "x": 54.5,
      "y": 30.12,
      "r": -0.004494461999999988
    },
    {
      "x": 54.55,
      "y": 30.13,
      "r": -0.0045340079999999896
    },
    {
      "x": 55.28,
      "y": 30.41,
      "r": -0.00512671800000002
    },
    {
      "x": 55.32,
      "y": 30.43,
      "r": -0.00516620000000001
    },
    {
      "x": 56.1,
      "y": 30.73,
      "r": -0.0057973680000000145
    },
    {
      "x": 56.15,
      "y": 30.75,
      "r": -0.005836782000000019
    },
    {
      "x": 56.88,
      "y": 31.03,
      "r": -0.006427512000000002
    },
    {
      "x": 56.93,
      "y": 31.05,
      "r": -0.006466861999999996
    },
    {
      "x": 57.7,
      "y": 31.35,
      "r": -0.007095918000000001
    },
    {
      "x": 57.75,
      "y": 31.37,
      "r": -0.007135200000000008
    },
    {
      "x": 58.53,
      "y": 31.66,
      "r": -0.007763167999999987
    },
    {
      "x": 58.57,
      "y": 31.68,
      "r": -0.00780238200000003
    },
    {
      "x": 59.35,
      "y": 31.98,
      "r": -0.008429262000000005
    },
    {
      "x": 59.4,
      "y": 32,
      "r": -0.008468407999999995
    },
    {
      "x": 60.12,
      "y": 32.28,
      "r": -0.009055118000000006
    },
    {
      "x": 60.17,
      "y": 32.3,
      "r": -0.009094200000000009
    },
    {
      "x": 60.95,
      "y": 32.59,
      "r": -0.009718967999999984
    },
    {
      "x": 60.95,
      "y": 32.59,
      "r": -0.009718967999999984
    },
    {
      "x": 61.72,
      "y": 32.89,
      "r": -0.01034271200000001
    },
    {
      "x": 61.77,
      "y": 32.91,
      "r": -0.010381661999999993
    },
    {
      "x": 62.54,
      "y": 33.21,
      "r": -0.011004318000000013
    },
    {
      "x": 62.59,
      "y": 33.23,
      "r": -0.01104320000000001
    },
    {
      "x": 63.36,
      "y": 33.52,
      "r": -0.011664767999999982
    },
    {
      "x": 63.41,
      "y": 33.54,
      "r": -0.01170358199999999
    },
    {
      "x": 64.14,
      "y": 33.82,
      "r": -0.012285312000000005
    },
    {
      "x": 64.18,
      "y": 33.84,
      "r": -0.012324062000000004
    },
    {
      "x": 64.96,
      "y": 34.14,
      "r": -0.012943518000000022
    },
    {
      "x": 65,
      "y": 34.16,
      "r": -0.012982200000000011
    },
    {
      "x": 65.78,
      "y": 34.45,
      "r": -0.01360056799999998
    },
    {
      "x": 65.78,
      "y": 34.45,
      "r": -0.01360056799999998
    },
    {
      "x": 66.55,
      "y": 34.75,
      "r": -0.014217912
    },
    {
      "x": 66.6,
      "y": 34.77,
      "r": -0.014256461999999992
    },
    {
      "x": 67.37,
      "y": 35.06,
      "r": -0.014872718000000007
    },
    {
      "x": 67.42,
      "y": 35.08,
      "r": -0.014911200000000013
    },
    {
      "x": 68.19,
      "y": 35.38,
      "r": -0.01552636799999998
    },
    {
      "x": 68.23,
      "y": 35.4,
      "r": -0.015564781999999978
    },
    {
      "x": 69,
      "y": 35.69,
      "r": -0.016178862000000006
    },
    {
      "x": 69,
      "y": 35.69,
      "r": -0.016178862000000006
    },
    {
      "x": 69.77,
      "y": 35.99,
      "r": -0.016791918000000017
    },
    {
      "x": 69.82,
      "y": 36.01,
      "r": -0.016830200000000017
    },
    {
      "x": 70.59,
      "y": 36.3,
      "r": -0.01744216799999998
    },
    {
      "x": 70.59,
      "y": 36.3,
      "r": -0.01744216799999998
    },
    {
      "x": 71.41,
      "y": 36.62,
      "r": -0.018091261999999997
    },
    {
      "x": 71.41,
      "y": 36.62,
      "r": -0.018091261999999997
    },
    {
      "x": 72.18,
      "y": 36.91,
      "r": -0.018701117999999985
    },
    {
      "x": 72.22,
      "y": 36.93,
      "r": -0.018739200000000022
    },
    {
      "x": 72.99,
      "y": 37.23,
      "r": -0.019347967999999983
    },
    {
      "x": 73.04,
      "y": 37.25,
      "r": -0.019385981999999993
    },
    {
      "x": 73.81,
      "y": 37.54,
      "r": -0.019993662000000013
    },
    {
      "x": 73.81,
      "y": 37.54,
      "r": -0.019993662000000013
    },
    {
      "x": 74.58,
      "y": 37.84,
      "r": -0.02060031800000002
    },
    {
      "x": 74.62,
      "y": 37.86,
      "r": -0.02063820000000003
    },
    {
      "x": 75.39,
      "y": 38.15,
      "r": -0.021243767999999986
    },
    {
      "x": 75.44,
      "y": 38.17,
      "r": -0.02128158199999999
    },
    {
      "x": 76.2,
      "y": 38.46,
      "r": -0.021886062000000008
    },
    {
      "x": 76.2,
      "y": 38.46,
      "r": -0.021886062000000008
    },
    {
      "x": 76.97,
      "y": 38.76,
      "r": -0.022489517999999986
    },
    {
      "x": 77.02,
      "y": 38.78,
      "r": -0.02252719999999997
    },
    {
      "x": 77.78,
      "y": 39.07,
      "r": -0.02312956799999999
    },
    {
      "x": 77.83,
      "y": 39.09,
      "r": -0.023167181999999988
    },
    {
      "x": 78.6,
      "y": 39.38,
      "r": -0.023768462000000004
    },
    {
      "x": 78.6,
      "y": 39.38,
      "r": -0.023768462000000004
    },
    {
      "x": 79.36,
      "y": 39.68,
      "r": -0.024368718000000025
    },
    {
      "x": 79.41,
      "y": 39.7,
      "r": -0.024406200000000024
    },
    {
      "x": 80.17,
      "y": 39.99,
      "r": -0.025005367999999997
    },
    {
      "x": 80.22,
      "y": 40.01,
      "r": -0.025042781999999986
    },
    {
      "x": 80.99,
      "y": 40.3,
      "r": -0.02564086200000002
    },
    {
      "x": 80.99,
      "y": 40.3,
      "r": -0.02564086200000002
    },
    {
      "x": 81.75,
      "y": 40.6,
      "r": -0.026237917999999995
    },
    {
      "x": 81.8,
      "y": 40.61,
      "r": -0.026275199999999988
    },
    {
      "x": 82.56,
      "y": 40.91,
      "r": -0.026871168
    },
    {
      "x": 82.61,
      "y": 40.93,
      "r": -0.026908381999999988
    },
    {
      "x": 83.94,
      "y": 41.44,
      "r": -0.027948750000000012
    },
    {
      "x": 84.04,
      "y": 41.48,
      "r": -0.028022941999999995
    },
    {
      "x": 84.23,
      "y": 41.55,
      "r": -0.02817127800000001
    },
    {
      "x": 84.28,
      "y": 41.57,
      "r": -0.028208352000000027
    },
    {
      "x": 84.94,
      "y": 41.82,
      "r": -0.02872696800000001
    },
    {
      "x": 84.99,
      "y": 41.84,
      "r": -0.02876398199999999
    },
    {
      "x": 85.75,
      "y": 42.14,
      "r": -0.02935566200000002
    },
    {
      "x": 85.75,
      "y": 42.14,
      "r": -0.02935566200000002
    },
    {
      "x": 86.51,
      "y": 42.43,
      "r": -0.029946317999999986
    },
    {
      "x": 86.56,
      "y": 42.45,
      "r": -0.029983199999999988
    },
    {
      "x": 87.32,
      "y": 42.74,
      "r": -0.030572767999999997
    },
    {
      "x": 87.37,
      "y": 42.76,
      "r": -0.030609581999999993
    },
    {
      "x": 88.13,
      "y": 43.05,
      "r": -0.031198062000000016
    },
    {
      "x": 88.13,
      "y": 43.05,
      "r": -0.031198062000000016
    },
    {
      "x": 88.94,
      "y": 43.36,
      "r": -0.03182219999999998
    },
    {
      "x": 88.94,
      "y": 43.36,
      "r": -0.03182219999999998
    },
    {
      "x": 89.7,
      "y": 43.65,
      "r": -0.032408568000000006
    },
    {
      "x": 89.74,
      "y": 43.67,
      "r": -0.032445181999999996
    },
    {
      "x": 90.5,
      "y": 43.96,
      "r": -0.03303046200000002
    },
    {
      "x": 90.5,
      "y": 43.96,
      "r": -0.03303046200000002
    },
    {
      "x": 91.31,
      "y": 44.27,
      "r": -0.03365119999999999
    },
    {
      "x": 91.31,
      "y": 44.27,
      "r": -0.03365119999999999
    },
    {
      "x": 92.07,
      "y": 44.56,
      "r": -0.034234368000000015
    },
    {
      "x": 92.12,
      "y": 44.58,
      "r": -0.034270782
    },
    {
      "x": 92.87,
      "y": 44.87,
      "r": -0.03485286200000002
    },
    {
      "x": 92.87,
      "y": 44.87,
      "r": -0.03485286200000002
    },
    {
      "x": 93.68,
      "y": 45.18,
      "r": -0.035470199999999986
    },
    {
      "x": 93.68,
      "y": 45.18,
      "r": -0.035470199999999986
    },
    {
      "x": 94.44,
      "y": 45.48,
      "r": -0.03605016800000001
    },
    {
      "x": 94.48,
      "y": 45.49,
      "r": -0.03608638200000001
    },
    {
      "x": 95.24,
      "y": 45.78,
      "r": -0.036665261999999976
    },
    {
      "x": 95.24,
      "y": 45.78,
      "r": -0.036665261999999976
    },
    {
      "x": 96.04,
      "y": 46.09,
      "r": -0.037279200000000005
    },
    {
      "x": 96.04,
      "y": 46.09,
      "r": -0.037279200000000005
    },
    {
      "x": 96.8,
      "y": 46.38,
      "r": -0.03785596800000002
    },
    {
      "x": 96.85,
      "y": 46.4,
      "r": -0.03789198200000002
    },
    {
      "x": 97.65,
      "y": 46.71,
      "r": -0.038503608000000016
    },
    {
      "x": 97.7,
      "y": 46.73,
      "r": -0.03853955000000003
    },
    {
      "x": 98.4,
      "y": 47,
      "r": -0.0390782
    },
    {
      "x": 98.4,
      "y": 47,
      "r": -0.0390782
    },
    {
      "x": 99.16,
      "y": 47.29,
      "r": -0.03965176800000001
    },
    {
      "x": 99.21,
      "y": 47.31,
      "r": -0.039687582
    },
    {
      "x": 99.96,
      "y": 47.6,
      "r": -0.040260061999999985
    },
    {
      "x": 100.01,
      "y": 47.62,
      "r": -0.04029580799999999
    },
    {
      "x": 100.76,
      "y": 47.91,
      "r": -0.04086719999999999
    },
    {
      "x": 100.76,
      "y": 47.91,
      "r": -0.04086719999999999
    },
    {
      "x": 101.52,
      "y": 48.2,
      "r": -0.04143756800000001
    },
    {
      "x": 101.56,
      "y": 48.22,
      "r": -0.04147318200000001
    },
    {
      "x": 102.32,
      "y": 48.51,
      "r": -0.04204246200000002
    },
    {
      "x": 102.36,
      "y": 48.52,
      "r": -0.042078008000000014
    },
    {
      "x": 103.11,
      "y": 48.81,
      "r": -0.042646199999999995
    },
    {
      "x": 103.11,
      "y": 48.81,
      "r": -0.042646199999999995
    },
    {
      "x": 103.87,
      "y": 49.1,
      "r": -0.04321336800000002
    },
    {
      "x": 103.91,
      "y": 49.12,
      "r": -0.04324878200000002
    },
    {
      "x": 104.67,
      "y": 49.41,
      "r": -0.04381486199999998
    },
    {
      "x": 104.71,
      "y": 49.43,
      "r": -0.043850207999999995
    },
    {
      "x": 105.46,
      "y": 49.72,
      "r": -0.04441519999999999
    },
    {
      "x": 105.46,
      "y": 49.72,
      "r": -0.04441519999999999
    },
    {
      "x": 106.26,
      "y": 50.02,
      "r": -0.04501438200000001
    },
    {
      "x": 106.26,
      "y": 50.02,
      "r": -0.04501438200000001
    },
    {
      "x": 107.01,
      "y": 50.31,
      "r": -0.045577261999999986
    },
    {
      "x": 107.06,
      "y": 50.33,
      "r": -0.04561240800000002
    },
    {
      "x": 107.81,
      "y": 50.62,
      "r": -0.04617420000000001
    },
    {
      "x": 107.81,
      "y": 50.62,
      "r": -0.04617420000000001
    },
    {
      "x": 108.61,
      "y": 50.93,
      "r": -0.04676998200000002
    },
    {
      "x": 108.61,
      "y": 50.93,
      "r": -0.04676998200000002
    },
    {
      "x": 109.36,
      "y": 51.21,
      "r": -0.04732966200000002
    },
    {
      "x": 109.4,
      "y": 51.23,
      "r": -0.04736460800000002
    },
    {
      "x": 110.15,
      "y": 51.52,
      "r": -0.04792320000000001
    },
    {
      "x": 110.15,
      "y": 51.52,
      "r": -0.04792320000000001
    },
    {
      "x": 110.95,
      "y": 51.83,
      "r": -0.048515581999999974
    },
    {
      "x": 110.99,
      "y": 51.84,
      "r": -0.04855039199999998
    },
    {
      "x": 111.7,
      "y": 52.11,
      "r": -0.049072061999999986
    },
    {
      "x": 111.74,
      "y": 52.13,
      "r": -0.04910680799999998
    },
    {
      "x": 112.49,
      "y": 52.42,
      "r": -0.04966220000000002
    },
    {
      "x": 112.49,
      "y": 52.42,
      "r": -0.04966220000000002
    },
    {
      "x": 113.28,
      "y": 52.72,
      "r": -0.050251182000000005
    },
    {
      "x": 113.28,
      "y": 52.72,
      "r": -0.050251182000000005
    },
    {
      "x": 114.03,
      "y": 53.01,
      "r": -0.05080446200000004
    },
    {
      "x": 114.08,
      "y": 53.03,
      "r": -0.05083900800000003
    },
    {
      "x": 114.82,
      "y": 53.32,
      "r": -0.05139120000000002
    },
    {
      "x": 114.82,
      "y": 53.32,
      "r": -0.05139120000000002
    },
    {
      "x": 115.62,
      "y": 53.62,
      "r": -0.05197678199999998
    },
    {
      "x": 115.62,
      "y": 53.62,
      "r": -0.05197678199999998
    },
    {
      "x": 116.36,
      "y": 53.91,
      "r": -0.05252686199999999
    },
    {
      "x": 116.41,
      "y": 53.93,
      "r": -0.052561208
    },
    {
      "x": 117.15,
      "y": 54.21,
      "r": -0.053110199999999996
    },
    {
      "x": 117.15,
      "y": 54.21,
      "r": -0.053110199999999996
    },
    {
      "x": 117.95,
      "y": 54.52,
      "r": -0.05369238200000002
    },
    {
      "x": 117.95,
      "y": 54.52,
      "r": -0.05369238200000002
    },
    {
      "x": 118.69,
      "y": 54.8,
      "r": -0.054239262
    },
    {
      "x": 118.74,
      "y": 54.82,
      "r": -0.05427340800000002
    },
    {
      "x": 119.48,
      "y": 55.11,
      "r": -0.054819200000000005
    },
    {
      "x": 119.48,
      "y": 55.11,
      "r": -0.054819200000000005
    },
    {
      "x": 120.27,
      "y": 55.41,
      "r": -0.05539798199999999
    },
    {
      "x": 120.32,
      "y": 55.43,
      "r": -0.05543199199999998
    },
    {
      "x": 121.02,
      "y": 55.7,
      "r": -0.055941661999999996
    },
    {
      "x": 121.06,
      "y": 55.72,
      "r": -0.05597560799999999
    },
    {
      "x": 121.8,
      "y": 56,
      "r": -0.05651820000000001
    },
    {
      "x": 121.8,
      "y": 56,
      "r": -0.05651820000000001
    },
    {
      "x": 122.59,
      "y": 56.31,
      "r": -0.05709358200000001
    },
    {
      "x": 122.59,
      "y": 56.31,
      "r": -0.05709358200000001
    },
    {
      "x": 123.34,
      "y": 56.59,
      "r": -0.057634062000000014
    },
    {
      "x": 123.38,
      "y": 56.61,
      "r": -0.057667808
    },
    {
      "x": 124.12,
      "y": 56.89,
      "r": -0.05820719999999997
    },
    {
      "x": 124.12,
      "y": 56.89,
      "r": -0.05820719999999997
    },
    {
      "x": 124.91,
      "y": 57.2,
      "r": -0.058779181999999985
    },
    {
      "x": 124.96,
      "y": 57.21,
      "r": -0.05881279199999998
    },
    {
      "x": 125.65,
      "y": 57.48,
      "r": -0.05931646200000001
    },
    {
      "x": 125.7,
      "y": 57.5,
      "r": -0.05935000799999999
    },
    {
      "x": 126.48,
      "y": 57.8,
      "r": -0.059919678000000004
    },
    {
      "x": 126.48,
      "y": 57.8,
      "r": -0.059919678000000004
    },
    {
      "x": 127.23,
      "y": 58.09,
      "r": -0.06045478200000003
    },
    {
      "x": 127.23,
      "y": 58.09,
      "r": -0.06045478200000003
    },
    {
      "x": 128.01,
      "y": 58.39,
      "r": -0.061022208
    },
    {
      "x": 128.01,
      "y": 58.39,
      "r": -0.061022208
    },
    {
      "x": 128.75,
      "y": 58.67,
      "r": -0.06155519999999997
    },
    {
      "x": 128.8,
      "y": 58.69,
      "r": -0.06158847799999998
    },
    {
      "x": 129.54,
      "y": 58.98,
      "r": -0.06212038199999999
    },
    {
      "x": 129.58,
      "y": 58.99,
      "r": -0.062153591999999994
    },
    {
      "x": 130.32,
      "y": 59.28,
      "r": -0.062684408
    },
    {
      "x": 130.32,
      "y": 59.28,
      "r": -0.062684408
    },
    {
      "x": 131.06,
      "y": 59.56,
      "r": -0.06321420000000003
    },
    {
      "x": 131.1,
      "y": 59.58,
      "r": -0.063247278
    },
    {
      "x": 131.84,
      "y": 59.86,
      "r": -0.06377598200000004
    },
    {
      "x": 131.84,
      "y": 59.86,
      "r": -0.06377598200000004
    },
    {
      "x": 132.62,
      "y": 60.16,
      "r": -0.064336608
    },
    {
      "x": 132.62,
      "y": 60.16,
      "r": -0.064336608
    },
    {
      "x": 133.36,
      "y": 60.45,
      "r": -0.0648632
    },
    {
      "x": 133.41,
      "y": 60.46,
      "r": -0.06489607799999997
    },
    {
      "x": 134.14,
      "y": 60.75,
      "r": -0.06542158199999999
    },
    {
      "x": 134.19,
      "y": 60.77,
      "r": -0.06545439199999999
    },
    {
      "x": 134.93,
      "y": 61.05,
      "r": -0.065978808
    },
    {
      "x": 134.93,
      "y": 61.05,
      "r": -0.065978808
    },
    {
      "x": 135.66,
      "y": 61.33,
      "r": -0.06650220000000003
    },
    {
      "x": 135.71,
      "y": 61.35,
      "r": -0.06653487800000002
    },
    {
      "x": 136.44,
      "y": 61.63,
      "r": -0.06705718200000003
    },
    {
      "x": 136.44,
      "y": 61.63,
      "r": -0.06705718200000003
    },
    {
      "x": 137.22,
      "y": 61.93,
      "r": -0.067611008
    },
    {
      "x": 137.22,
      "y": 61.93,
      "r": -0.067611008
    },
    {
      "x": 137.96,
      "y": 62.21,
      "r": -0.06813119999999999
    },
    {
      "x": 138,
      "y": 62.23,
      "r": -0.06816367799999999
    },
    {
      "x": 138.74,
      "y": 62.51,
      "r": -0.068682782
    },
    {
      "x": 138.78,
      "y": 62.53,
      "r": -0.06871519199999998
    },
    {
      "x": 139.52,
      "y": 62.81,
      "r": -0.06923320800000002
    },
    {
      "x": 139.52,
      "y": 62.81,
      "r": -0.06923320800000002
    },
    {
      "x": 140.25,
      "y": 63.1,
      "r": -0.06975020000000003
    },
    {
      "x": 140.3,
      "y": 63.11,
      "r": -0.06978247800000002
    },
    {
      "x": 141.03,
      "y": 63.4,
      "r": -0.070298382
    },
    {
      "x": 141.03,
      "y": 63.4,
      "r": -0.070298382
    },
    {
      "x": 141.81,
      "y": 63.69,
      "r": -0.07084540800000001
    },
    {
      "x": 141.81,
      "y": 63.69,
      "r": -0.07084540800000001
    },
    {
      "x": 142.54,
      "y": 63.98,
      "r": -0.07135919999999998
    },
    {
      "x": 142.58,
      "y": 63.99,
      "r": -0.07139127799999999
    },
    {
      "x": 143.32,
      "y": 64.28,
      "r": -0.07190398199999999
    },
    {
      "x": 143.36,
      "y": 64.29,
      "r": -0.07193599199999999
    },
    {
      "x": 144.09,
      "y": 64.57,
      "r": -0.07244760800000001
    },
    {
      "x": 144.09,
      "y": 64.57,
      "r": -0.07244760800000001
    },
    {
      "x": 144.87,
      "y": 64.87,
      "r": -0.072990078
    },
    {
      "x": 144.87,
      "y": 64.87,
      "r": -0.072990078
    },
    {
      "x": 145.6,
      "y": 65.15,
      "r": -0.073499582
    },
    {
      "x": 145.6,
      "y": 65.15,
      "r": -0.073499582
    },
    {
      "x": 146.38,
      "y": 65.45,
      "r": -0.07403980800000001
    },
    {
      "x": 146.38,
      "y": 65.45,
      "r": -0.07403980800000001
    },
    {
      "x": 147.15,
      "y": 65.75,
      "r": -0.07457887800000003
    },
    {
      "x": 147.15,
      "y": 65.75,
      "r": -0.07457887800000003
    },
    {
      "x": 147.88,
      "y": 66.03,
      "r": -0.07508518200000001
    },
    {
      "x": 147.92,
      "y": 66.05,
      "r": -0.07511679199999999
    },
    {
      "x": 148.65,
      "y": 66.33,
      "r": -0.07562200800000002
    },
    {
      "x": 148.7,
      "y": 66.35,
      "r": -0.07565355000000001
    },
    {
      "x": 149.43,
      "y": 66.63,
      "r": -0.07615767800000002
    },
    {
      "x": 149.43,
      "y": 66.63,
      "r": -0.07615767800000002
    },
    {
      "x": 150.16,
      "y": 66.91,
      "r": -0.076660782
    },
    {
      "x": 150.2,
      "y": 66.92,
      "r": -0.07669219199999999
    },
    {
      "x": 150.93,
      "y": 67.2,
      "r": -0.07719420799999999
    },
    {
      "x": 150.93,
      "y": 67.2,
      "r": -0.07719420799999999
    },
    {
      "x": 151.7,
      "y": 67.5,
      "r": -0.07772647799999999
    },
    {
      "x": 151.7,
      "y": 67.5,
      "r": -0.07772647799999999
    },
    {
      "x": 152.43,
      "y": 67.78,
      "r": -0.07822638200000001
    },
    {
      "x": 152.47,
      "y": 67.8,
      "r": -0.078257592
    },
    {
      "x": 153.2,
      "y": 68.08,
      "r": -0.07875640800000001
    },
    {
      "x": 153.2,
      "y": 68.08,
      "r": -0.07875640800000001
    },
    {
      "x": 153.97,
      "y": 68.37,
      "r": -0.07928527799999999
    },
    {
      "x": 153.97,
      "y": 68.37,
      "r": -0.07928527799999999
    },
    {
      "x": 154.7,
      "y": 68.65,
      "r": -0.079781982
    },
    {
      "x": 154.74,
      "y": 68.67,
      "r": -0.07981299200000001
    },
    {
      "x": 155.47,
      "y": 68.95,
      "r": -0.08030860800000002
    },
    {
      "x": 155.47,
      "y": 68.95,
      "r": -0.08030860800000002
    },
    {
      "x": 156.24,
      "y": 69.24,
      "r": -0.08083407800000003
    },
    {
      "x": 156.24,
      "y": 69.24,
      "r": -0.08083407800000003
    },
    {
      "x": 156.96,
      "y": 69.52,
      "r": -0.08132758200000001
    },
    {
      "x": 157.01,
      "y": 69.54,
      "r": -0.081358392
    },
    {
      "x": 157.73,
      "y": 69.82,
      "r": -0.08185080800000002
    },
    {
      "x": 157.73,
      "y": 69.82,
      "r": -0.08185080800000002
    },
    {
      "x": 158.5,
      "y": 70.11,
      "r": -0.08237287800000002
    },
    {
      "x": 158.5,
      "y": 70.11,
      "r": -0.08237287800000002
    },
    {
      "x": 159.22,
      "y": 70.39,
      "r": -0.08286318200000001
    },
    {
      "x": 159.27,
      "y": 70.41,
      "r": -0.08289379200000001
    },
    {
      "x": 159.99,
      "y": 70.69,
      "r": -0.08338300799999998
    },
    {
      "x": 159.99,
      "y": 70.69,
      "r": -0.08338300799999998
    },
    {
      "x": 160.76,
      "y": 70.98,
      "r": -0.083901678
    },
    {
      "x": 160.76,
      "y": 70.98,
      "r": -0.083901678
    },
    {
      "x": 161.48,
      "y": 71.26,
      "r": -0.08438878200000002
    },
    {
      "x": 161.52,
      "y": 71.28,
      "r": -0.08441919200000002
    },
    {
      "x": 162.24,
      "y": 71.56,
      "r": -0.08490520800000001
    },
    {
      "x": 162.29,
      "y": 71.57,
      "r": -0.08493555000000003
    },
    {
      "x": 163.01,
      "y": 71.85,
      "r": -0.085420478
    },
    {
      "x": 163.01,
      "y": 71.85,
      "r": -0.085420478
    },
    {
      "x": 163.78,
      "y": 72.14,
      "r": -0.085934592
    },
    {
      "x": 163.78,
      "y": 72.14,
      "r": -0.085934592
    },
    {
      "x": 164.5,
      "y": 72.42,
      "r": -0.08641740800000003
    },
    {
      "x": 164.54,
      "y": 72.44,
      "r": -0.08644754999999998
    },
    {
      "x": 165.26,
      "y": 72.72,
      "r": -0.086929278
    },
    {
      "x": 165.26,
      "y": 72.72,
      "r": -0.086929278
    },
    {
      "x": 166.02,
      "y": 73.01,
      "r": -0.08743999200000002
    },
    {
      "x": 166.02,
      "y": 73.01,
      "r": -0.08743999200000002
    },
    {
      "x": 166.74,
      "y": 73.29,
      "r": -0.08791960800000004
    },
    {
      "x": 166.79,
      "y": 73.3,
      "r": -0.08794955000000003
    },
    {
      "x": 167.51,
      "y": 73.58,
      "r": -0.08842807800000003
    },
    {
      "x": 167.51,
      "y": 73.58,
      "r": -0.08842807800000003
    },
    {
      "x": 168.27,
      "y": 73.87,
      "r": -0.088935392
    },
    {
      "x": 168.27,
      "y": 73.87,
      "r": -0.088935392
    },
    {
      "x": 168.99,
      "y": 74.15,
      "r": -0.089411808
    },
    {
      "x": 169.03,
      "y": 74.17,
      "r": -0.08944155000000004
    },
    {
      "x": 169.75,
      "y": 74.44,
      "r": -0.08991687799999999
    },
    {
      "x": 169.75,
      "y": 74.44,
      "r": -0.08991687799999999
    },
    {
      "x": 170.51,
      "y": 74.74,
      "r": -0.09042079200000003
    },
    {
      "x": 170.51,
      "y": 74.74,
      "r": -0.09042079200000003
    },
    {
      "x": 171.23,
      "y": 75.01,
      "r": -0.09089400799999998
    },
    {
      "x": 171.27,
      "y": 75.03,
      "r": -0.09092355000000002
    },
    {
      "x": 171.99,
      "y": 75.3,
      "r": -0.091395678
    },
    {
      "x": 171.99,
      "y": 75.3,
      "r": -0.091395678
    },
    {
      "x": 172.75,
      "y": 75.6,
      "r": -0.09189619200000002
    },
    {
      "x": 172.75,
      "y": 75.6,
      "r": -0.09189619200000002
    },
    {
      "x": 173.46,
      "y": 75.87,
      "r": -0.09236620800000002
    },
    {
      "x": 173.51,
      "y": 75.89,
      "r": -0.09239554999999999
    },
    {
      "x": 174.22,
      "y": 76.16,
      "r": -0.092864478
    },
    {
      "x": 174.22,
      "y": 76.16,
      "r": -0.092864478
    },
    {
      "x": 174.98,
      "y": 76.45,
      "r": -0.09336159200000001
    },
    {
      "x": 175.21,
      "y": 76.54,
      "r": -0.093507582
    },
    {
      "x": 175.7,
      "y": 76.73,
      "r": -0.09382840800000003
    },
    {
      "x": 175.74,
      "y": 76.75,
      "r": -0.09385754999999998
    },
    {
      "x": 176.46,
      "y": 77.02,
      "r": -0.09432327800000001
    },
    {
      "x": 176.46,
      "y": 77.02,
      "r": -0.09432327800000001
    },
    {
      "x": 177.21,
      "y": 77.31,
      "r": -0.09481699200000003
    },
    {
      "x": 177.21,
      "y": 77.31,
      "r": -0.09481699200000003
    },
    {
      "x": 177.93,
      "y": 77.59,
      "r": -0.095280608
    },
    {
      "x": 177.97,
      "y": 77.6,
      "r": -0.09530955000000003
    },
    {
      "x": 178.68,
      "y": 77.88,
      "r": -0.09577207800000001
    },
    {
      "x": 178.73,
      "y": 77.9,
      "r": -0.09580095200000001
    },
    {
      "x": 179.44,
      "y": 78.17,
      "r": -0.09626239200000003
    },
    {
      "x": 179.48,
      "y": 78.19,
      "r": -0.09629119800000002
    },
    {
      "x": 180.2,
      "y": 78.46,
      "r": -0.09675155000000002
    },
    {
      "x": 180.2,
      "y": 78.46,
      "r": -0.09675155000000002
    },
    {
      "x": 180.91,
      "y": 78.73,
      "r": -0.09721087800000001
    },
    {
      "x": 180.95,
      "y": 78.75,
      "r": -0.097239552
    },
    {
      "x": 181.66,
      "y": 79.02,
      "r": -0.097697792
    },
    {
      "x": 181.66,
      "y": 79.02,
      "r": -0.097697792
    },
    {
      "x": 182.42,
      "y": 79.31,
      "r": -0.09818355
    },
    {
      "x": 182.42,
      "y": 79.31,
      "r": -0.09818355
    },
    {
      "x": 183.13,
      "y": 79.59,
      "r": -0.09863967800000001
    },
    {
      "x": 183.17,
      "y": 79.6,
      "r": -0.09866815200000001
    },
    {
      "x": 183.88,
      "y": 79.88,
      "r": -0.09912319200000003
    },
    {
      "x": 183.92,
      "y": 79.89,
      "r": -0.09915159800000002
    },
    {
      "x": 184.63,
      "y": 80.17,
      "r": -0.09960555
    },
    {
      "x": 184.63,
      "y": 80.17,
      "r": -0.09960555
    },
    {
      "x": 185.34,
      "y": 80.44,
      "r": -0.100058478
    },
    {
      "x": 185.39,
      "y": 80.46,
      "r": -0.100086752
    },
    {
      "x": 186.1,
      "y": 80.73,
      "r": -0.10053859200000002
    },
    {
      "x": 186.1,
      "y": 80.73,
      "r": -0.10053859200000002
    },
    {
      "x": 186.85,
      "y": 81.02,
      "r": -0.10101755
    },
    {
      "x": 186.85,
      "y": 81.02,
      "r": -0.10101755
    },
    {
      "x": 187.55,
      "y": 81.29,
      "r": -0.10146727800000002
    },
    {
      "x": 187.6,
      "y": 81.31,
      "r": -0.10149535200000002
    },
    {
      "x": 188.31,
      "y": 81.58,
      "r": -0.10194399200000002
    },
    {
      "x": 188.35,
      "y": 81.6,
      "r": -0.10197199800000001
    },
    {
      "x": 189.06,
      "y": 81.87,
      "r": -0.10241955000000003
    },
    {
      "x": 189.06,
      "y": 81.87,
      "r": -0.10241955000000003
    },
    {
      "x": 189.76,
      "y": 82.14,
      "r": -0.10286607800000001
    },
    {
      "x": 189.81,
      "y": 82.16,
      "r": -0.10289395200000002
    },
    {
      "x": 190.51,
      "y": 82.43,
      "r": -0.103339392
    },
    {
      "x": 190.51,
      "y": 82.43,
      "r": -0.103339392
    },
    {
      "x": 191.26,
      "y": 82.72,
      "r": -0.10381155
    },
    {
      "x": 191.26,
      "y": 82.72,
      "r": -0.10381155
    },
    {
      "x": 191.97,
      "y": 82.99,
      "r": -0.10425487800000002
    },
    {
      "x": 192.01,
      "y": 83,
      "r": -0.10428255200000001
    },
    {
      "x": 192.72,
      "y": 83.28,
      "r": -0.10472479199999998
    },
    {
      "x": 192.76,
      "y": 83.29,
      "r": -0.10475239800000002
    },
    {
      "x": 193.47,
      "y": 83.56,
      "r": -0.10519355
    },
    {
      "x": 193.47,
      "y": 83.56,
      "r": -0.10519355
    },
    {
      "x": 194.17,
      "y": 83.83,
      "r": -0.10563367800000001
    },
    {
      "x": 194.21,
      "y": 83.85,
      "r": -0.10566115200000002
    },
    {
      "x": 194.92,
      "y": 84.12,
      "r": -0.10610019200000004
    },
    {
      "x": 194.92,
      "y": 84.12,
      "r": -0.10610019200000004
    },
    {
      "x": 195.66,
      "y": 84.41,
      "r": -0.10656555000000001
    },
    {
      "x": 195.66,
      "y": 84.41,
      "r": -0.10656555000000001
    },
    {
      "x": 196.37,
      "y": 84.68,
      "r": -0.10700247800000003
    },
    {
      "x": 196.41,
      "y": 84.7,
      "r": -0.107029752
    },
    {
      "x": 197.11,
      "y": 84.97,
      "r": -0.10746559200000001
    },
    {
      "x": 197.16,
      "y": 84.98,
      "r": -0.107492798
    },
    {
      "x": 197.86,
      "y": 85.25,
      "r": -0.10792755000000001
    },
    {
      "x": 197.86,
      "y": 85.25,
      "r": -0.10792755000000001
    },
    {
      "x": 198.56,
      "y": 85.52,
      "r": -0.10836127799999998
    },
    {
      "x": 198.6,
      "y": 85.54,
      "r": -0.10838835200000002
    },
    {
      "x": 199.3,
      "y": 85.81,
      "r": -0.108820992
    },
    {
      "x": 199.35,
      "y": 85.83,
      "r": -0.10884799800000003
    },
    {
      "x": 200.05,
      "y": 86.1,
      "r": -0.10927955
    },
    {
      "x": 200.05,
      "y": 86.1,
      "r": -0.10927955
    },
    {
      "x": 200.79,
      "y": 86.38,
      "r": -0.109736952
    },
    {
      "x": 200.79,
      "y": 86.38,
      "r": -0.109736952
    },
    {
      "x": 201.49,
      "y": 86.65,
      "r": -0.110166392
    },
    {
      "x": 201.54,
      "y": 86.67,
      "r": -0.11019319800000003
    },
    {
      "x": 202.24,
      "y": 86.94,
      "r": -0.11062155000000001
    },
    {
      "x": 202.24,
      "y": 86.94,
      "r": -0.11062155000000001
    },
    {
      "x": 202.98,
      "y": 87.22,
      "r": -0.111075552
    },
    {
      "x": 202.98,
      "y": 87.22,
      "r": -0.111075552
    },
    {
      "x": 203.68,
      "y": 87.49,
      "r": -0.11150179200000002
    },
    {
      "x": 203.72,
      "y": 87.51,
      "r": -0.11152839800000001
    },
    {
      "x": 204.42,
      "y": 87.78,
      "r": -0.11195355000000001
    },
    {
      "x": 204.42,
      "y": 87.78,
      "r": -0.11195355000000001
    },
    {
      "x": 205.16,
      "y": 88.06,
      "r": -0.11240415200000001
    },
    {
      "x": 205.16,
      "y": 88.06,
      "r": -0.11240415200000001
    },
    {
      "x": 205.86,
      "y": 88.33,
      "r": -0.11282719200000005
    },
    {
      "x": 205.9,
      "y": 88.35,
      "r": -0.11285359800000001
    },
    {
      "x": 206.6,
      "y": 88.61,
      "r": -0.11327555
    },
    {
      "x": 206.6,
      "y": 88.61,
      "r": -0.11327555
    },
    {
      "x": 207.34,
      "y": 88.9,
      "r": -0.11372275200000002
    },
    {
      "x": 207.34,
      "y": 88.9,
      "r": -0.11372275200000002
    },
    {
      "x": 208.03,
      "y": 89.17,
      "r": -0.11414259200000001
    },
    {
      "x": 208.08,
      "y": 89.18,
      "r": -0.114168798
    },
    {
      "x": 208.77,
      "y": 89.45,
      "r": -0.11458755000000001
    },
    {
      "x": 208.77,
      "y": 89.45,
      "r": -0.11458755000000001
    },
    {
      "x": 209.51,
      "y": 89.74,
      "r": -0.11503135200000002
    },
    {
      "x": 209.51,
      "y": 89.74,
      "r": -0.11503135200000002
    },
    {
      "x": 210.25,
      "y": 90.02,
      "r": -0.11547399800000002
    },
    {
      "x": 210.29,
      "y": 90.04,
      "r": -0.11549999999999999
    },
    {
      "x": 210.95,
      "y": 90.29,
      "r": -0.11588955000000001
    },
    {
      "x": 210.99,
      "y": 90.3,
      "r": -0.11591548800000001
    },
    {
      "x": 211.68,
      "y": 90.57,
      "r": -0.11632995199999999
    },
    {
      "x": 211.68,
      "y": 90.57,
      "r": -0.11632995199999999
    },
    {
      "x": 212.38,
      "y": 90.84,
      "r": -0.11674339200000002
    },
    {
      "x": 212.42,
      "y": 90.85,
      "r": -0.11676919799999999
    },
    {
      "x": 213.11,
      "y": 91.12,
      "r": -0.11718155000000002
    },
    {
      "x": 213.11,
      "y": 91.12,
      "r": -0.11718155000000002
    },
    {
      "x": 213.85,
      "y": 91.4,
      "r": -0.11761855199999999
    },
    {
      "x": 213.85,
      "y": 91.4,
      "r": -0.11761855199999999
    },
    {
      "x": 214.54,
      "y": 91.67,
      "r": -0.11802879200000001
    },
    {
      "x": 214.58,
      "y": 91.69,
      "r": -0.118054398
    },
    {
      "x": 215.28,
      "y": 91.95,
      "r": -0.11846355000000003
    },
    {
      "x": 215.28,
      "y": 91.95,
      "r": -0.11846355000000003
    },
    {
      "x": 216.01,
      "y": 92.24,
      "r": -0.11889715200000002
    },
    {
      "x": 216.01,
      "y": 92.24,
      "r": -0.11889715200000002
    },
    {
      "x": 216.7,
      "y": 92.5,
      "r": -0.119304192
    },
    {
      "x": 216.75,
      "y": 92.52,
      "r": -0.11932959800000001
    },
    {
      "x": 217.44,
      "y": 92.78,
      "r": -0.11973555000000001
    },
    {
      "x": 217.44,
      "y": 92.78,
      "r": -0.11973555000000001
    },
    {
      "x": 218.21,
      "y": 93.08,
      "r": -0.12019102199999998
    },
    {
      "x": 218.26,
      "y": 93.1,
      "r": -0.12021628800000002
    },
    {
      "x": 218.9,
      "y": 93.35,
      "r": -0.120594798
    },
    {
      "x": 218.9,
      "y": 93.35,
      "r": -0.120594798
    },
    {
      "x": 219.59,
      "y": 93.61,
      "r": -0.12099755
    },
    {
      "x": 219.64,
      "y": 93.63,
      "r": -0.121022688
    },
    {
      "x": 220.33,
      "y": 93.89,
      "r": -0.121424352
    },
    {
      "x": 220.33,
      "y": 93.89,
      "r": -0.121424352
    },
    {
      "x": 221.06,
      "y": 94.18,
      "r": -0.12184999800000001
    },
    {
      "x": 221.06,
      "y": 94.18,
      "r": -0.12184999800000001
    },
    {
      "x": 221.75,
      "y": 94.44,
      "r": -0.12224955000000003
    },
    {
      "x": 221.79,
      "y": 94.46,
      "r": -0.12227448800000001
    },
    {
      "x": 222.48,
      "y": 94.72,
      "r": -0.122672952
    },
    {
      "x": 222.52,
      "y": 94.74,
      "r": -0.12269782200000004
    },
    {
      "x": 223.21,
      "y": 95,
      "r": -0.123095198
    },
    {
      "x": 223.21,
      "y": 95,
      "r": -0.123095198
    },
    {
      "x": 223.9,
      "y": 95.27,
      "r": -0.12349155
    },
    {
      "x": 223.94,
      "y": 95.28,
      "r": -0.12351628799999999
    },
    {
      "x": 224.62,
      "y": 95.55,
      "r": -0.123911552
    },
    {
      "x": 224.67,
      "y": 95.56,
      "r": -0.12393622199999998
    },
    {
      "x": 225.35,
      "y": 95.83,
      "r": -0.12433039800000001
    },
    {
      "x": 225.35,
      "y": 95.83,
      "r": -0.12433039800000001
    },
    {
      "x": 226.04,
      "y": 96.09,
      "r": -0.12472355000000002
    },
    {
      "x": 226.08,
      "y": 96.11,
      "r": -0.12474808800000002
    },
    {
      "x": 226.77,
      "y": 96.37,
      "r": -0.12514015200000003
    },
    {
      "x": 226.81,
      "y": 96.39,
      "r": -0.125164622
    },
    {
      "x": 227.5,
      "y": 96.65,
      "r": -0.12555559800000002
    },
    {
      "x": 227.5,
      "y": 96.65,
      "r": -0.12555559800000002
    },
    {
      "x": 228.18,
      "y": 96.92,
      "r": -0.12594555000000002
    },
    {
      "x": 228.22,
      "y": 96.93,
      "r": -0.12596988800000003
    },
    {
      "x": 228.91,
      "y": 97.2,
      "r": -0.126358752
    },
    {
      "x": 228.91,
      "y": 97.2,
      "r": -0.126358752
    },
    {
      "x": 229.64,
      "y": 97.48,
      "r": -0.126770798
    },
    {
      "x": 229.64,
      "y": 97.48,
      "r": -0.126770798
    },
    {
      "x": 230.32,
      "y": 97.74,
      "r": -0.12715755
    },
    {
      "x": 230.36,
      "y": 97.75,
      "r": -0.12718168800000004
    },
    {
      "x": 231.09,
      "y": 98.03,
      "r": -0.12759142200000004
    },
    {
      "x": 231.13,
      "y": 98.05,
      "r": -0.127615488
    },
    {
      "x": 231.77,
      "y": 98.3,
      "r": -0.127975998
    },
    {
      "x": 231.77,
      "y": 98.3,
      "r": -0.127975998
    },
    {
      "x": 232.49,
      "y": 98.57,
      "r": -0.128383488
    },
    {
      "x": 232.54,
      "y": 98.59,
      "r": -0.12840742200000002
    },
    {
      "x": 233.18,
      "y": 98.84,
      "r": -0.12876595200000002
    },
    {
      "x": 233.22,
      "y": 98.85,
      "r": -0.128789822
    },
    {
      "x": 233.94,
      "y": 99.13,
      "r": -0.129195
    },
    {
      "x": 233.94,
      "y": 99.13,
      "r": -0.129195
    },
    {
      "x": 234.62,
      "y": 99.39,
      "r": -0.12957528799999998
    },
    {
      "x": 234.62,
      "y": 99.39,
      "r": -0.12957528799999998
    },
    {
      "x": 235.31,
      "y": 99.66,
      "r": -0.12995455200000003
    },
    {
      "x": 235.35,
      "y": 99.67,
      "r": -0.129978222
    },
    {
      "x": 236.03,
      "y": 99.93,
      "r": -0.130356398
    },
    {
      "x": 236.03,
      "y": 99.93,
      "r": -0.130356398
    },
    {
      "x": 236.75,
      "y": 100.21,
      "r": -0.13075708800000002
    },
    {
      "x": 236.75,
      "y": 100.21,
      "r": -0.13075708800000002
    },
    {
      "x": 237.47,
      "y": 100.49,
      "r": -0.131156622
    },
    {
      "x": 237.47,
      "y": 100.49,
      "r": -0.131156622
    },
    {
      "x": 238.15,
      "y": 100.75,
      "r": -0.13153159800000003
    },
    {
      "x": 238.19,
      "y": 100.77,
      "r": -0.131555
    },
    {
      "x": 238.87,
      "y": 101.03,
      "r": -0.13192888800000002
    },
    {
      "x": 238.87,
      "y": 101.03,
      "r": -0.13192888800000002
    },
    {
      "x": 239.55,
      "y": 101.29,
      "r": -0.13230175200000002
    },
    {
      "x": 239.59,
      "y": 101.31,
      "r": -0.13232502200000001
    },
    {
      "x": 240.27,
      "y": 101.57,
      "r": -0.13269679799999998
    },
    {
      "x": 240.31,
      "y": 101.58,
      "r": -0.13272
    },
    {
      "x": 240.99,
      "y": 101.84,
      "r": -0.13309068799999998
    },
    {
      "x": 240.99,
      "y": 101.84,
      "r": -0.13309068799999998
    },
    {
      "x": 241.67,
      "y": 102.1,
      "r": -0.133460352
    },
    {
      "x": 241.71,
      "y": 102.12,
      "r": -0.13348342200000002
    },
    {
      "x": 242.39,
      "y": 102.38,
      "r": -0.133851998
    },
    {
      "x": 242.39,
      "y": 102.38,
      "r": -0.133851998
    },
    {
      "x": 243.11,
      "y": 102.66,
      "r": -0.134242488
    },
    {
      "x": 243.11,
      "y": 102.66,
      "r": -0.134242488
    },
    {
      "x": 244.03,
      "y": 103.01,
      "r": -0.13474611200000003
    },
    {
      "x": 244.08,
      "y": 103.03,
      "r": -0.13476895800000002
    },
    {
      "x": 244.5,
      "y": 103.19,
      "r": -0.13499719800000004
    },
    {
      "x": 244.54,
      "y": 103.21,
      "r": -0.13502
    },
    {
      "x": 245.22,
      "y": 103.47,
      "r": -0.135384288
    },
    {
      "x": 245.22,
      "y": 103.47,
      "r": -0.135384288
    },
    {
      "x": 245.93,
      "y": 103.74,
      "r": -0.13577022200000002
    },
    {
      "x": 245.93,
      "y": 103.74,
      "r": -0.13577022200000002
    },
    {
      "x": 246.61,
      "y": 104,
      "r": -0.13613239800000002
    },
    {
      "x": 246.65,
      "y": 104.02,
      "r": -0.13615500000000003
    },
    {
      "x": 247.32,
      "y": 104.28,
      "r": -0.13651608800000004
    },
    {
      "x": 247.32,
      "y": 104.28,
      "r": -0.13651608800000004
    },
    {
      "x": 248.04,
      "y": 104.55,
      "r": -0.136898622
    },
    {
      "x": 248.08,
      "y": 104.57,
      "r": -0.136921088
    },
    {
      "x": 248.75,
      "y": 104.83,
      "r": -0.13728000000000004
    },
    {
      "x": 248.75,
      "y": 104.83,
      "r": -0.13728000000000004
    },
    {
      "x": 249.43,
      "y": 105.09,
      "r": -0.13763788799999999
    },
    {
      "x": 249.47,
      "y": 105.1,
      "r": -0.13766022200000003
    },
    {
      "x": 250.14,
      "y": 105.36,
      "r": -0.13801702200000002
    },
    {
      "x": 250.14,
      "y": 105.36,
      "r": -0.13801702200000002
    },
    {
      "x": 250.81,
      "y": 105.62,
      "r": -0.138372798
    },
    {
      "x": 250.85,
      "y": 105.64,
      "r": -0.13839500000000002
    },
    {
      "x": 251.52,
      "y": 105.89,
      "r": -0.138749688
    },
    {
      "x": 251.52,
      "y": 105.89,
      "r": -0.138749688
    },
    {
      "x": 252.24,
      "y": 106.17,
      "r": -0.139125422
    },
    {
      "x": 252.24,
      "y": 106.17,
      "r": -0.139125422
    },
    {
      "x": 252.91,
      "y": 106.43,
      "r": -0.13947799800000002
    },
    {
      "x": 252.95,
      "y": 106.44,
      "r": -0.1395
    },
    {
      "x": 253.62,
      "y": 106.7,
      "r": -0.139851488
    },
    {
      "x": 253.62,
      "y": 106.7,
      "r": -0.139851488
    },
    {
      "x": 254.33,
      "y": 106.97,
      "r": -0.14022382200000003
    },
    {
      "x": 254.33,
      "y": 106.97,
      "r": -0.14022382200000003
    },
    {
      "x": 255,
      "y": 107.23,
      "r": -0.140573198
    },
    {
      "x": 255.04,
      "y": 107.25,
      "r": -0.140595
    },
    {
      "x": 255.71,
      "y": 107.5,
      "r": -0.140943288
    },
    {
      "x": 255.71,
      "y": 107.5,
      "r": -0.140943288
    },
    {
      "x": 256.42,
      "y": 107.78,
      "r": -0.14131222200000002
    },
    {
      "x": 256.46,
      "y": 107.79,
      "r": -0.141333888
    },
    {
      "x": 257.09,
      "y": 108.03,
      "r": -0.141658398
    },
    {
      "x": 257.13,
      "y": 108.05,
      "r": -0.14168000000000003
    },
    {
      "x": 257.8,
      "y": 108.31,
      "r": -0.142025088
    },
    {
      "x": 257.8,
      "y": 108.31,
      "r": -0.142025088
    },
    {
      "x": 258.51,
      "y": 108.58,
      "r": -0.14239062200000002
    },
    {
      "x": 258.51,
      "y": 108.58,
      "r": -0.14239062200000002
    },
    {
      "x": 259.18,
      "y": 108.84,
      "r": -0.14273359800000002
    },
    {
      "x": 259.22,
      "y": 108.85,
      "r": -0.14275500000000002
    },
    {
      "x": 259.88,
      "y": 109.11,
      "r": -0.143096888
    },
    {
      "x": 259.88,
      "y": 109.11,
      "r": -0.143096888
    },
    {
      "x": 260.59,
      "y": 109.38,
      "r": -0.14345902200000002
    },
    {
      "x": 260.59,
      "y": 109.38,
      "r": -0.14345902200000002
    },
    {
      "x": 261.3,
      "y": 109.65,
      "r": -0.14382
    },
    {
      "x": 261.3,
      "y": 109.65,
      "r": -0.14382
    },
    {
      "x": 261.96,
      "y": 109.91,
      "r": -0.144158688
    },
    {
      "x": 262.01,
      "y": 109.93,
      "r": -0.14417982199999999
    },
    {
      "x": 262.67,
      "y": 110.18,
      "r": -0.14451742200000003
    },
    {
      "x": 262.67,
      "y": 110.18,
      "r": -0.14451742200000003
    },
    {
      "x": 263.38,
      "y": 110.45,
      "r": -0.144875
    },
    {
      "x": 263.38,
      "y": 110.45,
      "r": -0.144875
    },
    {
      "x": 264.04,
      "y": 110.71,
      "r": -0.145210488
    },
    {
      "x": 264.08,
      "y": 110.72,
      "r": -0.145231422
    },
    {
      "x": 264.75,
      "y": 110.98,
      "r": -0.145565822
    },
    {
      "x": 264.79,
      "y": 110.99,
      "r": -0.145586688
    },
    {
      "x": 265.45,
      "y": 111.25,
      "r": -0.14592000000000002
    },
    {
      "x": 265.45,
      "y": 111.25,
      "r": -0.14592000000000002
    },
    {
      "x": 266.11,
      "y": 111.5,
      "r": -0.146252288
    },
    {
      "x": 266.15,
      "y": 111.52,
      "r": -0.146273022
    },
    {
      "x": 266.82,
      "y": 111.78,
      "r": -0.14660422200000003
    },
    {
      "x": 266.82,
      "y": 111.78,
      "r": -0.14660422200000003
    },
    {
      "x": 267.52,
      "y": 112.05,
      "r": -0.14695500000000003
    },
    {
      "x": 267.52,
      "y": 112.05,
      "r": -0.14695500000000003
    },
    {
      "x": 268.18,
      "y": 112.3,
      "r": -0.147284088
    },
    {
      "x": 268.22,
      "y": 112.32,
      "r": -0.14730462200000002
    },
    {
      "x": 268.93,
      "y": 112.59,
      "r": -0.14765308800000002
    },
    {
      "x": 268.93,
      "y": 112.59,
      "r": -0.14765308800000002
    },
    {
      "x": 269.59,
      "y": 112.84,
      "r": -0.14798
    },
    {
      "x": 269.59,
      "y": 112.84,
      "r": -0.14798
    },
    {
      "x": 270.25,
      "y": 113.09,
      "r": -0.14830588800000002
    },
    {
      "x": 270.29,
      "y": 113.11,
      "r": -0.148326222
    },
    {
      "x": 270.95,
      "y": 113.36,
      "r": -0.148651022
    },
    {
      "x": 270.95,
      "y": 113.36,
      "r": -0.148651022
    },
    {
      "x": 271.65,
      "y": 113.63,
      "r": -0.148995
    },
    {
      "x": 271.65,
      "y": 113.63,
      "r": -0.148995
    },
    {
      "x": 272.31,
      "y": 113.89,
      "r": -0.149317688
    },
    {
      "x": 272.35,
      "y": 113.9,
      "r": -0.149337822
    },
    {
      "x": 273.01,
      "y": 114.16,
      "r": -0.14965942200000001
    },
    {
      "x": 273.05,
      "y": 114.17,
      "r": -0.149679488
    },
    {
      "x": 273.71,
      "y": 114.43,
      "r": -0.15000000000000002
    },
    {
      "x": 273.75,
      "y": 114.44,
      "r": -0.15001999800000002
    },
    {
      "x": 274.41,
      "y": 114.69,
      "r": -0.15033942200000003
    },
    {
      "x": 274.41,
      "y": 114.69,
      "r": -0.15033942200000003
    },
    {
      "x": 275.06,
      "y": 114.95,
      "r": -0.15065782200000002
    },
    {
      "x": 275.06,
      "y": 114.95,
      "r": -0.15065782200000002
    },
    {
      "x": 275.76,
      "y": 115.22,
      "r": -0.150995
    },
    {
      "x": 275.76,
      "y": 115.22,
      "r": -0.150995
    },
    {
      "x": 276.46,
      "y": 115.48,
      "r": -0.15133102200000004
    },
    {
      "x": 276.46,
      "y": 115.48,
      "r": -0.15133102200000004
    },
    {
      "x": 277.12,
      "y": 115.74,
      "r": -0.151646222
    },
    {
      "x": 277.16,
      "y": 115.75,
      "r": -0.15166588800000003
    },
    {
      "x": 277.81,
      "y": 116,
      "r": -0.15198
    },
    {
      "x": 277.81,
      "y": 116,
      "r": -0.15198
    },
    {
      "x": 278.51,
      "y": 116.27,
      "r": -0.152312622
    },
    {
      "x": 278.55,
      "y": 116.29,
      "r": -0.15233215200000003
    },
    {
      "x": 279.16,
      "y": 116.52,
      "r": -0.15262462200000002
    },
    {
      "x": 279.21,
      "y": 116.54,
      "r": -0.15264408800000004
    },
    {
      "x": 279.86,
      "y": 116.79,
      "r": -0.152955
    },
    {
      "x": 279.86,
      "y": 116.79,
      "r": -0.152955
    },
    {
      "x": 280.51,
      "y": 117.04,
      "r": -0.15326488800000002
    },
    {
      "x": 280.55,
      "y": 117.06,
      "r": -0.153284222
    },
    {
      "x": 281.29,
      "y": 117.34,
      "r": -0.15363155000000003
    },
    {
      "x": 281.29,
      "y": 117.34,
      "r": -0.15363155000000003
    },
    {
      "x": 281.9,
      "y": 117.58,
      "r": -0.15392000000000003
    },
    {
      "x": 281.9,
      "y": 117.58,
      "r": -0.15392000000000003
    },
    {
      "x": 282.56,
      "y": 117.83,
      "r": -0.15422668800000003
    },
    {
      "x": 282.6,
      "y": 117.84,
      "r": -0.15424582200000003
    },
    {
      "x": 283.25,
      "y": 118.1,
      "r": -0.15455142200000005
    },
    {
      "x": 283.25,
      "y": 118.1,
      "r": -0.15455142200000005
    },
    {
      "x": 283.94,
      "y": 118.36,
      "r": -0.154875
    },
    {
      "x": 283.94,
      "y": 118.36,
      "r": -0.154875
    },
    {
      "x": 284.64,
      "y": 118.63,
      "r": -0.15519742200000003
    },
    {
      "x": 284.64,
      "y": 118.63,
      "r": -0.15519742200000003
    },
    {
      "x": 285.29,
      "y": 118.88,
      "r": -0.155499822
    },
    {
      "x": 285.33,
      "y": 118.9,
      "r": -0.15551868800000002
    },
    {
      "x": 285.98,
      "y": 119.15,
      "r": -0.15582000000000001
    },
    {
      "x": 285.98,
      "y": 119.15,
      "r": -0.15582000000000001
    },
    {
      "x": 286.67,
      "y": 119.41,
      "r": -0.15613902200000002
    },
    {
      "x": 286.67,
      "y": 119.41,
      "r": -0.15613902200000002
    },
    {
      "x": 287.32,
      "y": 119.66,
      "r": -0.15643822200000002
    },
    {
      "x": 287.36,
      "y": 119.68,
      "r": -0.15645688800000002
    },
    {
      "x": 288.01,
      "y": 119.93,
      "r": -0.156755
    },
    {
      "x": 288.01,
      "y": 119.93,
      "r": -0.156755
    },
    {
      "x": 288.7,
      "y": 120.19,
      "r": -0.157070622
    },
    {
      "x": 288.7,
      "y": 120.19,
      "r": -0.157070622
    },
    {
      "x": 289.35,
      "y": 120.44,
      "r": -0.157366622
    },
    {
      "x": 289.39,
      "y": 120.46,
      "r": -0.157385088
    },
    {
      "x": 290.04,
      "y": 120.71,
      "r": -0.15768000000000001
    },
    {
      "x": 290.04,
      "y": 120.71,
      "r": -0.15768000000000001
    },
    {
      "x": 290.73,
      "y": 120.97,
      "r": -0.157992222
    },
    {
      "x": 290.73,
      "y": 120.97,
      "r": -0.157992222
    },
    {
      "x": 291.37,
      "y": 121.22,
      "r": -0.15828502200000003
    },
    {
      "x": 291.42,
      "y": 121.24,
      "r": -0.15830328800000001
    },
    {
      "x": 292.06,
      "y": 121.49,
      "r": -0.158595
    },
    {
      "x": 292.1,
      "y": 121.5,
      "r": -0.158613198
    },
    {
      "x": 292.75,
      "y": 121.75,
      "r": -0.15890382200000003
    },
    {
      "x": 292.75,
      "y": 121.75,
      "r": -0.15890382200000003
    },
    {
      "x": 293.44,
      "y": 122.01,
      "r": -0.159211488
    },
    {
      "x": 293.48,
      "y": 122.03,
      "r": -0.15922955000000003
    },
    {
      "x": 294.08,
      "y": 122.26,
      "r": -0.15950000000000003
    },
    {
      "x": 294.08,
      "y": 122.26,
      "r": -0.15950000000000003
    },
    {
      "x": 294.77,
      "y": 122.53,
      "r": -0.15980542200000003
    },
    {
      "x": 294.77,
      "y": 122.53,
      "r": -0.15980542200000003
    },
    {
      "x": 295.41,
      "y": 122.77,
      "r": -0.16009182200000002
    },
    {
      "x": 295.45,
      "y": 122.79,
      "r": -0.16010968800000003
    },
    {
      "x": 296.1,
      "y": 123.04,
      "r": -0.16039499999999998
    },
    {
      "x": 296.1,
      "y": 123.04,
      "r": -0.16039499999999998
    },
    {
      "x": 296.78,
      "y": 123.3,
      "r": -0.16069702200000002
    },
    {
      "x": 296.78,
      "y": 123.3,
      "r": -0.16069702200000002
    },
    {
      "x": 297.43,
      "y": 123.55,
      "r": -0.160980222
    },
    {
      "x": 297.47,
      "y": 123.56,
      "r": -0.160997888
    },
    {
      "x": 298.11,
      "y": 123.81,
      "r": -0.16128
    },
    {
      "x": 298.11,
      "y": 123.81,
      "r": -0.16128
    },
    {
      "x": 298.8,
      "y": 124.08,
      "r": -0.161578622
    },
    {
      "x": 298.8,
      "y": 124.08,
      "r": -0.161578622
    },
    {
      "x": 299.48,
      "y": 124.34,
      "r": -0.161876088
    },
    {
      "x": 299.48,
      "y": 124.34,
      "r": -0.161876088
    },
    {
      "x": 300.12,
      "y": 124.59,
      "r": -0.16215500000000002
    },
    {
      "x": 300.12,
      "y": 124.59,
      "r": -0.16215500000000002
    },
    {
      "x": 300.8,
      "y": 124.85,
      "r": -0.162450222
    },
    {
      "x": 300.8,
      "y": 124.85,
      "r": -0.162450222
    },
    {
      "x": 301.49,
      "y": 125.11,
      "r": -0.16274428800000001
    },
    {
      "x": 301.49,
      "y": 125.11,
      "r": -0.16274428800000001
    },
    {
      "x": 302.17,
      "y": 125.37,
      "r": -0.16303719800000002
    },
    {
      "x": 302.17,
      "y": 125.37,
      "r": -0.16303719800000002
    },
    {
      "x": 302.81,
      "y": 125.62,
      "r": -0.16331182200000002
    },
    {
      "x": 302.81,
      "y": 125.62,
      "r": -0.16331182200000002
    },
    {
      "x": 303.49,
      "y": 125.88,
      "r": -0.163602488
    },
    {
      "x": 303.49,
      "y": 125.88,
      "r": -0.163602488
    },
    {
      "x": 304.13,
      "y": 126.13,
      "r": -0.163875
    },
    {
      "x": 304.17,
      "y": 126.14,
      "r": -0.163891998
    },
    {
      "x": 304.81,
      "y": 126.39,
      "r": -0.164163422
    },
    {
      "x": 304.81,
      "y": 126.39,
      "r": -0.164163422
    },
    {
      "x": 305.49,
      "y": 126.65,
      "r": -0.164450688
    },
    {
      "x": 305.53,
      "y": 126.66,
      "r": -0.16446755000000002
    },
    {
      "x": 306.17,
      "y": 126.91,
      "r": -0.16473679800000002
    },
    {
      "x": 306.17,
      "y": 126.91,
      "r": -0.16473679800000002
    },
    {
      "x": 306.8,
      "y": 127.16,
      "r": -0.165005022
    },
    {
      "x": 306.84,
      "y": 127.17,
      "r": -0.16502175200000002
    },
    {
      "x": 307.48,
      "y": 127.42,
      "r": -0.16528888800000002
    },
    {
      "x": 307.48,
      "y": 127.42,
      "r": -0.16528888800000002
    },
    {
      "x": 308.12,
      "y": 127.66,
      "r": -0.165555
    },
    {
      "x": 308.16,
      "y": 127.68,
      "r": -0.165571598
    },
    {
      "x": 308.8,
      "y": 127.92,
      "r": -0.16583662200000002
    },
    {
      "x": 308.84,
      "y": 127.94,
      "r": -0.165853152
    },
    {
      "x": 309.47,
      "y": 128.18,
      "r": -0.16611708800000002
    },
    {
      "x": 309.51,
      "y": 128.2,
      "r": -0.16613355000000002
    },
    {
      "x": 310.11,
      "y": 128.43,
      "r": -0.16638000000000003
    },
    {
      "x": 310.15,
      "y": 128.44,
      "r": -0.16639639800000003
    },
    {
      "x": 310.79,
      "y": 128.69,
      "r": -0.16665822200000002
    },
    {
      "x": 310.79,
      "y": 128.69,
      "r": -0.16665822200000002
    },
    {
      "x": 311.46,
      "y": 128.95,
      "r": -0.16693528800000001
    },
    {
      "x": 311.46,
      "y": 128.95,
      "r": -0.16693528800000001
    },
    {
      "x": 312.1,
      "y": 129.19,
      "r": -0.16719499999999998
    },
    {
      "x": 312.14,
      "y": 129.21,
      "r": -0.16721119800000003
    },
    {
      "x": 312.77,
      "y": 129.45,
      "r": -0.16746982200000002
    },
    {
      "x": 312.81,
      "y": 129.47,
      "r": -0.16748595200000002
    },
    {
      "x": 313.44,
      "y": 129.71,
      "r": -0.16774348800000002
    },
    {
      "x": 313.48,
      "y": 129.72,
      "r": -0.16775955
    },
    {
      "x": 314.32,
      "y": 130.04,
      "r": -0.16809592800000003
    },
    {
      "x": 314.36,
      "y": 130.06,
      "r": -0.16811190200000004
    },
    {
      "x": 316.06,
      "y": 130.71,
      "r": -0.168795
    },
    {
      "x": 316.1,
      "y": 130.73,
      "r": -0.16881079799999998
    },
    {
      "x": 316.18,
      "y": 130.76,
      "r": -0.168842382
    },
    {
      "x": 316.21,
      "y": 130.77,
      "r": -0.168858168
    },
    {
      "x": 316.73,
      "y": 130.97,
      "r": -0.169063022
    },
    {
      "x": 316.77,
      "y": 130.99,
      "r": -0.169078752
    },
    {
      "x": 317.44,
      "y": 131.25,
      "r": -0.16934555
    },
    {
      "x": 317.48,
      "y": 131.26,
      "r": -0.169361208
    },
    {
      "x": 318.07,
      "y": 131.49,
      "r": -0.16959559800000001
    },
    {
      "x": 318.07,
      "y": 131.49,
      "r": -0.16959559800000001
    },
    {
      "x": 321.14,
      "y": 132.67,
      "r": -0.17079991800000002
    },
    {
      "x": 321.18,
      "y": 132.69,
      "r": -0.17081520000000003
    },
    {
      "x": 321.26,
      "y": 132.72,
      "r": -0.17084575200000002
    },
    {
      "x": 321.26,
      "y": 132.72,
      "r": -0.17084575200000002
    },
    {
      "x": 321.42,
      "y": 132.78,
      "r": -0.17090680800000002
    },
    {
      "x": 321.46,
      "y": 132.79,
      "r": -0.170922062
    },
    {
      "x": 322.01,
      "y": 133,
      "r": -0.17113519800000002
    },
    {
      "x": 322.01,
      "y": 133,
      "r": -0.17113519800000002
    },
    {
      "x": 322.64,
      "y": 133.25,
      "r": -0.171377822
    },
    {
      "x": 322.68,
      "y": 133.26,
      "r": -0.17139295200000002
    },
    {
      "x": 323.31,
      "y": 133.5,
      "r": -0.171634488
    },
    {
      "x": 323.31,
      "y": 133.5,
      "r": -0.171634488
    },
    {
      "x": 323.97,
      "y": 133.76,
      "r": -0.17188999800000002
    },
    {
      "x": 323.97,
      "y": 133.76,
      "r": -0.17188999800000002
    },
    {
      "x": 324.6,
      "y": 134,
      "r": -0.17212942200000003
    },
    {
      "x": 324.64,
      "y": 134.01,
      "r": -0.172144352
    },
    {
      "x": 325.27,
      "y": 134.26,
      "r": -0.172382688
    },
    {
      "x": 325.3,
      "y": 134.27,
      "r": -0.17239755
    },
    {
      "x": 325.93,
      "y": 134.51,
      "r": -0.17263479800000003
    },
    {
      "x": 325.93,
      "y": 134.51,
      "r": -0.17263479800000003
    },
    {
      "x": 326.6,
      "y": 134.77,
      "r": -0.172885752
    },
    {
      "x": 326.6,
      "y": 134.77,
      "r": -0.172885752
    },
    {
      "x": 327.22,
      "y": 135.01,
      "r": -0.17312088800000003
    },
    {
      "x": 327.26,
      "y": 135.02,
      "r": -0.17313555
    },
    {
      "x": 327.89,
      "y": 135.26,
      "r": -0.173369598
    },
    {
      "x": 327.89,
      "y": 135.26,
      "r": -0.173369598
    },
    {
      "x": 328.51,
      "y": 135.5,
      "r": -0.173602622
    },
    {
      "x": 328.55,
      "y": 135.52,
      "r": -0.173617152
    },
    {
      "x": 329.25,
      "y": 135.79,
      "r": -0.17387800800000003
    },
    {
      "x": 329.29,
      "y": 135.8,
      "r": -0.173892462
    },
    {
      "x": 329.84,
      "y": 136.01,
      "r": -0.17409439800000004
    },
    {
      "x": 329.84,
      "y": 136.01,
      "r": -0.17409439800000004
    },
    {
      "x": 330.46,
      "y": 136.25,
      "r": -0.174324222
    },
    {
      "x": 330.5,
      "y": 136.27,
      "r": -0.17433855200000004
    },
    {
      "x": 331.13,
      "y": 136.51,
      "r": -0.174567288
    },
    {
      "x": 331.16,
      "y": 136.52,
      "r": -0.17458155
    },
    {
      "x": 331.79,
      "y": 136.76,
      "r": -0.174809198
    },
    {
      "x": 331.79,
      "y": 136.76,
      "r": -0.174809198
    },
    {
      "x": 332.41,
      "y": 137,
      "r": -0.175035822
    },
    {
      "x": 332.45,
      "y": 137.02,
      "r": -0.175049952
    },
    {
      "x": 333.07,
      "y": 137.26,
      "r": -0.17527548800000003
    },
    {
      "x": 333.11,
      "y": 137.27,
      "r": -0.17528955000000002
    },
    {
      "x": 333.73,
      "y": 137.51,
      "r": -0.175513998
    },
    {
      "x": 333.73,
      "y": 137.51,
      "r": -0.175513998
    },
    {
      "x": 334.39,
      "y": 137.77,
      "r": -0.175751352
    },
    {
      "x": 334.39,
      "y": 137.77,
      "r": -0.175751352
    },
    {
      "x": 335.01,
      "y": 138,
      "r": -0.17597368800000002
    },
    {
      "x": 335.05,
      "y": 138.02,
      "r": -0.17598755000000002
    },
    {
      "x": 335.67,
      "y": 138.26,
      "r": -0.17620879800000003
    },
    {
      "x": 335.71,
      "y": 138.27,
      "r": -0.176222592
    },
    {
      "x": 336.33,
      "y": 138.51,
      "r": -0.17644275200000004
    },
    {
      "x": 336.33,
      "y": 138.51,
      "r": -0.17644275200000004
    },
    {
      "x": 336.95,
      "y": 138.75,
      "r": -0.17666188800000004
    },
    {
      "x": 336.99,
      "y": 138.76,
      "r": -0.17667555000000001
    },
    {
      "x": 337.61,
      "y": 139,
      "r": -0.176893598
    },
    {
      "x": 337.65,
      "y": 139.02,
      "r": -0.176907192
    },
    {
      "x": 338.27,
      "y": 139.26,
      "r": -0.177124152
    },
    {
      "x": 338.27,
      "y": 139.26,
      "r": -0.177124152
    },
    {
      "x": 338.88,
      "y": 139.49,
      "r": -0.177340088
    },
    {
      "x": 338.92,
      "y": 139.51,
      "r": -0.17735355000000003
    },
    {
      "x": 339.54,
      "y": 139.75,
      "r": -0.17756839800000002
    },
    {
      "x": 339.58,
      "y": 139.76,
      "r": -0.17758179200000002
    },
    {
      "x": 340.2,
      "y": 140,
      "r": -0.17779555200000002
    },
    {
      "x": 340.24,
      "y": 140.01,
      "r": -0.177808878
    },
    {
      "x": 340.89,
      "y": 140.27,
      "r": -0.17803480800000002
    },
    {
      "x": 340.93,
      "y": 140.28,
      "r": -0.178048062
    },
    {
      "x": 341.47,
      "y": 140.49,
      "r": -0.178233198
    },
    {
      "x": 341.51,
      "y": 140.5,
      "r": -0.17824639200000003
    },
    {
      "x": 342.12,
      "y": 140.74,
      "r": -0.178456952
    },
    {
      "x": 342.12,
      "y": 140.74,
      "r": -0.178456952
    },
    {
      "x": 342.74,
      "y": 140.98,
      "r": -0.17866648800000004
    },
    {
      "x": 342.78,
      "y": 140.99,
      "r": -0.17867955000000002
    },
    {
      "x": 343.4,
      "y": 141.23,
      "r": -0.178887998
    },
    {
      "x": 343.43,
      "y": 141.24,
      "r": -0.178900992
    },
    {
      "x": 344.05,
      "y": 141.48,
      "r": -0.179108352
    },
    {
      "x": 344.05,
      "y": 141.48,
      "r": -0.179108352
    },
    {
      "x": 344.66,
      "y": 141.72,
      "r": -0.17931468800000003
    },
    {
      "x": 344.7,
      "y": 141.73,
      "r": -0.17932755
    },
    {
      "x": 345.32,
      "y": 141.97,
      "r": -0.17953279800000002
    },
    {
      "x": 345.32,
      "y": 141.97,
      "r": -0.17953279800000002
    },
    {
      "x": 345.97,
      "y": 142.22,
      "r": -0.179749752
    },
    {
      "x": 345.97,
      "y": 142.22,
      "r": -0.179749752
    },
    {
      "x": 346.62,
      "y": 142.47,
      "r": -0.17996555000000003
    },
    {
      "x": 346.62,
      "y": 142.47,
      "r": -0.17996555000000003
    },
    {
      "x": 347.23,
      "y": 142.71,
      "r": -0.18016759800000004
    },
    {
      "x": 347.27,
      "y": 142.72,
      "r": -0.18018019200000002
    },
    {
      "x": 347.89,
      "y": 142.96,
      "r": -0.18038115200000002
    },
    {
      "x": 347.89,
      "y": 142.96,
      "r": -0.18038115200000002
    },
    {
      "x": 348.54,
      "y": 143.21,
      "r": -0.18059355000000002
    },
    {
      "x": 348.57,
      "y": 143.22,
      "r": -0.180606008
    },
    {
      "x": 349.15,
      "y": 143.44,
      "r": -0.18079239800000002
    },
    {
      "x": 349.19,
      "y": 143.46,
      "r": -0.180804792
    },
    {
      "x": 349.8,
      "y": 143.69,
      "r": -0.181002552
    },
    {
      "x": 349.8,
      "y": 143.69,
      "r": -0.181002552
    },
    {
      "x": 350.45,
      "y": 143.94,
      "r": -0.18121155
    },
    {
      "x": 350.45,
      "y": 143.94,
      "r": -0.18121155
    },
    {
      "x": 351.06,
      "y": 144.18,
      "r": -0.18140719800000002
    },
    {
      "x": 351.1,
      "y": 144.19,
      "r": -0.181419392
    },
    {
      "x": 351.71,
      "y": 144.43,
      "r": -0.18161395200000002
    },
    {
      "x": 351.71,
      "y": 144.43,
      "r": -0.18161395200000002
    },
    {
      "x": 352.35,
      "y": 144.67,
      "r": -0.18181955000000002
    },
    {
      "x": 352.35,
      "y": 144.67,
      "r": -0.18181955000000002
    },
    {
      "x": 352.96,
      "y": 144.91,
      "r": -0.182011998
    },
    {
      "x": 353,
      "y": 144.92,
      "r": -0.182023992
    },
    {
      "x": 353.61,
      "y": 145.16,
      "r": -0.18221535200000002
    },
    {
      "x": 353.61,
      "y": 145.16,
      "r": -0.18221535200000002
    },
    {
      "x": 354.26,
      "y": 145.41,
      "r": -0.18241755000000004
    },
    {
      "x": 354.26,
      "y": 145.41,
      "r": -0.18241755000000004
    },
    {
      "x": 354.87,
      "y": 145.64,
      "r": -0.18260679800000001
    },
    {
      "x": 354.9,
      "y": 145.66,
      "r": -0.18261859200000002
    },
    {
      "x": 355.51,
      "y": 145.89,
      "r": -0.18280675200000002
    },
    {
      "x": 355.51,
      "y": 145.89,
      "r": -0.18280675200000002
    },
    {
      "x": 356.16,
      "y": 146.14,
      "r": -0.18300555000000002
    },
    {
      "x": 356.2,
      "y": 146.15,
      "r": -0.183017208
    },
    {
      "x": 356.76,
      "y": 146.37,
      "r": -0.183191598
    },
    {
      "x": 356.8,
      "y": 146.39,
      "r": -0.18320319200000001
    },
    {
      "x": 357.41,
      "y": 146.62,
      "r": -0.18338815200000003
    },
    {
      "x": 357.41,
      "y": 146.62,
      "r": -0.18338815200000003
    },
    {
      "x": 358.05,
      "y": 146.87,
      "r": -0.18358355
    },
    {
      "x": 358.05,
      "y": 146.87,
      "r": -0.18358355
    },
    {
      "x": 358.66,
      "y": 147.1,
      "r": -0.18376639800000003
    },
    {
      "x": 358.7,
      "y": 147.11,
      "r": -0.18377779200000002
    },
    {
      "x": 359.3,
      "y": 147.35,
      "r": -0.18395955200000003
    },
    {
      "x": 359.3,
      "y": 147.35,
      "r": -0.18395955200000003
    },
    {
      "x": 359.95,
      "y": 147.59,
      "r": -0.18415155
    },
    {
      "x": 359.98,
      "y": 147.61,
      "r": -0.18416280800000004
    },
    {
      "x": 360.55,
      "y": 147.83,
      "r": -0.184331198
    },
    {
      "x": 360.59,
      "y": 147.84,
      "r": -0.18434239200000002
    },
    {
      "x": 361.19,
      "y": 148.07,
      "r": -0.18452095200000002
    },
    {
      "x": 361.23,
      "y": 148.09,
      "r": -0.18453207800000002
    },
    {
      "x": 361.83,
      "y": 148.32,
      "r": -0.18470955
    },
    {
      "x": 361.83,
      "y": 148.32,
      "r": -0.18470955
    },
    {
      "x": 362.44,
      "y": 148.55,
      "r": -0.18488599800000002
    },
    {
      "x": 362.48,
      "y": 148.57,
      "r": -0.184896992
    },
    {
      "x": 363.08,
      "y": 148.8,
      "r": -0.18507235200000002
    },
    {
      "x": 363.08,
      "y": 148.8,
      "r": -0.18507235200000002
    },
    {
      "x": 363.76,
      "y": 149.06,
      "r": -0.185268408
    },
    {
      "x": 363.79,
      "y": 149.07,
      "r": -0.185279262
    },
    {
      "x": 364.36,
      "y": 149.29,
      "r": -0.18544159200000002
    },
    {
      "x": 364.36,
      "y": 149.29,
      "r": -0.18544159200000002
    },
    {
      "x": 364.96,
      "y": 149.52,
      "r": -0.18561375200000002
    },
    {
      "x": 364.96,
      "y": 149.52,
      "r": -0.18561375200000002
    },
    {
      "x": 365.6,
      "y": 149.77,
      "r": -0.18579555000000003
    },
    {
      "x": 365.64,
      "y": 149.78,
      "r": -0.185806208
    },
    {
      "x": 366.24,
      "y": 150.01,
      "r": -0.185976192
    },
    {
      "x": 366.24,
      "y": 150.01,
      "r": -0.185976192
    },
    {
      "x": 366.84,
      "y": 150.25,
      "r": -0.186145152
    },
    {
      "x": 366.88,
      "y": 150.26,
      "r": -0.18615567800000002
    },
    {
      "x": 367.48,
      "y": 150.49,
      "r": -0.18632355
    },
    {
      "x": 367.51,
      "y": 150.51,
      "r": -0.186334008
    },
    {
      "x": 368.11,
      "y": 150.74,
      "r": -0.18650079200000003
    },
    {
      "x": 368.11,
      "y": 150.74,
      "r": -0.18650079200000003
    },
    {
      "x": 368.71,
      "y": 150.97,
      "r": -0.186666552
    },
    {
      "x": 368.75,
      "y": 150.98,
      "r": -0.18667687800000002
    },
    {
      "x": 369.35,
      "y": 151.21,
      "r": -0.18684155000000002
    },
    {
      "x": 369.35,
      "y": 151.21,
      "r": -0.18684155000000002
    },
    {
      "x": 369.99,
      "y": 151.46,
      "r": -0.18701539200000003
    },
    {
      "x": 369.99,
      "y": 151.46,
      "r": -0.18701539200000003
    },
    {
      "x": 370.58,
      "y": 151.69,
      "r": -0.187177952
    },
    {
      "x": 370.62,
      "y": 151.7,
      "r": -0.18718807800000004
    },
    {
      "x": 371.22,
      "y": 151.93,
      "r": -0.18734955
    },
    {
      "x": 371.26,
      "y": 151.94,
      "r": -0.187359608
    },
    {
      "x": 371.85,
      "y": 152.17,
      "r": -0.18751999200000002
    },
    {
      "x": 371.85,
      "y": 152.17,
      "r": -0.18751999200000002
    },
    {
      "x": 372.45,
      "y": 152.4,
      "r": -0.18767935200000002
    },
    {
      "x": 372.49,
      "y": 152.42,
      "r": -0.18768927800000001
    },
    {
      "x": 373.08,
      "y": 152.65,
      "r": -0.18784755
    },
    {
      "x": 373.08,
      "y": 152.65,
      "r": -0.18784755
    },
    {
      "x": 373.72,
      "y": 152.89,
      "r": -0.18801459200000004
    },
    {
      "x": 373.72,
      "y": 152.89,
      "r": -0.18801459200000004
    },
    {
      "x": 374.31,
      "y": 153.12,
      "r": -0.188170752
    },
    {
      "x": 374.35,
      "y": 153.13,
      "r": -0.188180478
    },
    {
      "x": 375.02,
      "y": 153.39,
      "r": -0.188354862
    },
    {
      "x": 375.02,
      "y": 153.39,
      "r": -0.188354862
    },
    {
      "x": 375.58,
      "y": 153.61,
      "r": -0.188499192
    },
    {
      "x": 375.58,
      "y": 153.61,
      "r": -0.188499192
    },
    {
      "x": 376.17,
      "y": 153.84,
      "r": -0.188652152
    },
    {
      "x": 376.21,
      "y": 153.85,
      "r": -0.188661678
    },
    {
      "x": 376.8,
      "y": 154.08,
      "r": -0.18881355
    },
    {
      "x": 376.8,
      "y": 154.08,
      "r": -0.18881355
    },
    {
      "x": 377.43,
      "y": 154.32,
      "r": -0.188973792
    },
    {
      "x": 377.43,
      "y": 154.32,
      "r": -0.188973792
    },
    {
      "x": 378.06,
      "y": 154.56,
      "r": -0.189132878
    },
    {
      "x": 378.06,
      "y": 154.56,
      "r": -0.189132878
    },
    {
      "x": 378.66,
      "y": 154.79,
      "r": -0.18928155000000002
    },
    {
      "x": 378.69,
      "y": 154.81,
      "r": -0.189290808
    },
    {
      "x": 379.29,
      "y": 155.03,
      "r": -0.189438392
    },
    {
      "x": 379.29,
      "y": 155.03,
      "r": -0.189438392
    },
    {
      "x": 379.92,
      "y": 155.28,
      "r": -0.18959407800000003
    },
    {
      "x": 379.92,
      "y": 155.28,
      "r": -0.18959407800000003
    },
    {
      "x": 380.51,
      "y": 155.5,
      "r": -0.18973955
    },
    {
      "x": 380.54,
      "y": 155.52,
      "r": -0.189748608
    },
    {
      "x": 381.14,
      "y": 155.74,
      "r": -0.189892992
    },
    {
      "x": 381.14,
      "y": 155.74,
      "r": -0.189892992
    },
    {
      "x": 381.76,
      "y": 155.99,
      "r": -0.19004527800000004
    },
    {
      "x": 381.76,
      "y": 155.99,
      "r": -0.19004527800000004
    },
    {
      "x": 382.35,
      "y": 156.21,
      "r": -0.19018755
    },
    {
      "x": 382.39,
      "y": 156.23,
      "r": -0.190196408
    },
    {
      "x": 382.98,
      "y": 156.45,
      "r": -0.190337592
    },
    {
      "x": 382.98,
      "y": 156.45,
      "r": -0.190337592
    },
    {
      "x": 383.61,
      "y": 156.7,
      "r": -0.19048647800000001
    },
    {
      "x": 383.61,
      "y": 156.7,
      "r": -0.19048647800000001
    },
    {
      "x": 384.2,
      "y": 156.92,
      "r": -0.19062555
    },
    {
      "x": 384.23,
      "y": 156.94,
      "r": -0.190634208
    },
    {
      "x": 384.82,
      "y": 157.16,
      "r": -0.190772192
    },
    {
      "x": 384.82,
      "y": 157.16,
      "r": -0.190772192
    },
    {
      "x": 385.45,
      "y": 157.4,
      "r": -0.19091767800000004
    },
    {
      "x": 385.45,
      "y": 157.4,
      "r": -0.19091767800000004
    },
    {
      "x": 386.11,
      "y": 157.66,
      "r": -0.191070462
    },
    {
      "x": 386.33,
      "y": 157.74,
      "r": -0.19112110200000001
    },
    {
      "x": 386.66,
      "y": 157.87,
      "r": -0.191196792
    },
    {
      "x": 386.7,
      "y": 157.88,
      "r": -0.19120518200000003
    },
    {
      "x": 387.28,
      "y": 158.11,
      "r": -0.19133887800000002
    },
    {
      "x": 387.28,
      "y": 158.11,
      "r": -0.19133887800000002
    },
    {
      "x": 387.87,
      "y": 158.33,
      "r": -0.19147155000000002
    },
    {
      "x": 387.91,
      "y": 158.35,
      "r": -0.19147980800000003
    },
    {
      "x": 388.49,
      "y": 158.57,
      "r": -0.19161139200000002
    },
    {
      "x": 388.49,
      "y": 158.57,
      "r": -0.19161139200000002
    },
    {
      "x": 389.12,
      "y": 158.81,
      "r": -0.19175007800000002
    },
    {
      "x": 389.12,
      "y": 158.81,
      "r": -0.19175007800000002
    },
    {
      "x": 389.7,
      "y": 159.04,
      "r": -0.19187955
    },
    {
      "x": 389.74,
      "y": 159.05,
      "r": -0.19188760800000002
    },
    {
      "x": 390.32,
      "y": 159.28,
      "r": -0.192015992
    },
    {
      "x": 390.36,
      "y": 159.29,
      "r": -0.192023982
    },
    {
      "x": 390.94,
      "y": 159.52,
      "r": -0.192151278
    },
    {
      "x": 390.98,
      "y": 159.53,
      "r": -0.1921592
    },
    {
      "x": 391.53,
      "y": 159.74,
      "r": -0.19227755000000002
    },
    {
      "x": 391.57,
      "y": 159.76,
      "r": -0.19228540800000002
    },
    {
      "x": 392.15,
      "y": 159.98,
      "r": -0.192410592
    },
    {
      "x": 392.15,
      "y": 159.98,
      "r": -0.192410592
    },
    {
      "x": 392.77,
      "y": 160.22,
      "r": -0.19254247800000002
    },
    {
      "x": 392.77,
      "y": 160.22,
      "r": -0.19254247800000002
    },
    {
      "x": 393.35,
      "y": 160.44,
      "r": -0.19266555
    },
    {
      "x": 393.43,
      "y": 160.47,
      "r": -0.192680862
    },
    {
      "x": 393.97,
      "y": 160.68,
      "r": -0.192795192
    },
    {
      "x": 394.01,
      "y": 160.7,
      "r": -0.192802782
    },
    {
      "x": 394.59,
      "y": 160.92,
      "r": -0.192923678
    },
    {
      "x": 394.59,
      "y": 160.92,
      "r": -0.192923678
    },
    {
      "x": 395.21,
      "y": 161.16,
      "r": -0.193051008
    },
    {
      "x": 395.21,
      "y": 161.16,
      "r": -0.193051008
    },
    {
      "x": 395.79,
      "y": 161.38,
      "r": -0.193169792
    },
    {
      "x": 395.83,
      "y": 161.39,
      "r": -0.193177182
    },
    {
      "x": 396.41,
      "y": 161.62,
      "r": -0.193294878
    },
    {
      "x": 396.41,
      "y": 161.62,
      "r": -0.193294878
    },
    {
      "x": 397.06,
      "y": 161.87,
      "r": -0.193426062
    },
    {
      "x": 397.06,
      "y": 161.87,
      "r": -0.193426062
    },
    {
      "x": 397.6,
      "y": 162.08,
      "r": -0.193534392
    },
    {
      "x": 397.64,
      "y": 162.09,
      "r": -0.19354158200000002
    },
    {
      "x": 398.22,
      "y": 162.32,
      "r": -0.193656078
    },
    {
      "x": 398.22,
      "y": 162.32,
      "r": -0.193656078
    },
    {
      "x": 398.84,
      "y": 162.55,
      "r": -0.193776608
    },
    {
      "x": 398.84,
      "y": 162.55,
      "r": -0.193776608
    },
    {
      "x": 399.42,
      "y": 162.78,
      "r": -0.193888992
    },
    {
      "x": 399.45,
      "y": 162.79,
      "r": -0.19389598200000002
    },
    {
      "x": 400.03,
      "y": 163.01,
      "r": -0.194007278
    },
    {
      "x": 400.03,
      "y": 163.01,
      "r": -0.194007278
    },
    {
      "x": 400.64,
      "y": 163.25,
      "r": -0.194124408
    },
    {
      "x": 400.64,
      "y": 163.25,
      "r": -0.194124408
    },
    {
      "x": 401.22,
      "y": 163.47,
      "r": -0.194233592
    },
    {
      "x": 401.26,
      "y": 163.48,
      "r": -0.19424038200000002
    },
    {
      "x": 401.84,
      "y": 163.71,
      "r": -0.194348478
    },
    {
      "x": 401.84,
      "y": 163.71,
      "r": -0.194348478
    },
    {
      "x": 402.45,
      "y": 163.94,
      "r": -0.19446220800000003
    },
    {
      "x": 402.45,
      "y": 163.94,
      "r": -0.19446220800000003
    },
    {
      "x": 403.03,
      "y": 164.16,
      "r": -0.194568192
    },
    {
      "x": 403.06,
      "y": 164.18,
      "r": -0.194574782
    },
    {
      "x": 403.64,
      "y": 164.4,
      "r": -0.194679678
    },
    {
      "x": 403.64,
      "y": 164.4,
      "r": -0.194679678
    },
    {
      "x": 404.25,
      "y": 164.63,
      "r": -0.19479000800000001
    },
    {
      "x": 404.29,
      "y": 164.65,
      "r": -0.194796462
    },
    {
      "x": 404.83,
      "y": 164.86,
      "r": -0.194892792
    },
    {
      "x": 404.86,
      "y": 164.87,
      "r": -0.194899182
    },
    {
      "x": 405.44,
      "y": 165.09,
      "r": -0.195000878
    },
    {
      "x": 405.44,
      "y": 165.09,
      "r": -0.195000878
    },
    {
      "x": 406.05,
      "y": 165.33,
      "r": -0.19510780800000002
    },
    {
      "x": 406.05,
      "y": 165.33,
      "r": -0.19510780800000002
    },
    {
      "x": 406.66,
      "y": 165.56,
      "r": -0.19521358200000002
    },
    {
      "x": 406.66,
      "y": 165.56,
      "r": -0.19521358200000002
    },
    {
      "x": 407.23,
      "y": 165.78,
      "r": -0.195312078
    },
    {
      "x": 407.23,
      "y": 165.78,
      "r": -0.195312078
    },
    {
      "x": 407.88,
      "y": 166.03,
      "r": -0.195421662
    },
    {
      "x": 407.88,
      "y": 166.03,
      "r": -0.195421662
    },
    {
      "x": 408.45,
      "y": 166.25,
      "r": -0.19551798200000003
    },
    {
      "x": 408.45,
      "y": 166.25,
      "r": -0.19551798200000003
    },
    {
      "x": 409.02,
      "y": 166.47,
      "r": -0.195613278
    },
    {
      "x": 409.02,
      "y": 166.47,
      "r": -0.195613278
    },
    {
      "x": 409.63,
      "y": 166.7,
      "r": -0.195713408
    },
    {
      "x": 409.63,
      "y": 166.7,
      "r": -0.195713408
    },
    {
      "x": 410.24,
      "y": 166.94,
      "r": -0.195812382
    },
    {
      "x": 410.24,
      "y": 166.94,
      "r": -0.195812382
    },
    {
      "x": 410.81,
      "y": 167.16,
      "r": -0.195904478
    },
    {
      "x": 410.84,
      "y": 167.17,
      "r": -0.1959102
    },
    {
      "x": 411.41,
      "y": 167.39,
      "r": -0.19600120799999998
    },
    {
      "x": 411.45,
      "y": 167.4,
      "r": -0.196006862
    },
    {
      "x": 412.02,
      "y": 167.62,
      "r": -0.19609678200000003
    },
    {
      "x": 412.02,
      "y": 167.62,
      "r": -0.19609678200000003
    },
    {
      "x": 412.59,
      "y": 167.84,
      "r": -0.196185678
    },
    {
      "x": 412.63,
      "y": 167.86,
      "r": -0.1961912
    },
    {
      "x": 413.2,
      "y": 168.08,
      "r": -0.196279008
    },
    {
      "x": 413.2,
      "y": 168.08,
      "r": -0.196279008
    },
    {
      "x": 413.8,
      "y": 168.31,
      "r": -0.196371182
    },
    {
      "x": 413.8,
      "y": 168.31,
      "r": -0.196371182
    },
    {
      "x": 414.37,
      "y": 168.53,
      "r": -0.196456878
    },
    {
      "x": 414.4,
      "y": 168.54,
      "r": -0.19646220000000003
    },
    {
      "x": 414.97,
      "y": 168.76,
      "r": -0.19654680800000002
    },
    {
      "x": 415.01,
      "y": 168.77,
      "r": -0.196552062
    },
    {
      "x": 415.58,
      "y": 168.99,
      "r": -0.196635582
    },
    {
      "x": 415.58,
      "y": 168.99,
      "r": -0.196635582
    },
    {
      "x": 416.14,
      "y": 169.21,
      "r": -0.196718078
    },
    {
      "x": 416.18,
      "y": 169.22,
      "r": -0.1967232
    },
    {
      "x": 416.75,
      "y": 169.44,
      "r": -0.196804608
    },
    {
      "x": 416.75,
      "y": 169.44,
      "r": -0.196804608
    },
    {
      "x": 417.35,
      "y": 169.67,
      "r": -0.19688998200000002
    },
    {
      "x": 417.35,
      "y": 169.67,
      "r": -0.19688998200000002
    },
    {
      "x": 417.92,
      "y": 169.89,
      "r": -0.196969278
    },
    {
      "x": 417.95,
      "y": 169.9,
      "r": -0.19697420000000002
    },
    {
      "x": 418.55,
      "y": 170.14,
      "r": -0.197057262
    },
    {
      "x": 418.59,
      "y": 170.15,
      "r": -0.197062112
    },
    {
      "x": 419.12,
      "y": 170.35,
      "r": -0.197134382
    },
    {
      "x": 419.12,
      "y": 170.35,
      "r": -0.197134382
    },
    {
      "x": 419.68,
      "y": 170.57,
      "r": -0.19721047800000002
    },
    {
      "x": 419.72,
      "y": 170.58,
      "r": -0.1972152
    },
    {
      "x": 420.28,
      "y": 170.8,
      "r": -0.197290208
    },
    {
      "x": 420.28,
      "y": 170.8,
      "r": -0.197290208
    },
    {
      "x": 420.88,
      "y": 171.03,
      "r": -0.19736878200000002
    },
    {
      "x": 420.88,
      "y": 171.03,
      "r": -0.19736878200000002
    },
    {
      "x": 421.45,
      "y": 171.25,
      "r": -0.197441678
    },
    {
      "x": 421.48,
      "y": 171.26,
      "r": -0.19744620000000002
    },
    {
      "x": 422.05,
      "y": 171.48,
      "r": -0.197518008
    },
    {
      "x": 422.08,
      "y": 171.49,
      "r": -0.197522462
    },
    {
      "x": 422.64,
      "y": 171.71,
      "r": -0.197593182
    },
    {
      "x": 422.64,
      "y": 171.71,
      "r": -0.197593182
    },
    {
      "x": 423.21,
      "y": 171.93,
      "r": -0.19766287800000001
    },
    {
      "x": 423.24,
      "y": 171.94,
      "r": -0.19766720000000002
    },
    {
      "x": 423.81,
      "y": 172.16,
      "r": -0.197735808
    },
    {
      "x": 423.81,
      "y": 172.16,
      "r": -0.197735808
    },
    {
      "x": 424.4,
      "y": 172.39,
      "r": -0.197807582
    },
    {
      "x": 424.4,
      "y": 172.39,
      "r": -0.197807582
    },
    {
      "x": 425,
      "y": 172.61,
      "r": -0.1978782
    },
    {
      "x": 425,
      "y": 172.61,
      "r": -0.1978782
    },
    {
      "x": 425.56,
      "y": 172.83,
      "r": -0.197943608
    },
    {
      "x": 425.6,
      "y": 172.84,
      "r": -0.19794766200000002
    },
    {
      "x": 426.16,
      "y": 173.06,
      "r": -0.19801198200000003
    },
    {
      "x": 426.16,
      "y": 173.06,
      "r": -0.19801198200000003
    },
    {
      "x": 426.75,
      "y": 173.29,
      "r": -0.1980792
    },
    {
      "x": 426.75,
      "y": 173.29,
      "r": -0.1980792
    },
    {
      "x": 427.31,
      "y": 173.5,
      "r": -0.19814140800000002
    },
    {
      "x": 427.35,
      "y": 173.52,
      "r": -0.19814526200000002
    },
    {
      "x": 427.91,
      "y": 173.73,
      "r": -0.19820638200000001
    },
    {
      "x": 427.91,
      "y": 173.73,
      "r": -0.19820638200000001
    },
    {
      "x": 428.5,
      "y": 173.96,
      "r": -0.1982702
    },
    {
      "x": 428.5,
      "y": 173.96,
      "r": -0.1982702
    },
    {
      "x": 429.13,
      "y": 174.2,
      "r": -0.19833651200000002
    },
    {
      "x": 429.13,
      "y": 174.2,
      "r": -0.19833651200000002
    },
    {
      "x": 429.65,
      "y": 174.4,
      "r": -0.19839078200000002
    },
    {
      "x": 429.69,
      "y": 174.42,
      "r": -0.198394368
    },
    {
      "x": 430.24,
      "y": 174.63,
      "r": -0.19845120000000002
    },
    {
      "x": 430.24,
      "y": 174.63,
      "r": -0.19845120000000002
    },
    {
      "x": 430.8,
      "y": 174.85,
      "r": -0.198507008
    },
    {
      "x": 430.84,
      "y": 174.86,
      "r": -0.198510462
    },
    {
      "x": 431.39,
      "y": 175.07,
      "r": -0.198565182
    },
    {
      "x": 431.43,
      "y": 175.09,
      "r": -0.198568568
    },
    {
      "x": 431.99,
      "y": 175.3,
      "r": -0.1986222
    },
    {
      "x": 431.99,
      "y": 175.3,
      "r": -0.1986222
    },
    {
      "x": 432.54,
      "y": 175.52,
      "r": -0.198674808
    },
    {
      "x": 432.58,
      "y": 175.53,
      "r": -0.19867806200000002
    },
    {
      "x": 433.13,
      "y": 175.74,
      "r": -0.19872958200000002
    },
    {
      "x": 433.13,
      "y": 175.74,
      "r": -0.19872958200000002
    },
    {
      "x": 433.72,
      "y": 175.97,
      "r": -0.19878320000000002
    },
    {
      "x": 433.72,
      "y": 175.97,
      "r": -0.19878320000000002
    },
    {
      "x": 434.28,
      "y": 176.18,
      "r": -0.19883260800000002
    },
    {
      "x": 434.31,
      "y": 176.2,
      "r": -0.19883566200000002
    },
    {
      "x": 434.87,
      "y": 176.41,
      "r": -0.19888398200000001
    },
    {
      "x": 434.9,
      "y": 176.42,
      "r": -0.19888696800000003
    },
    {
      "x": 435.46,
      "y": 176.64,
      "r": -0.1989342
    },
    {
      "x": 435.46,
      "y": 176.64,
      "r": -0.1989342
    },
    {
      "x": 436.01,
      "y": 176.85,
      "r": -0.19898040800000003
    },
    {
      "x": 436.04,
      "y": 176.86,
      "r": -0.19898326200000002
    },
    {
      "x": 436.6,
      "y": 177.08,
      "r": -0.199028382
    },
    {
      "x": 436.6,
      "y": 177.08,
      "r": -0.199028382
    },
    {
      "x": 437.19,
      "y": 177.3,
      "r": -0.1990752
    },
    {
      "x": 437.19,
      "y": 177.3,
      "r": -0.1990752
    },
    {
      "x": 437.77,
      "y": 177.53,
      "r": -0.199120862
    },
    {
      "x": 437.77,
      "y": 177.53,
      "r": -0.199120862
    },
    {
      "x": 438.32,
      "y": 177.74,
      "r": -0.199162782
    },
    {
      "x": 438.32,
      "y": 177.74,
      "r": -0.199162782
    },
    {
      "x": 438.91,
      "y": 177.97,
      "r": -0.1992062
    },
    {
      "x": 438.91,
      "y": 177.97,
      "r": -0.1992062
    },
    {
      "x": 439.53,
      "y": 178.2,
      "r": -0.199250912
    },
    {
      "x": 439.57,
      "y": 178.22,
      "r": -0.199253358
    },
    {
      "x": 440.05,
      "y": 178.4,
      "r": -0.199287182
    },
    {
      "x": 440.08,
      "y": 178.42,
      "r": -0.199289568
    },
    {
      "x": 440.63,
      "y": 178.63,
      "r": -0.1993272
    },
    {
      "x": 440.67,
      "y": 178.64,
      "r": -0.199329518
    },
    {
      "x": 441.22,
      "y": 178.85,
      "r": -0.199366062
    },
    {
      "x": 441.22,
      "y": 178.85,
      "r": -0.199366062
    },
    {
      "x": 441.77,
      "y": 179.06,
      "r": -0.19940158200000002
    },
    {
      "x": 441.8,
      "y": 179.08,
      "r": -0.199403768
    },
    {
      "x": 442.35,
      "y": 179.29,
      "r": -0.1994382
    },
    {
      "x": 442.35,
      "y": 179.29,
      "r": -0.1994382
    },
    {
      "x": 442.93,
      "y": 179.51,
      "r": -0.19947366200000002
    },
    {
      "x": 442.93,
      "y": 179.51,
      "r": -0.19947366200000002
    },
    {
      "x": 443.48,
      "y": 179.72,
      "r": -0.19950598200000003
    },
    {
      "x": 443.52,
      "y": 179.74,
      "r": -0.199507968
    },
    {
      "x": 444.07,
      "y": 179.95,
      "r": -0.19953920000000003
    },
    {
      "x": 444.07,
      "y": 179.95,
      "r": -0.19953920000000003
    },
    {
      "x": 444.65,
      "y": 180.17,
      "r": -0.199571262
    },
    {
      "x": 444.65,
      "y": 180.17,
      "r": -0.199571262
    },
    {
      "x": 445.19,
      "y": 180.38,
      "r": -0.19960038200000002
    },
    {
      "x": 445.23,
      "y": 180.4,
      "r": -0.199602168
    },
    {
      "x": 445.78,
      "y": 180.61,
      "r": -0.1996302
    },
    {
      "x": 445.78,
      "y": 180.61,
      "r": -0.1996302
    },
    {
      "x": 446.36,
      "y": 180.83,
      "r": -0.19965886200000002
    },
    {
      "x": 446.36,
      "y": 180.83,
      "r": -0.19965886200000002
    },
    {
      "x": 446.9,
      "y": 181.04,
      "r": -0.199684782
    },
    {
      "x": 446.94,
      "y": 181.05,
      "r": -0.199686368
    },
    {
      "x": 447.48,
      "y": 181.26,
      "r": -0.1997112
    },
    {
      "x": 447.48,
      "y": 181.26,
      "r": -0.1997112
    },
    {
      "x": 448.06,
      "y": 181.49,
      "r": -0.199736462
    },
    {
      "x": 448.06,
      "y": 181.49,
      "r": -0.199736462
    },
    {
      "x": 448.61,
      "y": 181.69,
      "r": -0.199759182
    },
    {
      "x": 448.64,
      "y": 181.71,
      "r": -0.199760568
    },
    {
      "x": 449.19,
      "y": 181.92,
      "r": -0.19978220000000002
    },
    {
      "x": 449.19,
      "y": 181.92,
      "r": -0.19978220000000002
    },
    {
      "x": 449.83,
      "y": 182.17,
      "r": -0.19980655800000002
    },
    {
      "x": 449.97,
      "y": 182.22,
      "r": -0.199811502
    },
    {
      "x": 450.34,
      "y": 182.36,
      "r": -0.199824768
    },
    {
      "x": 450.34,
      "y": 182.36,
      "r": -0.199824768
    },
    {
      "x": 450.88,
      "y": 182.57,
      "r": -0.1998432
    },
    {
      "x": 450.88,
      "y": 182.57,
      "r": -0.1998432
    },
    {
      "x": 451.46,
      "y": 182.79,
      "r": -0.199861662
    },
    {
      "x": 451.46,
      "y": 182.79,
      "r": -0.199861662
    },
    {
      "x": 452.04,
      "y": 183.01,
      "r": -0.19987896800000002
    },
    {
      "x": 452.04,
      "y": 183.01,
      "r": -0.19987896800000002
    },
    {
      "x": 452.58,
      "y": 183.22,
      "r": -0.19989420000000002
    },
    {
      "x": 452.58,
      "y": 183.22,
      "r": -0.19989420000000002
    },
    {
      "x": 453.15,
      "y": 183.44,
      "r": -0.19990926200000003
    },
    {
      "x": 453.19,
      "y": 183.46,
      "r": -0.199910112
    },
    {
      "x": 453.73,
      "y": 183.67,
      "r": -0.199923168
    },
    {
      "x": 453.73,
      "y": 183.67,
      "r": -0.199923168
    },
    {
      "x": 454.27,
      "y": 183.87,
      "r": -0.1999352
    },
    {
      "x": 454.3,
      "y": 183.89,
      "r": -0.199935918
    },
    {
      "x": 454.84,
      "y": 184.09,
      "r": -0.199946862
    },
    {
      "x": 454.84,
      "y": 184.09,
      "r": -0.199946862
    },
    {
      "x": 455.42,
      "y": 184.31,
      "r": -0.199957368
    },
    {
      "x": 455.42,
      "y": 184.31,
      "r": -0.199957368
    },
    {
      "x": 455.96,
      "y": 184.52,
      "r": -0.1999662
    },
    {
      "x": 455.99,
      "y": 184.54,
      "r": -0.19996671800000002
    },
    {
      "x": 456.53,
      "y": 184.74,
      "r": -0.19997446200000002
    },
    {
      "x": 456.56,
      "y": 184.76,
      "r": -0.199974912
    },
    {
      "x": 457.1,
      "y": 184.96,
      "r": -0.199981568
    },
    {
      "x": 457.1,
      "y": 184.96,
      "r": -0.199981568
    },
    {
      "x": 457.64,
      "y": 185.17,
      "r": -0.19998720000000003
    },
    {
      "x": 457.68,
      "y": 185.18,
      "r": -0.19998751800000003
    },
    {
      "x": 458.21,
      "y": 185.39,
      "r": -0.199992062
    },
    {
      "x": 458.21,
      "y": 185.39,
      "r": -0.199992062
    },
    {
      "x": 458.78,
      "y": 185.61,
      "r": -0.19999576800000002
    },
    {
      "x": 458.78,
      "y": 185.61,
      "r": -0.19999576800000002
    },
    {
      "x": 459.32,
      "y": 185.82,
      "r": -0.19999820000000001
    },
    {
      "x": 459.36,
      "y": 185.83,
      "r": -0.199998318
    },
    {
      "x": 459.89,
      "y": 186.04,
      "r": -0.199999662
    },
    {
      "x": 459.93,
      "y": 186.05,
      "r": -0.199999712
    },
    {
      "x": 460.46,
      "y": 186.25,
      "r": -0.2
    },
    {
      "x": 460.5,
      "y": 186.27,
      "r": -0.19994286122448982
    },
    {
      "x": 461,
      "y": 186.46,
      "r": -0.19908675918367347
    },
    {
      "x": 461.03,
      "y": 186.47,
      "r": -0.1990297510204082
    },
    {
      "x": 461.57,
      "y": 186.68,
      "r": -0.19811873061224494
    },
    {
      "x": 461.6,
      "y": 186.69,
      "r": -0.19806186122448988
    },
    {
      "x": 462.14,
      "y": 186.9,
      "r": -0.19715306122448986
    },
    {
      "x": 462.14,
      "y": 186.9,
      "r": -0.19715306122448986
    },
    {
      "x": 462.67,
      "y": 187.1,
      "r": -0.19624635102040824
    },
    {
      "x": 462.7,
      "y": 187.12,
      "r": -0.19618975102040817
    },
    {
      "x": 463.24,
      "y": 187.32,
      "r": -0.19528526122448978
    },
    {
      "x": 463.27,
      "y": 187.34,
      "r": -0.19522880000000006
    },
    {
      "x": 463.81,
      "y": 187.54,
      "r": -0.19432653061224492
    },
    {
      "x": 463.84,
      "y": 187.55,
      "r": -0.19427020816326535
    },
    {
      "x": 464.37,
      "y": 187.76,
      "r": -0.19337015918367353
    },
    {
      "x": 464.37,
      "y": 187.76,
      "r": -0.19337015918367353
    },
    {
      "x": 464.91,
      "y": 187.96,
      "r": -0.19247220000000004
    },
    {
      "x": 464.94,
      "y": 187.98,
      "r": -0.19241614693877548
    },
    {
      "x": 465.47,
      "y": 188.18,
      "r": -0.19152040816326532
    },
    {
      "x": 465.47,
      "y": 188.18,
      "r": -0.19152040816326532
    },
    {
      "x": 466.04,
      "y": 188.4,
      "r": -0.1905709755102041
    },
    {
      "x": 466.04,
      "y": 188.4,
      "r": -0.1905709755102041
    },
    {
      "x": 466.57,
      "y": 188.6,
      "r": -0.18967954693877553
    },
    {
      "x": 466.6,
      "y": 188.62,
      "r": -0.1896239020408164
    },
    {
      "x": 467.13,
      "y": 188.82,
      "r": -0.18873469387755107
    },
    {
      "x": 467.13,
      "y": 188.82,
      "r": -0.18873469387755107
    },
    {
      "x": 467.7,
      "y": 189.04,
      "r": -0.1877922
    },
    {
      "x": 467.7,
      "y": 189.04,
      "r": -0.1877922
    },
    {
      "x": 468.23,
      "y": 189.24,
      "r": -0.1869073020408163
    },
    {
      "x": 468.26,
      "y": 189.25,
      "r": -0.18685206530612244
    },
    {
      "x": 468.79,
      "y": 189.46,
      "r": -0.18596938775510208
    },
    {
      "x": 468.79,
      "y": 189.46,
      "r": -0.18596938775510208
    },
    {
      "x": 469.35,
      "y": 189.67,
      "r": -0.18503383265306128
    },
    {
      "x": 469.35,
      "y": 189.67,
      "r": -0.18503383265306128
    },
    {
      "x": 469.95,
      "y": 189.9,
      "r": -0.1840458163265306
    },
    {
      "x": 469.95,
      "y": 189.9,
      "r": -0.1840458163265306
    },
    {
      "x": 470.61,
      "y": 190.16,
      "r": -0.18295112244897963
    },
    {
      "x": 470.64,
      "y": 190.17,
      "r": -0.1828964734693878
    },
    {
      "x": 471.01,
      "y": 190.31,
      "r": -0.18229587346938778
    },
    {
      "x": 471.01,
      "y": 190.31,
      "r": -0.18229587346938778
    },
    {
      "x": 471.54,
      "y": 190.51,
      "r": -0.18142403673469387
    },
    {
      "x": 471.57,
      "y": 190.53,
      "r": -0.18136961632653062
    },
    {
      "x": 472.1,
      "y": 190.73,
      "r": -0.18050000000000002
    },
    {
      "x": 472.1,
      "y": 190.73,
      "r": -0.18050000000000002
    },
    {
      "x": 472.66,
      "y": 190.95,
      "r": -0.17957832244897964
    },
    {
      "x": 472.66,
      "y": 190.95,
      "r": -0.17957832244897964
    },
    {
      "x": 473.18,
      "y": 191.15,
      "r": -0.17871301632653067
    },
    {
      "x": 473.22,
      "y": 191.16,
      "r": -0.17865900408163263
    },
    {
      "x": 473.74,
      "y": 191.36,
      "r": -0.17779591836734696
    },
    {
      "x": 473.74,
      "y": 191.36,
      "r": -0.17779591836734696
    },
    {
      "x": 474.3,
      "y": 191.58,
      "r": -0.17688117959183677
    },
    {
      "x": 474.3,
      "y": 191.58,
      "r": -0.17688117959183677
    },
    {
      "x": 474.83,
      "y": 191.78,
      "r": -0.17602240408163267
    },
    {
      "x": 474.86,
      "y": 191.79,
      "r": -0.17596880000000004
    },
    {
      "x": 475.39,
      "y": 192,
      "r": -0.17511224489795923
    },
    {
      "x": 475.39,
      "y": 192,
      "r": -0.17511224489795923
    },
    {
      "x": 475.95,
      "y": 192.21,
      "r": -0.17420444489795917
    },
    {
      "x": 475.95,
      "y": 192.21,
      "r": -0.17420444489795917
    },
    {
      "x": 476.47,
      "y": 192.41,
      "r": -0.17335219999999998
    },
    {
      "x": 476.5,
      "y": 192.42,
      "r": -0.17329900408163265
    },
    {
      "x": 477.03,
      "y": 192.63,
      "r": -0.17244897959183675
    },
    {
      "x": 477.03,
      "y": 192.63,
      "r": -0.17244897959183675
    },
    {
      "x": 477.58,
      "y": 192.84,
      "r": -0.17154811836734699
    },
    {
      "x": 477.58,
      "y": 192.84,
      "r": -0.17154811836734699
    },
    {
      "x": 478.11,
      "y": 193.04,
      "r": -0.1707024040816327
    },
    {
      "x": 478.14,
      "y": 193.05,
      "r": -0.17064961632653067
    },
    {
      "x": 478.66,
      "y": 193.25,
      "r": -0.16980612244897966
    },
    {
      "x": 478.66,
      "y": 193.25,
      "r": -0.16980612244897966
    },
    {
      "x": 479.22,
      "y": 193.47,
      "r": -0.16891219999999998
    },
    {
      "x": 479.22,
      "y": 193.47,
      "r": -0.16891219999999998
    },
    {
      "x": 479.8,
      "y": 193.69,
      "r": -0.16796826530612252
    },
    {
      "x": 479.8,
      "y": 193.69,
      "r": -0.16796826530612252
    },
    {
      "x": 480.29,
      "y": 193.88,
      "r": -0.16718367346938778
    },
    {
      "x": 480.33,
      "y": 193.89,
      "r": -0.1671314326530613
    },
    {
      "x": 480.85,
      "y": 194.1,
      "r": -0.16629668979591844
    },
    {
      "x": 480.85,
      "y": 194.1,
      "r": -0.16629668979591844
    },
    {
      "x": 481.4,
      "y": 194.31,
      "r": -0.16541206530612243
    },
    {
      "x": 481.4,
      "y": 194.31,
      "r": -0.16541206530612243
    },
    {
      "x": 481.92,
      "y": 194.51,
      "r": -0.16458163265306125
    },
    {
      "x": 481.95,
      "y": 194.52,
      "r": -0.16452980000000003
    },
    {
      "x": 482.47,
      "y": 194.72,
      "r": -0.16370158775510205
    },
    {
      "x": 482.47,
      "y": 194.72,
      "r": -0.16370158775510205
    },
    {
      "x": 483.03,
      "y": 194.93,
      "r": -0.16282390204081637
    },
    {
      "x": 483.03,
      "y": 194.93,
      "r": -0.16282390204081637
    },
    {
      "x": 483.55,
      "y": 195.13,
      "r": -0.16200000000000006
    },
    {
      "x": 483.58,
      "y": 195.15,
      "r": -0.16194857551020406
    },
    {
      "x": 484.1,
      "y": 195.34,
      "r": -0.161126893877551
    },
    {
      "x": 484.1,
      "y": 195.34,
      "r": -0.161126893877551
    },
    {
      "x": 484.65,
      "y": 195.56,
      "r": -0.16025614693877552
    },
    {
      "x": 484.65,
      "y": 195.56,
      "r": -0.16025614693877552
    },
    {
      "x": 485.17,
      "y": 195.76,
      "r": -0.1594387755102041
    },
    {
      "x": 485.2,
      "y": 195.77,
      "r": -0.1593877591836735
    },
    {
      "x": 485.72,
      "y": 195.97,
      "r": -0.15857260816326535
    },
    {
      "x": 485.72,
      "y": 195.97,
      "r": -0.15857260816326535
    },
    {
      "x": 486.27,
      "y": 196.18,
      "r": -0.15770880000000007
    },
    {
      "x": 486.27,
      "y": 196.18,
      "r": -0.15770880000000007
    },
    {
      "x": 486.78,
      "y": 196.38,
      "r": -0.15689795918367355
    },
    {
      "x": 486.81,
      "y": 196.39,
      "r": -0.15684735102040817
    },
    {
      "x": 487.33,
      "y": 196.59,
      "r": -0.15603873061224488
    },
    {
      "x": 487.33,
      "y": 196.59,
      "r": -0.15603873061224488
    },
    {
      "x": 487.88,
      "y": 196.8,
      "r": -0.15518186122448982
    },
    {
      "x": 487.88,
      "y": 196.8,
      "r": -0.15518186122448982
    },
    {
      "x": 488.39,
      "y": 197,
      "r": -0.1543775510204082
    },
    {
      "x": 488.43,
      "y": 197.01,
      "r": -0.1543273510204082
    },
    {
      "x": 488.94,
      "y": 197.21,
      "r": -0.15352526122448984
    },
    {
      "x": 488.94,
      "y": 197.21,
      "r": -0.15352526122448984
    },
    {
      "x": 489.52,
      "y": 197.43,
      "r": -0.15262540816326534
    },
    {
      "x": 489.55,
      "y": 197.44,
      "r": -0.1525754938775511
    },
    {
      "x": 490,
      "y": 197.62,
      "r": -0.15187755102040817
    },
    {
      "x": 490.04,
      "y": 197.63,
      "r": -0.1518277591836735
    },
    {
      "x": 490.55,
      "y": 197.83,
      "r": -0.1510322
    },
    {
      "x": 490.55,
      "y": 197.83,
      "r": -0.1510322
    },
    {
      "x": 491.1,
      "y": 198.04,
      "r": -0.15018920816326534
    },
    {
      "x": 491.1,
      "y": 198.04,
      "r": -0.15018920816326534
    },
    {
      "x": 491.61,
      "y": 198.23,
      "r": -0.1493979591836735
    },
    {
      "x": 491.64,
      "y": 198.25,
      "r": -0.14934857551020408
    },
    {
      "x": 492.15,
      "y": 198.44,
      "r": -0.1485595469387755
    },
    {
      "x": 492.15,
      "y": 198.44,
      "r": -0.1485595469387755
    },
    {
      "x": 492.7,
      "y": 198.65,
      "r": -0.14772349387755102
    },
    {
      "x": 492.73,
      "y": 198.67,
      "r": -0.1476743877551021
    },
    {
      "x": 493.24,
      "y": 198.86,
      "r": -0.14688980000000004
    },
    {
      "x": 493.24,
      "y": 198.86,
      "r": -0.14688980000000004
    },
    {
      "x": 493.79,
      "y": 199.07,
      "r": -0.14605846530612243
    },
    {
      "x": 493.79,
      "y": 199.07,
      "r": -0.14605846530612243
    },
    {
      "x": 494.3,
      "y": 199.27,
      "r": -0.1452781877551021
    },
    {
      "x": 494.3,
      "y": 199.27,
      "r": -0.1452781877551021
    },
    {
      "x": 494.84,
      "y": 199.48,
      "r": -0.14445143265306123
    },
    {
      "x": 494.84,
      "y": 199.48,
      "r": -0.14445143265306123
    },
    {
      "x": 495.35,
      "y": 199.67,
      "r": -0.14367546530612244
    },
    {
      "x": 495.38,
      "y": 199.69,
      "r": -0.1436270367346939
    },
    {
      "x": 495.89,
      "y": 199.88,
      "r": -0.14285328979591838
    },
    {
      "x": 495.92,
      "y": 199.89,
      "r": -0.14280500000000007
    },
    {
      "x": 496.43,
      "y": 200.09,
      "r": -0.1420334734693878
    },
    {
      "x": 496.43,
      "y": 200.09,
      "r": -0.1420334734693878
    },
    {
      "x": 496.94,
      "y": 200.29,
      "r": -0.14126403673469393
    },
    {
      "x": 496.97,
      "y": 200.3,
      "r": -0.14121601632653064
    },
    {
      "x": 497.48,
      "y": 200.49,
      "r": -0.1404488
    },
    {
      "x": 497.48,
      "y": 200.49,
      "r": -0.1404488
    },
    {
      "x": 498.02,
      "y": 200.7,
      "r": -0.13963592244897963
    },
    {
      "x": 498.02,
      "y": 200.7,
      "r": -0.13963592244897963
    },
    {
      "x": 498.53,
      "y": 200.9,
      "r": -0.13887301632653062
    },
    {
      "x": 498.56,
      "y": 200.91,
      "r": -0.1388254040816327
    },
    {
      "x": 499.07,
      "y": 201.1,
      "r": -0.138064718367347
    },
    {
      "x": 499.1,
      "y": 201.12,
      "r": -0.13801724489795916
    },
    {
      "x": 499.61,
      "y": 201.31,
      "r": -0.1372587795918367
    },
    {
      "x": 499.61,
      "y": 201.31,
      "r": -0.1372587795918367
    },
    {
      "x": 500.12,
      "y": 201.51,
      "r": -0.13650240408163264
    },
    {
      "x": 500.15,
      "y": 201.52,
      "r": -0.13645520000000003
    },
    {
      "x": 500.65,
      "y": 201.71,
      "r": -0.1357010448979592
    },
    {
      "x": 500.65,
      "y": 201.71,
      "r": -0.1357010448979592
    },
    {
      "x": 501.19,
      "y": 201.92,
      "r": -0.13490204489795923
    },
    {
      "x": 501.19,
      "y": 201.92,
      "r": -0.13490204489795923
    },
    {
      "x": 501.7,
      "y": 202.11,
      "r": -0.1341522
    },
    {
      "x": 501.73,
      "y": 202.13,
      "r": -0.13410540408163263
    },
    {
      "x": 502.23,
      "y": 202.32,
      "r": -0.1333577795918368
    },
    {
      "x": 502.26,
      "y": 202.33,
      "r": -0.13331112244897958
    },
    {
      "x": 502.77,
      "y": 202.53,
      "r": -0.13256571836734693
    },
    {
      "x": 502.77,
      "y": 202.53,
      "r": -0.13256571836734693
    },
    {
      "x": 503.27,
      "y": 202.72,
      "r": -0.13182240408163265
    },
    {
      "x": 503.3,
      "y": 202.73,
      "r": -0.13177601632653063
    },
    {
      "x": 503.81,
      "y": 202.93,
      "r": -0.13103492244897963
    },
    {
      "x": 503.84,
      "y": 202.94,
      "r": -0.1309886734693878
    },
    {
      "x": 504.34,
      "y": 203.13,
      "r": -0.13024980000000008
    },
    {
      "x": 504.34,
      "y": 203.13,
      "r": -0.13024980000000008
    },
    {
      "x": 504.88,
      "y": 203.34,
      "r": -0.12946703673469387
    },
    {
      "x": 504.88,
      "y": 203.34,
      "r": -0.12946703673469387
    },
    {
      "x": 505.38,
      "y": 203.53,
      "r": -0.12873247346938776
    },
    {
      "x": 505.41,
      "y": 203.54,
      "r": -0.12868663265306124
    },
    {
      "x": 505.91,
      "y": 203.74,
      "r": -0.12795428979591839
    },
    {
      "x": 505.91,
      "y": 203.74,
      "r": -0.12795428979591839
    },
    {
      "x": 506.45,
      "y": 203.94,
      "r": -0.12717846530612253
    },
    {
      "x": 506.45,
      "y": 203.94,
      "r": -0.12717846530612253
    },
    {
      "x": 506.95,
      "y": 204.13,
      "r": -0.12645043265306127
    },
    {
      "x": 506.98,
      "y": 204.15,
      "r": -0.126405
    },
    {
      "x": 507.48,
      "y": 204.34,
      "r": -0.12567918775510203
    },
    {
      "x": 507.48,
      "y": 204.34,
      "r": -0.12567918775510203
    },
    {
      "x": 508.01,
      "y": 204.54,
      "r": -0.12491030204081632
    },
    {
      "x": 508.01,
      "y": 204.54,
      "r": -0.12491030204081632
    },
    {
      "x": 508.51,
      "y": 204.74,
      "r": -0.12418880000000002
    },
    {
      "x": 508.54,
      "y": 204.75,
      "r": -0.12414377551020411
    },
    {
      "x": 509.04,
      "y": 204.94,
      "r": -0.12342449387755104
    },
    {
      "x": 509.04,
      "y": 204.94,
      "r": -0.12342449387755104
    },
    {
      "x": 509.57,
      "y": 205.14,
      "r": -0.12266254693877549
    },
    {
      "x": 509.57,
      "y": 205.14,
      "r": -0.12266254693877549
    },
    {
      "x": 510.07,
      "y": 205.34,
      "r": -0.12194757551020415
    },
    {
      "x": 510.1,
      "y": 205.35,
      "r": -0.12190295918367347
    },
    {
      "x": 510.6,
      "y": 205.54,
      "r": -0.12119020816326531
    },
    {
      "x": 510.6,
      "y": 205.54,
      "r": -0.12119020816326531
    },
    {
      "x": 511.13,
      "y": 205.74,
      "r": -0.12043520000000002
    },
    {
      "x": 511.13,
      "y": 205.74,
      "r": -0.12043520000000002
    },
    {
      "x": 511.63,
      "y": 205.93,
      "r": -0.11972675918367351
    },
    {
      "x": 511.66,
      "y": 205.95,
      "r": -0.1196825510204082
    },
    {
      "x": 512.16,
      "y": 206.14,
      "r": -0.11897633061224494
    },
    {
      "x": 512.16,
      "y": 206.14,
      "r": -0.11897633061224494
    },
    {
      "x": 512.69,
      "y": 206.34,
      "r": -0.11822826122448978
    },
    {
      "x": 512.69,
      "y": 206.34,
      "r": -0.11822826122448978
    },
    {
      "x": 513.18,
      "y": 206.53,
      "r": -0.11752635102040815
    },
    {
      "x": 513.21,
      "y": 206.54,
      "r": -0.11748255102040817
    },
    {
      "x": 513.71,
      "y": 206.73,
      "r": -0.11678286122448983
    },
    {
      "x": 513.71,
      "y": 206.73,
      "r": -0.11678286122448983
    },
    {
      "x": 514.24,
      "y": 206.94,
      "r": -0.11604173061224493
    },
    {
      "x": 514.24,
      "y": 206.94,
      "r": -0.11604173061224493
    },
    {
      "x": 514.73,
      "y": 207.13,
      "r": -0.1153463510204082
    },
    {
      "x": 514.76,
      "y": 207.14,
      "r": -0.11530295918367346
    },
    {
      "x": 515.26,
      "y": 207.33,
      "r": -0.11460979999999997
    },
    {
      "x": 515.26,
      "y": 207.33,
      "r": -0.11460979999999997
    },
    {
      "x": 515.78,
      "y": 207.53,
      "r": -0.11387560816326531
    },
    {
      "x": 515.78,
      "y": 207.53,
      "r": -0.11387560816326531
    },
    {
      "x": 516.28,
      "y": 207.72,
      "r": -0.11318675918367345
    },
    {
      "x": 516.31,
      "y": 207.73,
      "r": -0.11314377551020412
    },
    {
      "x": 516.8,
      "y": 207.92,
      "r": -0.11245714693877557
    },
    {
      "x": 516.8,
      "y": 207.92,
      "r": -0.11245714693877557
    },
    {
      "x": 517.33,
      "y": 208.13,
      "r": -0.111729893877551
    },
    {
      "x": 517.33,
      "y": 208.13,
      "r": -0.111729893877551
    },
    {
      "x": 517.85,
      "y": 208.33,
      "r": -0.111005
    },
    {
      "x": 517.88,
      "y": 208.34,
      "r": -0.11096243265306123
    },
    {
      "x": 518.34,
      "y": 208.52,
      "r": -0.11032490204081631
    },
    {
      "x": 518.34,
      "y": 208.52,
      "r": -0.11032490204081631
    },
    {
      "x": 518.86,
      "y": 208.72,
      "r": -0.10960458775510205
    },
    {
      "x": 518.86,
      "y": 208.72,
      "r": -0.10960458775510205
    },
    {
      "x": 519.39,
      "y": 208.92,
      "r": -0.10888663265306127
    },
    {
      "x": 519.39,
      "y": 208.92,
      "r": -0.10888663265306127
    },
    {
      "x": 519.88,
      "y": 209.11,
      "r": -0.10821306530612251
    },
    {
      "x": 519.91,
      "y": 209.12,
      "r": -0.10817103673469385
    },
    {
      "x": 520.4,
      "y": 209.31,
      "r": -0.10749968979591835
    },
    {
      "x": 520.4,
      "y": 209.31,
      "r": -0.10749968979591835
    },
    {
      "x": 520.92,
      "y": 209.51,
      "r": -0.10678867346938777
    },
    {
      "x": 520.92,
      "y": 209.51,
      "r": -0.10678867346938777
    },
    {
      "x": 521.41,
      "y": 209.7,
      "r": -0.10612163673469388
    },
    {
      "x": 521.44,
      "y": 209.71,
      "r": -0.10608001632653066
    },
    {
      "x": 521.93,
      "y": 209.9,
      "r": -0.10541520000000003
    },
    {
      "x": 521.93,
      "y": 209.9,
      "r": -0.10541520000000003
    },
    {
      "x": 522.45,
      "y": 210.1,
      "r": -0.10471112244897958
    },
    {
      "x": 522.45,
      "y": 210.1,
      "r": -0.10471112244897958
    },
    {
      "x": 522.94,
      "y": 210.28,
      "r": -0.10405061632653059
    },
    {
      "x": 522.97,
      "y": 210.3,
      "r": -0.10400940408163264
    },
    {
      "x": 523.46,
      "y": 210.48,
      "r": -0.10335111836734695
    },
    {
      "x": 523.46,
      "y": 210.48,
      "r": -0.10335111836734695
    },
    {
      "x": 523.98,
      "y": 210.68,
      "r": -0.10265397959183675
    },
    {
      "x": 523.98,
      "y": 210.68,
      "r": -0.10265397959183675
    },
    {
      "x": 524.46,
      "y": 210.87,
      "r": -0.10200000408163266
    },
    {
      "x": 524.5,
      "y": 210.88,
      "r": -0.10195919999999999
    },
    {
      "x": 524.98,
      "y": 211.07,
      "r": -0.10130744489795916
    },
    {
      "x": 524.98,
      "y": 211.07,
      "r": -0.10130744489795916
    },
    {
      "x": 525.5,
      "y": 211.27,
      "r": -0.10061724489795919
    },
    {
      "x": 525.5,
      "y": 211.27,
      "r": -0.10061724489795919
    },
    {
      "x": 525.99,
      "y": 211.46,
      "r": -0.0999698
    },
    {
      "x": 526.02,
      "y": 211.47,
      "r": -0.09992940408163267
    },
    {
      "x": 526.5,
      "y": 211.65,
      "r": -0.09928417959183676
    },
    {
      "x": 526.5,
      "y": 211.65,
      "r": -0.09928417959183676
    },
    {
      "x": 527.05,
      "y": 211.86,
      "r": -0.0985608
    },
    {
      "x": 527.05,
      "y": 211.86,
      "r": -0.0985608
    },
    {
      "x": 527.5,
      "y": 212.04,
      "r": -0.09796000408163269
    },
    {
      "x": 527.53,
      "y": 212.05,
      "r": -0.09792001632653063
    },
    {
      "x": 528.02,
      "y": 212.24,
      "r": -0.09728132244897958
    },
    {
      "x": 528.05,
      "y": 212.25,
      "r": -0.09724147346938775
    },
    {
      "x": 528.53,
      "y": 212.44,
      "r": -0.09660500000000001
    },
    {
      "x": 528.53,
      "y": 212.44,
      "r": -0.09660500000000001
    },
    {
      "x": 529.02,
      "y": 212.62,
      "r": -0.09597061632653062
    },
    {
      "x": 529.05,
      "y": 212.63,
      "r": -0.0959310367346939
    },
    {
      "x": 529.53,
      "y": 212.82,
      "r": -0.09529887346938777
    },
    {
      "x": 529.53,
      "y": 212.82,
      "r": -0.09529887346938777
    },
    {
      "x": 530.04,
      "y": 213.02,
      "r": -0.09462948979591834
    },
    {
      "x": 530.07,
      "y": 213.03,
      "r": -0.09459018775510204
    },
    {
      "x": 530.56,
      "y": 213.21,
      "r": -0.09396246530612247
    },
    {
      "x": 530.56,
      "y": 213.21,
      "r": -0.09396246530612247
    },
    {
      "x": 531.04,
      "y": 213.4,
      "r": -0.09333683265306124
    },
    {
      "x": 531.07,
      "y": 213.41,
      "r": -0.09329780000000004
    },
    {
      "x": 531.55,
      "y": 213.6,
      "r": -0.09267438775510209
    },
    {
      "x": 531.55,
      "y": 213.6,
      "r": -0.09267438775510209
    },
    {
      "x": 532.06,
      "y": 213.79,
      "r": -0.09201430204081629
    },
    {
      "x": 532.06,
      "y": 213.79,
      "r": -0.09201430204081629
    },
    {
      "x": 532.54,
      "y": 213.98,
      "r": -0.0913952
    },
    {
      "x": 532.57,
      "y": 213.99,
      "r": -0.09135657551020407
    },
    {
      "x": 533.05,
      "y": 214.17,
      "r": -0.09073969387755101
    },
    {
      "x": 533.08,
      "y": 214.19,
      "r": -0.09070120816326532
    },
    {
      "x": 533.56,
      "y": 214.37,
      "r": -0.09008654693877555
    },
    {
      "x": 533.56,
      "y": 214.37,
      "r": -0.09008654693877555
    },
    {
      "x": 534.04,
      "y": 214.56,
      "r": -0.08947397551020408
    },
    {
      "x": 534.07,
      "y": 214.57,
      "r": -0.08943575918367351
    },
    {
      "x": 534.55,
      "y": 214.75,
      "r": -0.08882540816326534
    },
    {
      "x": 534.55,
      "y": 214.75,
      "r": -0.08882540816326534
    },
    {
      "x": 535.06,
      "y": 214.95,
      "r": -0.0881792
    },
    {
      "x": 535.06,
      "y": 214.95,
      "r": -0.0881792
    },
    {
      "x": 535.54,
      "y": 215.13,
      "r": -0.08757315918367348
    },
    {
      "x": 535.57,
      "y": 215.14,
      "r": -0.08753535102040817
    },
    {
      "x": 536.08,
      "y": 215.34,
      "r": -0.08689386122448983
    },
    {
      "x": 536.11,
      "y": 215.35,
      "r": -0.0868562
    },
    {
      "x": 536.56,
      "y": 215.52,
      "r": -0.08629226122448985
    },
    {
      "x": 536.56,
      "y": 215.52,
      "r": -0.08629226122448985
    },
    {
      "x": 537.03,
      "y": 215.71,
      "r": -0.08569275102040819
    },
    {
      "x": 537.06,
      "y": 215.72,
      "r": -0.08565535102040817
    },
    {
      "x": 537.54,
      "y": 215.9,
      "r": -0.08505806122448978
    },
    {
      "x": 537.54,
      "y": 215.9,
      "r": -0.08505806122448978
    },
    {
      "x": 538.05,
      "y": 216.1,
      "r": -0.0844257306122449
    },
    {
      "x": 538.05,
      "y": 216.1,
      "r": -0.0844257306122449
    },
    {
      "x": 538.55,
      "y": 216.29,
      "r": -0.0837957591836735
    },
    {
      "x": 538.55,
      "y": 216.29,
      "r": -0.0837957591836735
    },
    {
      "x": 539.03,
      "y": 216.47,
      "r": -0.08320500000000003
    },
    {
      "x": 539.06,
      "y": 216.48,
      "r": -0.0831681469387755
    },
    {
      "x": 539.53,
      "y": 216.67,
      "r": -0.08257960816326526
    },
    {
      "x": 539.53,
      "y": 216.67,
      "r": -0.08257960816326526
    },
    {
      "x": 540.01,
      "y": 216.85,
      "r": -0.08199315918367343
    },
    {
      "x": 540.04,
      "y": 216.86,
      "r": -0.08195657551020408
    },
    {
      "x": 540.51,
      "y": 217.04,
      "r": -0.08137234693877554
    },
    {
      "x": 540.51,
      "y": 217.04,
      "r": -0.08137234693877554
    },
    {
      "x": 541.02,
      "y": 217.24,
      "r": -0.08075389387755104
    },
    {
      "x": 541.02,
      "y": 217.24,
      "r": -0.08075389387755104
    },
    {
      "x": 541.49,
      "y": 217.42,
      "r": -0.0801739755102041
    },
    {
      "x": 541.52,
      "y": 217.43,
      "r": -0.08013780000000002
    },
    {
      "x": 541.99,
      "y": 217.61,
      "r": -0.07956010204081634
    },
    {
      "x": 542.02,
      "y": 217.62,
      "r": -0.07952406530612244
    },
    {
      "x": 542.5,
      "y": 217.81,
      "r": -0.07894858775510204
    },
    {
      "x": 542.5,
      "y": 217.81,
      "r": -0.07894858775510204
    },
    {
      "x": 543,
      "y": 218,
      "r": -0.07833943265306123
    },
    {
      "x": 543,
      "y": 218,
      "r": -0.07833943265306123
    },
    {
      "x": 543.47,
      "y": 218.18,
      "r": -0.07776826530612246
    },
    {
      "x": 543.47,
      "y": 218.18,
      "r": -0.07776826530612246
    },
    {
      "x": 543.97,
      "y": 218.37,
      "r": -0.0771636897959184
    },
    {
      "x": 543.97,
      "y": 218.37,
      "r": -0.0771636897959184
    },
    {
      "x": 544.47,
      "y": 218.57,
      "r": -0.07656147346938776
    },
    {
      "x": 544.47,
      "y": 218.57,
      "r": -0.07656147346938776
    },
    {
      "x": 544.94,
      "y": 218.75,
      "r": -0.07599683673469385
    },
    {
      "x": 545.03,
      "y": 218.78,
      "r": -0.07589119999999996
    },
    {
      "x": 545.44,
      "y": 218.94,
      "r": -0.0753992
    },
    {
      "x": 545.44,
      "y": 218.94,
      "r": -0.0753992
    },
    {
      "x": 545.94,
      "y": 219.13,
      "r": -0.0748039224489796
    },
    {
      "x": 545.94,
      "y": 219.13,
      "r": -0.0748039224489796
    },
    {
      "x": 546.41,
      "y": 219.31,
      "r": -0.07424581632653066
    },
    {
      "x": 546.44,
      "y": 219.32,
      "r": -0.07421100408163261
    },
    {
      "x": 546.91,
      "y": 219.5,
      "r": -0.07365511836734692
    },
    {
      "x": 546.91,
      "y": 219.5,
      "r": -0.07365511836734692
    },
    {
      "x": 547.41,
      "y": 219.7,
      "r": -0.07306677959183674
    },
    {
      "x": 547.41,
      "y": 219.7,
      "r": -0.07306677959183674
    },
    {
      "x": 547.88,
      "y": 219.88,
      "r": -0.07251520408163264
    },
    {
      "x": 547.91,
      "y": 219.89,
      "r": -0.07248080000000004
    },
    {
      "x": 548.38,
      "y": 220.07,
      "r": -0.07193144489795919
    },
    {
      "x": 548.38,
      "y": 220.07,
      "r": -0.07193144489795919
    },
    {
      "x": 548.87,
      "y": 220.26,
      "r": -0.07135004489795924
    },
    {
      "x": 548.87,
      "y": 220.26,
      "r": -0.07135004489795924
    },
    {
      "x": 549.34,
      "y": 220.44,
      "r": -0.07080500000000006
    },
    {
      "x": 549.37,
      "y": 220.45,
      "r": -0.07077100408163264
    },
    {
      "x": 549.84,
      "y": 220.63,
      "r": -0.07022817959183675
    },
    {
      "x": 549.84,
      "y": 220.63,
      "r": -0.07022817959183675
    },
    {
      "x": 550.33,
      "y": 220.82,
      "r": -0.06965371836734696
    },
    {
      "x": 550.33,
      "y": 220.82,
      "r": -0.06965371836734696
    },
    {
      "x": 550.8,
      "y": 221,
      "r": -0.06911520408163266
    },
    {
      "x": 550.83,
      "y": 221.01,
      "r": -0.06908161632653065
    },
    {
      "x": 551.29,
      "y": 221.19,
      "r": -0.06854532244897962
    },
    {
      "x": 551.32,
      "y": 221.2,
      "r": -0.06851187346938775
    },
    {
      "x": 551.79,
      "y": 221.38,
      "r": -0.06797779999999998
    },
    {
      "x": 551.79,
      "y": 221.38,
      "r": -0.06797779999999998
    },
    {
      "x": 552.28,
      "y": 221.57,
      "r": -0.06741263673469386
    },
    {
      "x": 552.28,
      "y": 221.57,
      "r": -0.06741263673469386
    },
    {
      "x": 552.74,
      "y": 221.75,
      "r": -0.06688287346938779
    },
    {
      "x": 552.74,
      "y": 221.75,
      "r": -0.06688287346938779
    },
    {
      "x": 553.24,
      "y": 221.94,
      "r": -0.0663222897959184
    },
    {
      "x": 553.24,
      "y": 221.94,
      "r": -0.0663222897959184
    },
    {
      "x": 553.73,
      "y": 222.13,
      "r": -0.06576406530612244
    },
    {
      "x": 553.87,
      "y": 222.18,
      "r": -0.0656003306122449
    },
    {
      "x": 554.19,
      "y": 222.31,
      "r": -0.06524083265306121
    },
    {
      "x": 554.22,
      "y": 222.32,
      "r": -0.06520820000000002
    },
    {
      "x": 554.68,
      "y": 222.49,
      "r": -0.06468718775510204
    },
    {
      "x": 554.71,
      "y": 222.51,
      "r": -0.06465469387755104
    },
    {
      "x": 555.18,
      "y": 222.68,
      "r": -0.06413590204081632
    },
    {
      "x": 555.18,
      "y": 222.68,
      "r": -0.06413590204081632
    },
    {
      "x": 555.64,
      "y": 222.86,
      "r": -0.06361920000000001
    },
    {
      "x": 555.67,
      "y": 222.87,
      "r": -0.06358697551020415
    },
    {
      "x": 556.13,
      "y": 223.05,
      "r": -0.06307249387755107
    },
    {
      "x": 556.13,
      "y": 223.05,
      "r": -0.06307249387755107
    },
    {
      "x": 556.62,
      "y": 223.24,
      "r": -0.06252814693877551
    },
    {
      "x": 556.62,
      "y": 223.24,
      "r": -0.06252814693877551
    },
    {
      "x": 557.08,
      "y": 223.42,
      "r": -0.062017975510204076
    },
    {
      "x": 557.11,
      "y": 223.43,
      "r": -0.06198615918367348
    },
    {
      "x": 557.57,
      "y": 223.6,
      "r": -0.061478208163265324
    },
    {
      "x": 557.57,
      "y": 223.6,
      "r": -0.061478208163265324
    },
    {
      "x": 558.06,
      "y": 223.79,
      "r": -0.06094080000000002
    },
    {
      "x": 558.06,
      "y": 223.79,
      "r": -0.06094080000000002
    },
    {
      "x": 558.52,
      "y": 223.97,
      "r": -0.06043715918367351
    },
    {
      "x": 558.55,
      "y": 223.98,
      "r": -0.060405751020408155
    },
    {
      "x": 559,
      "y": 224.16,
      "r": -0.05990433061224487
    },
    {
      "x": 559,
      "y": 224.16,
      "r": -0.05990433061224487
    },
    {
      "x": 559.49,
      "y": 224.34,
      "r": -0.059373861224489816
    },
    {
      "x": 559.49,
      "y": 224.34,
      "r": -0.059373861224489816
    },
    {
      "x": 559.95,
      "y": 224.52,
      "r": -0.05887675102040818
    },
    {
      "x": 559.98,
      "y": 224.53,
      "r": -0.05884575102040818
    },
    {
      "x": 560.44,
      "y": 224.71,
      "r": -0.05835086122448982
    },
    {
      "x": 560.44,
      "y": 224.71,
      "r": -0.05835086122448982
    },
    {
      "x": 560.92,
      "y": 224.89,
      "r": -0.057827330612244876
    },
    {
      "x": 560.92,
      "y": 224.89,
      "r": -0.057827330612244876
    },
    {
      "x": 561.38,
      "y": 225.07,
      "r": -0.05733675102040814
    },
    {
      "x": 561.41,
      "y": 225.08,
      "r": -0.05730615918367349
    },
    {
      "x": 561.86,
      "y": 225.26,
      "r": -0.0568178
    },
    {
      "x": 561.86,
      "y": 225.26,
      "r": -0.0568178
    },
    {
      "x": 562.38,
      "y": 225.45,
      "r": -0.05627089387755105
    },
    {
      "x": 562.41,
      "y": 225.46,
      "r": -0.056240587755102045
    },
    {
      "x": 562.81,
      "y": 225.62,
      "r": -0.0558171591836735
    },
    {
      "x": 562.83,
      "y": 225.63,
      "r": -0.05578697551020412
    },
    {
      "x": 563.29,
      "y": 225.8,
      "r": -0.05530514693877553
    },
    {
      "x": 563.29,
      "y": 225.8,
      "r": -0.05530514693877553
    },
    {
      "x": 563.77,
      "y": 225.99,
      "r": -0.054795493877551005
    },
    {
      "x": 563.77,
      "y": 225.99,
      "r": -0.054795493877551005
    },
    {
      "x": 564.26,
      "y": 226.18,
      "r": -0.05428820000000001
    },
    {
      "x": 564.26,
      "y": 226.18,
      "r": -0.05428820000000001
    },
    {
      "x": 564.71,
      "y": 226.35,
      "r": -0.05381290204081632
    },
    {
      "x": 564.71,
      "y": 226.35,
      "r": -0.05381290204081632
    },
    {
      "x": 565.19,
      "y": 226.54,
      "r": -0.05331018775510207
    },
    {
      "x": 565.19,
      "y": 226.54,
      "r": -0.05331018775510207
    },
    {
      "x": 565.67,
      "y": 226.72,
      "r": -0.05280983265306122
    },
    {
      "x": 565.67,
      "y": 226.72,
      "r": -0.05280983265306122
    },
    {
      "x": 566.13,
      "y": 226.9,
      "r": -0.05234106530612245
    },
    {
      "x": 566.13,
      "y": 226.9,
      "r": -0.05234106530612245
    },
    {
      "x": 566.61,
      "y": 227.08,
      "r": -0.051845289795918376
    },
    {
      "x": 566.64,
      "y": 227.09,
      "r": -0.051816200000000034
    },
    {
      "x": 567.09,
      "y": 227.26,
      "r": -0.05135187346938777
    },
    {
      "x": 567.09,
      "y": 227.26,
      "r": -0.05135187346938777
    },
    {
      "x": 567.54,
      "y": 227.44,
      "r": -0.05088963673469388
    },
    {
      "x": 567.57,
      "y": 227.45,
      "r": -0.050860816326530583
    },
    {
      "x": 568.02,
      "y": 227.62,
      "r": -0.050400799999999996
    },
    {
      "x": 568.05,
      "y": 227.63,
      "r": -0.050372118367346924
    },
    {
      "x": 568.5,
      "y": 227.81,
      "r": -0.04991432244897959
    },
    {
      "x": 568.5,
      "y": 227.81,
      "r": -0.04991432244897959
    },
    {
      "x": 568.95,
      "y": 227.98,
      "r": -0.04945861632653059
    },
    {
      "x": 568.98,
      "y": 227.99,
      "r": -0.04943020408163265
    },
    {
      "x": 569.43,
      "y": 228.16,
      "r": -0.04897671836734693
    },
    {
      "x": 569.43,
      "y": 228.16,
      "r": -0.04897671836734693
    },
    {
      "x": 569.91,
      "y": 228.35,
      "r": -0.04849717959183675
    },
    {
      "x": 569.91,
      "y": 228.35,
      "r": -0.04849717959183675
    },
    {
      "x": 570.36,
      "y": 228.52,
      "r": -0.04804800408163268
    },
    {
      "x": 570.38,
      "y": 228.53,
      "r": -0.04802000000000001
    },
    {
      "x": 570.89,
      "y": 228.73,
      "r": -0.047517322448979604
    },
    {
      "x": 570.89,
      "y": 228.73,
      "r": -0.047517322448979604
    },
    {
      "x": 571.31,
      "y": 228.89,
      "r": -0.0471004448979592
    },
    {
      "x": 571.31,
      "y": 228.89,
      "r": -0.0471004448979592
    },
    {
      "x": 571.76,
      "y": 229.06,
      "r": -0.0466578
    },
    {
      "x": 571.78,
      "y": 229.07,
      "r": -0.04663020408163268
    },
    {
      "x": 572.23,
      "y": 229.24,
      "r": -0.04618977959183673
    },
    {
      "x": 572.23,
      "y": 229.24,
      "r": -0.04618977959183673
    },
    {
      "x": 572.71,
      "y": 229.43,
      "r": -0.04572411836734694
    },
    {
      "x": 572.71,
      "y": 229.43,
      "r": -0.04572411836734694
    },
    {
      "x": 573.15,
      "y": 229.6,
      "r": -0.04528800408163264
    },
    {
      "x": 573.18,
      "y": 229.61,
      "r": -0.04526081632653062
    },
    {
      "x": 573.63,
      "y": 229.78,
      "r": -0.044826922448979595
    },
    {
      "x": 573.66,
      "y": 229.79,
      "r": -0.044799873469387796
    },
    {
      "x": 574.1,
      "y": 229.96,
      "r": -0.044368200000000024
    },
    {
      "x": 574.1,
      "y": 229.96,
      "r": -0.044368200000000024
    },
    {
      "x": 574.55,
      "y": 230.13,
      "r": -0.04393861632653062
    },
    {
      "x": 574.58,
      "y": 230.14,
      "r": -0.04391183673469387
    },
    {
      "x": 575.02,
      "y": 230.32,
      "r": -0.04348447346938772
    },
    {
      "x": 575.02,
      "y": 230.32,
      "r": -0.04348447346938772
    },
    {
      "x": 575.49,
      "y": 230.5,
      "r": -0.04303268979591837
    },
    {
      "x": 575.49,
      "y": 230.5,
      "r": -0.04303268979591837
    },
    {
      "x": 575.94,
      "y": 230.67,
      "r": -0.04260963673469387
    },
    {
      "x": 575.97,
      "y": 230.68,
      "r": -0.04258326530612247
    },
    {
      "x": 576.41,
      "y": 230.85,
      "r": -0.042162432653061244
    },
    {
      "x": 576.44,
      "y": 230.86,
      "r": -0.04213620000000001
    },
    {
      "x": 576.88,
      "y": 231.03,
      "r": -0.041717587755102065
    },
    {
      "x": 576.88,
      "y": 231.03,
      "r": -0.041717587755102065
    },
    {
      "x": 577.35,
      "y": 231.21,
      "r": -0.04127510204081633
    },
    {
      "x": 577.35,
      "y": 231.21,
      "r": -0.04127510204081633
    },
    {
      "x": 577.8,
      "y": 231.38,
      "r": -0.040860799999999975
    },
    {
      "x": 577.82,
      "y": 231.39,
      "r": -0.04083497551020407
    },
    {
      "x": 578.27,
      "y": 231.56,
      "r": -0.04042289387755102
    },
    {
      "x": 578.27,
      "y": 231.56,
      "r": -0.04042289387755102
    },
    {
      "x": 578.74,
      "y": 231.74,
      "r": -0.039987346938775536
    },
    {
      "x": 578.74,
      "y": 231.74,
      "r": -0.039987346938775536
    },
    {
      "x": 579.18,
      "y": 231.91,
      "r": -0.03957957551020411
    },
    {
      "x": 579.21,
      "y": 231.93,
      "r": -0.03955415918367344
    },
    {
      "x": 579.65,
      "y": 232.09,
      "r": -0.03914860816326532
    },
    {
      "x": 579.65,
      "y": 232.09,
      "r": -0.03914860816326532
    },
    {
      "x": 580.11,
      "y": 232.27,
      "r": -0.038720000000000004
    },
    {
      "x": 580.11,
      "y": 232.27,
      "r": -0.038720000000000004
    },
    {
      "x": 580.56,
      "y": 232.44,
      "r": -0.03831875918367347
    },
    {
      "x": 580.58,
      "y": 232.45,
      "r": -0.03829375102040816
    },
    {
      "x": 581.02,
      "y": 232.62,
      "r": -0.03789473061224491
    },
    {
      "x": 581.02,
      "y": 232.62,
      "r": -0.03789473061224491
    },
    {
      "x": 581.49,
      "y": 232.8,
      "r": -0.03747306122448976
    },
    {
      "x": 581.49,
      "y": 232.8,
      "r": -0.03747306122448976
    },
    {
      "x": 581.93,
      "y": 232.97,
      "r": -0.03707835102040816
    },
    {
      "x": 581.96,
      "y": 232.98,
      "r": -0.03705375102040814
    },
    {
      "x": 582.4,
      "y": 233.15,
      "r": -0.036661261224489816
    },
    {
      "x": 582.4,
      "y": 233.15,
      "r": -0.036661261224489816
    },
    {
      "x": 582.86,
      "y": 233.33,
      "r": -0.03624653061224492
    },
    {
      "x": 582.86,
      "y": 233.33,
      "r": -0.03624653061224492
    },
    {
      "x": 583.3,
      "y": 233.5,
      "r": -0.035858351020408186
    },
    {
      "x": 583.33,
      "y": 233.51,
      "r": -0.0358341591836735
    },
    {
      "x": 583.76,
      "y": 233.68,
      "r": -0.03544820000000001
    },
    {
      "x": 583.76,
      "y": 233.68,
      "r": -0.03544820000000001
    },
    {
      "x": 584.23,
      "y": 233.86,
      "r": -0.035040408163265285
    },
    {
      "x": 584.23,
      "y": 233.86,
      "r": -0.035040408163265285
    },
    {
      "x": 584.66,
      "y": 234.02,
      "r": -0.034658759183673477
    },
    {
      "x": 584.69,
      "y": 234.04,
      "r": -0.034634975510204086
    },
    {
      "x": 585.13,
      "y": 234.2,
      "r": -0.03425554693877553
    },
    {
      "x": 585.16,
      "y": 234.21,
      "r": -0.03423190204081633
    },
    {
      "x": 585.59,
      "y": 234.38,
      "r": -0.03385469387755105
    },
    {
      "x": 585.59,
      "y": 234.38,
      "r": -0.03385469387755105
    },
    {
      "x": 586.03,
      "y": 234.55,
      "r": -0.03347957551020411
    },
    {
      "x": 586.05,
      "y": 234.56,
      "r": -0.03345619999999999
    },
    {
      "x": 586.49,
      "y": 234.73,
      "r": -0.03308330204081633
    },
    {
      "x": 586.49,
      "y": 234.73,
      "r": -0.03308330204081633
    },
    {
      "x": 586.95,
      "y": 234.9,
      "r": -0.03268938775510205
    },
    {
      "x": 586.95,
      "y": 234.9,
      "r": -0.03268938775510205
    },
    {
      "x": 587.39,
      "y": 235.07,
      "r": -0.03232080000000001
    },
    {
      "x": 587.41,
      "y": 235.08,
      "r": -0.03229783265306124
    },
    {
      "x": 587.85,
      "y": 235.25,
      "r": -0.03193146530612248
    },
    {
      "x": 587.85,
      "y": 235.25,
      "r": -0.03193146530612248
    },
    {
      "x": 588.31,
      "y": 235.43,
      "r": -0.03154448979591834
    },
    {
      "x": 588.31,
      "y": 235.43,
      "r": -0.03154448979591834
    },
    {
      "x": 588.77,
      "y": 235.6,
      "r": -0.031159873469387755
    },
    {
      "x": 588.77,
      "y": 235.6,
      "r": -0.031159873469387755
    },
    {
      "x": 589.2,
      "y": 235.77,
      "r": -0.030800036734693892
    },
    {
      "x": 589.2,
      "y": 235.77,
      "r": -0.030800036734693892
    },
    {
      "x": 589.66,
      "y": 235.95,
      "r": -0.030420000000000003
    },
    {
      "x": 589.66,
      "y": 235.95,
      "r": -0.030420000000000003
    },
    {
      "x": 590.12,
      "y": 236.12,
      "r": -0.030042322448979586
    },
    {
      "x": 590.12,
      "y": 236.12,
      "r": -0.030042322448979586
    },
    {
      "x": 590.55,
      "y": 236.29,
      "r": -0.029689016326530593
    },
    {
      "x": 590.58,
      "y": 236.3,
      "r": -0.029667004081632697
    },
    {
      "x": 591.01,
      "y": 236.46,
      "r": -0.029315918367346927
    },
    {
      "x": 591.01,
      "y": 236.46,
      "r": -0.029315918367346927
    },
    {
      "x": 591.47,
      "y": 236.64,
      "r": -0.028945179591836734
    },
    {
      "x": 591.47,
      "y": 236.64,
      "r": -0.028945179591836734
    },
    {
      "x": 591.92,
      "y": 236.82,
      "r": -0.028576800000000013
    },
    {
      "x": 591.92,
      "y": 236.82,
      "r": -0.028576800000000013
    },
    {
      "x": 592.35,
      "y": 236.98,
      "r": -0.02823224489795914
    },
    {
      "x": 592.38,
      "y": 236.99,
      "r": -0.028210779591836765
    },
    {
      "x": 592.81,
      "y": 237.16,
      "r": -0.02786844489795917
    },
    {
      "x": 592.84,
      "y": 237.17,
      "r": -0.02784711836734699
    },
    {
      "x": 593.24,
      "y": 237.32,
      "r": -0.02752820000000003
    },
    {
      "x": 593.26,
      "y": 237.33,
      "r": -0.027507004081632674
    },
    {
      "x": 593.69,
      "y": 237.5,
      "r": -0.027168979591836784
    },
    {
      "x": 593.69,
      "y": 237.5,
      "r": -0.027168979591836784
    },
    {
      "x": 594.15,
      "y": 237.67,
      "r": -0.026812118367346927
    },
    {
      "x": 594.15,
      "y": 237.67,
      "r": -0.026812118367346927
    },
    {
      "x": 594.58,
      "y": 237.84,
      "r": -0.026478404081632656
    },
    {
      "x": 594.6,
      "y": 237.85,
      "r": -0.026457616326530597
    },
    {
      "x": 595.03,
      "y": 238.01,
      "r": -0.026126122448979605
    },
    {
      "x": 595.03,
      "y": 238.01,
      "r": -0.026126122448979605
    },
    {
      "x": 595.51,
      "y": 238.2,
      "r": -0.025755689795918357
    },
    {
      "x": 595.54,
      "y": 238.21,
      "r": -0.02573518775510203
    },
    {
      "x": 595.94,
      "y": 238.36,
      "r": -0.025428636734693866
    },
    {
      "x": 595.94,
      "y": 238.36,
      "r": -0.025428636734693866
    },
    {
      "x": 596.36,
      "y": 238.52,
      "r": -0.025103673469387744
    },
    {
      "x": 596.36,
      "y": 238.52,
      "r": -0.025103673469387744
    },
    {
      "x": 596.82,
      "y": 238.7,
      "r": -0.02476068979591839
    },
    {
      "x": 596.82,
      "y": 238.7,
      "r": -0.02476068979591839
    },
    {
      "x": 597.24,
      "y": 238.86,
      "r": -0.02444003673469386
    },
    {
      "x": 597.27,
      "y": 238.87,
      "r": -0.02442006530612248
    },
    {
      "x": 597.69,
      "y": 239.04,
      "r": -0.024101632653061228
    },
    {
      "x": 597.69,
      "y": 239.04,
      "r": -0.024101632653061228
    },
    {
      "x": 598.14,
      "y": 239.21,
      "r": -0.02376558775510204
    },
    {
      "x": 598.17,
      "y": 239.22,
      "r": -0.023745893877550994
    },
    {
      "x": 598.57,
      "y": 239.37,
      "r": -0.02345146530612241
    },
    {
      "x": 598.59,
      "y": 239.38,
      "r": -0.023431902040816327
    },
    {
      "x": 599.02,
      "y": 239.55,
      "r": -0.023119999999999974
    },
    {
      "x": 599.02,
      "y": 239.55,
      "r": -0.023119999999999974
    },
    {
      "x": 599.47,
      "y": 239.72,
      "r": -0.02279089387755101
    },
    {
      "x": 599.47,
      "y": 239.72,
      "r": -0.02279089387755101
    },
    {
      "x": 599.92,
      "y": 239.89,
      "r": -0.02246414693877552
    },
    {
      "x": 599.92,
      "y": 239.89,
      "r": -0.02246414693877552
    },
    {
      "x": 600.34,
      "y": 240.05,
      "r": -0.02215877551020412
    },
    {
      "x": 600.37,
      "y": 240.06,
      "r": -0.022139759183673474
    },
    {
      "x": 600.79,
      "y": 240.23,
      "r": -0.021836608163265298
    },
    {
      "x": 600.81,
      "y": 240.24,
      "r": -0.02181773061224493
    },
    {
      "x": 601.24,
      "y": 240.4,
      "r": -0.021516800000000003
    },
    {
      "x": 601.24,
      "y": 240.4,
      "r": -0.021516800000000003
    },
    {
      "x": 601.66,
      "y": 240.56,
      "r": -0.021217959183673474
    },
    {
      "x": 601.68,
      "y": 240.57,
      "r": -0.021199351020408153
    },
    {
      "x": 602.1,
      "y": 240.73,
      "r": -0.02090273061224493
    },
    {
      "x": 602.1,
      "y": 240.73,
      "r": -0.02090273061224493
    },
    {
      "x": 602.55,
      "y": 240.9,
      "r": -0.020589861224489747
    },
    {
      "x": 602.55,
      "y": 240.9,
      "r": -0.020589861224489747
    },
    {
      "x": 602.97,
      "y": 241.07,
      "r": -0.020297551020408172
    },
    {
      "x": 603,
      "y": 241.08,
      "r": -0.02027935102040815
    },
    {
      "x": 603.47,
      "y": 241.26,
      "r": -0.01995314693877548
    },
    {
      "x": 603.47,
      "y": 241.26,
      "r": -0.01995314693877548
    },
    {
      "x": 603.86,
      "y": 241.41,
      "r": -0.01968333061224492
    },
    {
      "x": 603.86,
      "y": 241.41,
      "r": -0.01968333061224492
    },
    {
      "x": 604.28,
      "y": 241.57,
      "r": -0.01939755102040816
    },
    {
      "x": 604.31,
      "y": 241.58,
      "r": -0.019379759183673434
    },
    {
      "x": 604.73,
      "y": 241.74,
      "r": -0.019096200000000008
    },
    {
      "x": 604.73,
      "y": 241.74,
      "r": -0.019096200000000008
    },
    {
      "x": 605.17,
      "y": 241.91,
      "r": -0.018797208163265328
    },
    {
      "x": 605.17,
      "y": 241.91,
      "r": -0.018797208163265328
    },
    {
      "x": 605.59,
      "y": 242.07,
      "r": -0.018517959183673438
    },
    {
      "x": 605.61,
      "y": 242.08,
      "r": -0.01850057551020412
    },
    {
      "x": 606.03,
      "y": 242.24,
      "r": -0.01822354693877551
    },
    {
      "x": 606.06,
      "y": 242.25,
      "r": -0.018206302040816358
    },
    {
      "x": 606.47,
      "y": 242.41,
      "r": -0.017931493877551025
    },
    {
      "x": 606.47,
      "y": 242.41,
      "r": -0.017931493877551025
    },
    {
      "x": 606.89,
      "y": 242.57,
      "r": -0.017658775510204117
    },
    {
      "x": 606.92,
      "y": 242.58,
      "r": -0.017641799999999985
    },
    {
      "x": 607.33,
      "y": 242.74,
      "r": -0.017371302040816328
    },
    {
      "x": 607.33,
      "y": 242.74,
      "r": -0.017371302040816328
    },
    {
      "x": 607.77,
      "y": 242.91,
      "r": -0.01708618775510201
    },
    {
      "x": 607.77,
      "y": 242.91,
      "r": -0.01708618775510201
    },
    {
      "x": 608.19,
      "y": 243.07,
      "r": -0.01682
    },
    {
      "x": 608.22,
      "y": 243.08,
      "r": -0.016803432653061223
    },
    {
      "x": 608.63,
      "y": 243.24,
      "r": -0.016539465306122464
    },
    {
      "x": 608.66,
      "y": 243.25,
      "r": -0.01652303673469388
    },
    {
      "x": 609.07,
      "y": 243.41,
      "r": -0.016261289795918343
    },
    {
      "x": 609.07,
      "y": 243.41,
      "r": -0.016261289795918343
    },
    {
      "x": 609.48,
      "y": 243.57,
      "r": -0.016001632653061232
    },
    {
      "x": 609.51,
      "y": 243.58,
      "r": -0.01598547346938775
    },
    {
      "x": 609.92,
      "y": 243.74,
      "r": -0.01572803673469389
    },
    {
      "x": 609.92,
      "y": 243.74,
      "r": -0.01572803673469389
    },
    {
      "x": 610.36,
      "y": 243.91,
      "r": -0.01545680000000002
    },
    {
      "x": 610.36,
      "y": 243.91,
      "r": -0.01545680000000002
    },
    {
      "x": 610.8,
      "y": 244.08,
      "r": -0.015187922448979568
    },
    {
      "x": 610.8,
      "y": 244.08,
      "r": -0.015187922448979568
    },
    {
      "x": 611.21,
      "y": 244.24,
      "r": -0.014937016326530606
    },
    {
      "x": 611.24,
      "y": 244.25,
      "r": -0.014921404081632644
    },
    {
      "x": 611.65,
      "y": 244.4,
      "r": -0.01467271836734696
    },
    {
      "x": 611.68,
      "y": 244.41,
      "r": -0.014657244897959193
    },
    {
      "x": 612.09,
      "y": 244.57,
      "r": -0.014410779591836731
    },
    {
      "x": 612.09,
      "y": 244.57,
      "r": -0.014410779591836731
    },
    {
      "x": 612.5,
      "y": 244.73,
      "r": -0.014166404081632666
    },
    {
      "x": 612.53,
      "y": 244.74,
      "r": -0.01415120000000003
    },
    {
      "x": 612.94,
      "y": 244.9,
      "r": -0.013909044897959189
    },
    {
      "x": 612.94,
      "y": 244.9,
      "r": -0.013909044897959189
    },
    {
      "x": 613.37,
      "y": 245.07,
      "r": -0.013654044897959183
    },
    {
      "x": 613.37,
      "y": 245.07,
      "r": -0.013654044897959183
    },
    {
      "x": 613.78,
      "y": 245.22,
      "r": -0.01341619999999999
    },
    {
      "x": 613.81,
      "y": 245.23,
      "r": -0.01340140408163265
    },
    {
      "x": 614.22,
      "y": 245.39,
      "r": -0.013165779591836707
    },
    {
      "x": 614.22,
      "y": 245.39,
      "r": -0.013165779591836707
    },
    {
      "x": 614.65,
      "y": 245.56,
      "r": -0.012917718367346953
    },
    {
      "x": 614.65,
      "y": 245.56,
      "r": -0.012917718367346953
    },
    {
      "x": 615.06,
      "y": 245.72,
      "r": -0.012686404081632685
    },
    {
      "x": 615.09,
      "y": 245.73,
      "r": -0.012672016326530616
    },
    {
      "x": 615.49,
      "y": 245.88,
      "r": -0.012442922448979571
    },
    {
      "x": 615.49,
      "y": 245.88,
      "r": -0.012442922448979571
    },
    {
      "x": 615.93,
      "y": 246.05,
      "r": -0.012201799999999985
    },
    {
      "x": 615.93,
      "y": 246.05,
      "r": -0.012201799999999985
    },
    {
      "x": 616.34,
      "y": 246.21,
      "r": -0.011977016326530643
    },
    {
      "x": 616.36,
      "y": 246.22,
      "r": -0.011963036734693872
    },
    {
      "x": 616.77,
      "y": 246.37,
      "r": -0.01174047346938778
    },
    {
      "x": 616.77,
      "y": 246.37,
      "r": -0.01174047346938778
    },
    {
      "x": 617.2,
      "y": 246.54,
      "r": -0.011506289795918334
    },
    {
      "x": 617.2,
      "y": 246.54,
      "r": -0.011506289795918334
    },
    {
      "x": 617.63,
      "y": 246.7,
      "r": -0.011274465306122444
    },
    {
      "x": 617.63,
      "y": 246.7,
      "r": -0.011274465306122444
    },
    {
      "x": 618.04,
      "y": 246.86,
      "r": -0.011058432653061223
    },
    {
      "x": 618.06,
      "y": 246.87,
      "r": -0.011045
    },
    {
      "x": 618.47,
      "y": 247.03,
      "r": -0.010831187755102056
    },
    {
      "x": 618.47,
      "y": 247.03,
      "r": -0.010831187755102056
    },
    {
      "x": 618.87,
      "y": 247.18,
      "r": -0.010619465306122428
    },
    {
      "x": 618.9,
      "y": 247.19,
      "r": -0.010606302040816334
    },
    {
      "x": 619.3,
      "y": 247.35,
      "r": -0.010396800000000012
    },
    {
      "x": 619.3,
      "y": 247.35,
      "r": -0.010396800000000012
    },
    {
      "x": 619.73,
      "y": 247.51,
      "r": -0.010176493877551013
    },
    {
      "x": 619.73,
      "y": 247.51,
      "r": -0.010176493877551013
    },
    {
      "x": 620.16,
      "y": 247.68,
      "r": -0.009958546938775514
    },
    {
      "x": 620.16,
      "y": 247.68,
      "r": -0.009958546938775514
    },
    {
      "x": 620.56,
      "y": 247.83,
      "r": -0.009755575510204062
    },
    {
      "x": 620.56,
      "y": 247.83,
      "r": -0.009755575510204062
    },
    {
      "x": 620.99,
      "y": 248,
      "r": -0.009542208163265287
    },
    {
      "x": 620.99,
      "y": 248,
      "r": -0.009542208163265287
    },
    {
      "x": 621.42,
      "y": 248.16,
      "r": -0.009331200000000012
    },
    {
      "x": 621.42,
      "y": 248.16,
      "r": -0.009331200000000012
    },
    {
      "x": 621.85,
      "y": 248.33,
      "r": -0.009122551020408182
    },
    {
      "x": 621.85,
      "y": 248.33,
      "r": -0.009122551020408182
    },
    {
      "x": 622.25,
      "y": 248.48,
      "r": -0.008928330612244906
    },
    {
      "x": 622.25,
      "y": 248.48,
      "r": -0.008928330612244906
    },
    {
      "x": 622.68,
      "y": 248.64,
      "r": -0.008724261224489799
    },
    {
      "x": 622.68,
      "y": 248.64,
      "r": -0.008724261224489799
    },
    {
      "x": 623.08,
      "y": 248.8,
      "r": -0.00853435102040817
    },
    {
      "x": 623.1,
      "y": 248.81,
      "r": -0.008522551020408164
    },
    {
      "x": 623.5,
      "y": 248.96,
      "r": -0.008334861224489787
    },
    {
      "x": 623.5,
      "y": 248.96,
      "r": -0.008334861224489787
    },
    {
      "x": 623.93,
      "y": 249.13,
      "r": -0.008137730612244903
    },
    {
      "x": 623.93,
      "y": 249.13,
      "r": -0.008137730612244903
    },
    {
      "x": 624.33,
      "y": 249.28,
      "r": -0.007954351020408174
    },
    {
      "x": 624.35,
      "y": 249.29,
      "r": -0.007942959183673465
    },
    {
      "x": 624.75,
      "y": 249.44,
      "r": -0.007761800000000013
    },
    {
      "x": 624.75,
      "y": 249.44,
      "r": -0.007761800000000013
    },
    {
      "x": 625.18,
      "y": 249.61,
      "r": -0.007571608163265325
    },
    {
      "x": 625.18,
      "y": 249.61,
      "r": -0.007571608163265325
    },
    {
      "x": 625.57,
      "y": 249.76,
      "r": -0.007394759183673466
    },
    {
      "x": 625.6,
      "y": 249.77,
      "r": -0.007383775510204055
    },
    {
      "x": 626,
      "y": 249.92,
      "r": -0.007209146938775529
    },
    {
      "x": 626,
      "y": 249.92,
      "r": -0.007209146938775529
    },
    {
      "x": 626.42,
      "y": 250.08,
      "r": -0.007025893877551037
    },
    {
      "x": 626.42,
      "y": 250.08,
      "r": -0.007025893877551037
    },
    {
      "x": 626.82,
      "y": 250.24,
      "r": -0.006855575510204076
    },
    {
      "x": 626.84,
      "y": 250.25,
      "r": -0.006845000000000018
    },
    {
      "x": 627.24,
      "y": 250.4,
      "r": -0.006676902040816335
    },
    {
      "x": 627.24,
      "y": 250.4,
      "r": -0.006676902040816335
    },
    {
      "x": 627.66,
      "y": 250.56,
      "r": -0.006500587755102039
    },
    {
      "x": 627.66,
      "y": 250.56,
      "r": -0.006500587755102039
    },
    {
      "x": 628.06,
      "y": 250.71,
      "r": -0.006336799999999976
    },
    {
      "x": 628.08,
      "y": 250.72,
      "r": -0.006326632653061243
    },
    {
      "x": 628.48,
      "y": 250.88,
      "r": -0.00616506530612243
    },
    {
      "x": 628.48,
      "y": 250.88,
      "r": -0.00616506530612243
    },
    {
      "x": 628.9,
      "y": 251.04,
      "r": -0.0059956897959183575
    },
    {
      "x": 628.9,
      "y": 251.04,
      "r": -0.0059956897959183575
    },
    {
      "x": 629.29,
      "y": 251.19,
      "r": -0.005838432653061221
    },
    {
      "x": 629.32,
      "y": 251.2,
      "r": -0.005828673469387757
    },
    {
      "x": 629.71,
      "y": 251.35,
      "r": -0.005673636734693871
    },
    {
      "x": 629.71,
      "y": 251.35,
      "r": -0.005673636734693871
    },
    {
      "x": 630.13,
      "y": 251.51,
      "r": -0.005511199999999994
    },
    {
      "x": 630.13,
      "y": 251.51,
      "r": -0.005511199999999994
    },
    {
      "x": 630.55,
      "y": 251.67,
      "r": -0.0053511224489795894
    },
    {
      "x": 630.55,
      "y": 251.67,
      "r": -0.0053511224489795894
    },
    {
      "x": 630.94,
      "y": 251.82,
      "r": -0.005202616326530629
    },
    {
      "x": 630.94,
      "y": 251.82,
      "r": -0.005202616326530629
    },
    {
      "x": 631.36,
      "y": 251.98,
      "r": -0.005047118367346948
    },
    {
      "x": 631.38,
      "y": 251.99,
      "r": -0.005038044897959171
    },
    {
      "x": 631.78,
      "y": 252.14,
      "r": -0.004893979591836739
    },
    {
      "x": 631.78,
      "y": 252.14,
      "r": -0.004893979591836739
    },
    {
      "x": 632.17,
      "y": 252.3,
      "r": -0.004752004081632649
    },
    {
      "x": 632.17,
      "y": 252.3,
      "r": -0.004752004081632649
    },
    {
      "x": 632.58,
      "y": 252.46,
      "r": -0.004603444897959191
    },
    {
      "x": 632.58,
      "y": 252.46,
      "r": -0.004603444897959191
    },
    {
      "x": 633,
      "y": 252.62,
      "r": -0.004457244897959206
    },
    {
      "x": 633,
      "y": 252.62,
      "r": -0.004457244897959206
    },
    {
      "x": 633.39,
      "y": 252.77,
      "r": -0.004321799999999987
    },
    {
      "x": 633.41,
      "y": 252.77,
      "r": -0.004313404081632638
    },
    {
      "x": 633.83,
      "y": 252.93,
      "r": -0.004171922448979598
    },
    {
      "x": 633.85,
      "y": 252.94,
      "r": -0.004163673469387785
    },
    {
      "x": 634.22,
      "y": 253.08,
      "r": -0.004040918367346935
    },
    {
      "x": 634.22,
      "y": 253.08,
      "r": -0.004040918367346935
    },
    {
      "x": 634.61,
      "y": 253.23,
      "r": -0.0039120040816326695
    },
    {
      "x": 634.63,
      "y": 253.24,
      "r": -0.0039040163265306183
    },
    {
      "x": 635.02,
      "y": 253.39,
      "r": -0.003777322448979603
    },
    {
      "x": 635.02,
      "y": 253.39,
      "r": -0.003777322448979603
    },
    {
      "x": 635.44,
      "y": 253.55,
      "r": -0.0036450000000000093
    },
    {
      "x": 635.44,
      "y": 253.55,
      "r": -0.0036450000000000093
    },
    {
      "x": 635.82,
      "y": 253.7,
      "r": -0.0035226163265305865
    },
    {
      "x": 635.85,
      "y": 253.71,
      "r": -0.0035150367346938882
    },
    {
      "x": 636.24,
      "y": 253.86,
      "r": -0.0033948734693877436
    },
    {
      "x": 636.26,
      "y": 253.87,
      "r": -0.0033874326530612398
    },
    {
      "x": 636.65,
      "y": 254.02,
      "r": -0.0032694897959183733
    },
    {
      "x": 636.65,
      "y": 254.02,
      "r": -0.0032694897959183733
    },
    {
      "x": 637.03,
      "y": 254.17,
      "r": -0.0031536367346938765
    },
    {
      "x": 637.06,
      "y": 254.18,
      "r": -0.003146465306122448
    },
    {
      "x": 637.45,
      "y": 254.33,
      "r": -0.003032832653061257
    },
    {
      "x": 637.45,
      "y": 254.33,
      "r": -0.003032832653061257
    },
    {
      "x": 637.86,
      "y": 254.48,
      "r": -0.0029143877551020547
    },
    {
      "x": 637.86,
      "y": 254.48,
      "r": -0.0029143877551020547
    },
    {
      "x": 638.24,
      "y": 254.63,
      "r": -0.002805065306122456
    },
    {
      "x": 638.27,
      "y": 254.64,
      "r": -0.002798302040816325
    },
    {
      "x": 638.65,
      "y": 254.79,
      "r": -0.0026912000000000047
    },
    {
      "x": 638.68,
      "y": 254.8,
      "r": -0.002684575510204096
    },
    {
      "x": 639.06,
      "y": 254.95,
      "r": -0.002579693877551026
    },
    {
      "x": 639.06,
      "y": 254.95,
      "r": -0.002579693877551026
    },
    {
      "x": 639.45,
      "y": 255.09,
      "r": -0.0024769020408163256
    },
    {
      "x": 639.47,
      "y": 255.1,
      "r": -0.0024705469387755197
    },
    {
      "x": 639.85,
      "y": 255.25,
      "r": -0.00236997551020407
    },
    {
      "x": 639.85,
      "y": 255.25,
      "r": -0.00236997551020407
    },
    {
      "x": 640.26,
      "y": 255.41,
      "r": -0.0022654081632653145
    },
    {
      "x": 640.26,
      "y": 255.41,
      "r": -0.0022654081632653145
    },
    {
      "x": 640.67,
      "y": 255.57,
      "r": -0.002163200000000004
    },
    {
      "x": 640.67,
      "y": 255.57,
      "r": -0.002163200000000004
    },
    {
      "x": 641.08,
      "y": 255.72,
      "r": -0.002063351020408166
    },
    {
      "x": 641.08,
      "y": 255.72,
      "r": -0.002063351020408166
    },
    {
      "x": 641.46,
      "y": 255.87,
      "r": -0.0019715306122449205
    },
    {
      "x": 641.46,
      "y": 255.87,
      "r": -0.0019715306122449205
    },
    {
      "x": 641.87,
      "y": 256.03,
      "r": -0.0018762612244898058
    },
    {
      "x": 641.87,
      "y": 256.03,
      "r": -0.0018762612244898058
    },
    {
      "x": 642.25,
      "y": 256.17,
      "r": -0.0017887510204081525
    },
    {
      "x": 642.27,
      "y": 256.18,
      "r": -0.0017833510204081637
    },
    {
      "x": 642.65,
      "y": 256.33,
      "r": -0.0016980612244897886
    },
    {
      "x": 642.65,
      "y": 256.33,
      "r": -0.0016980612244897886
    },
    {
      "x": 643.06,
      "y": 256.48,
      "r": -0.0016097306122448973
    },
    {
      "x": 643.06,
      "y": 256.48,
      "r": -0.0016097306122448973
    },
    {
      "x": 643.44,
      "y": 256.63,
      "r": -0.00152875102040817
    },
    {
      "x": 643.46,
      "y": 256.64,
      "r": -0.0015237591836734787
    },
    {
      "x": 643.84,
      "y": 256.79,
      "r": -0.001444999999999974
    },
    {
      "x": 643.84,
      "y": 256.79,
      "r": -0.001444999999999974
    },
    {
      "x": 644.25,
      "y": 256.94,
      "r": -0.0013636081632653063
    },
    {
      "x": 644.25,
      "y": 256.94,
      "r": -0.0013636081632653063
    },
    {
      "x": 644.62,
      "y": 257.09,
      "r": -0.0012891591836734773
    },
    {
      "x": 644.65,
      "y": 257.1,
      "r": -0.0012845755102040834
    },
    {
      "x": 645.03,
      "y": 257.24,
      "r": -0.0012123469387755326
    },
    {
      "x": 645.03,
      "y": 257.24,
      "r": -0.0012123469387755326
    },
    {
      "x": 645.43,
      "y": 257.4,
      "r": -0.001137893877551005
    },
    {
      "x": 645.43,
      "y": 257.4,
      "r": -0.001137893877551005
    },
    {
      "x": 645.81,
      "y": 257.54,
      "r": -0.001069975510204102
    },
    {
      "x": 645.83,
      "y": 257.55,
      "r": -0.0010658000000000056
    },
    {
      "x": 646.21,
      "y": 257.7,
      "r": -0.0010001020408163253
    },
    {
      "x": 646.23,
      "y": 257.71,
      "r": -0.0009960653061224511
    },
    {
      "x": 646.61,
      "y": 257.85,
      "r": -0.0009325877551020489
    },
    {
      "x": 646.61,
      "y": 257.85,
      "r": -0.0009325877551020489
    },
    {
      "x": 646.99,
      "y": 258,
      "r": -0.0008712000000000164
    },
    {
      "x": 647.01,
      "y": 258,
      "r": -0.0008674326530612175
    },
    {
      "x": 647.39,
      "y": 258.15,
      "r": -0.0008082653061224632
    },
    {
      "x": 647.39,
      "y": 258.15,
      "r": -0.0008082653061224632
    },
    {
      "x": 647.79,
      "y": 258.3,
      "r": -0.0007476897959183826
    },
    {
      "x": 647.79,
      "y": 258.3,
      "r": -0.0007476897959183826
    },
    {
      "x": 648.16,
      "y": 258.45,
      "r": -0.0006928326530612205
    },
    {
      "x": 648.19,
      "y": 258.46,
      "r": -0.0006894734693877747
    },
    {
      "x": 648.56,
      "y": 258.6,
      "r": -0.0006368367346938908
    },
    {
      "x": 648.56,
      "y": 258.6,
      "r": -0.0006368367346938908
    },
    {
      "x": 648.96,
      "y": 258.75,
      "r": -0.0005832000000000059
    },
    {
      "x": 648.96,
      "y": 258.75,
      "r": -0.0005832000000000059
    },
    {
      "x": 649.33,
      "y": 258.9,
      "r": -0.0005348734693877699
    },
    {
      "x": 649.36,
      "y": 258.91,
      "r": -0.0005319224489795937
    },
    {
      "x": 649.73,
      "y": 259.05,
      "r": -0.00048581632653060813
    },
    {
      "x": 649.73,
      "y": 259.05,
      "r": -0.00048581632653060813
    },
    {
      "x": 650.13,
      "y": 259.2,
      "r": -0.00043911836734694676
    },
    {
      "x": 650.13,
      "y": 259.2,
      "r": -0.00043911836734694676
    },
    {
      "x": 650.53,
      "y": 259.36,
      "r": -0.0003947795918367303
    },
    {
      "x": 650.53,
      "y": 259.36,
      "r": -0.0003947795918367303
    },
    {
      "x": 650.9,
      "y": 259.5,
      "r": -0.00035520408163264294
    },
    {
      "x": 650.92,
      "y": 259.51,
      "r": -0.00035279999999998646
    },
    {
      "x": 651.29,
      "y": 259.65,
      "r": -0.0003154448979591773
    },
    {
      "x": 651.29,
      "y": 259.65,
      "r": -0.0003154448979591773
    },
    {
      "x": 651.69,
      "y": 259.8,
      "r": -0.0002780448979591843
    },
    {
      "x": 651.69,
      "y": 259.8,
      "r": -0.0002780448979591843
    },
    {
      "x": 652.06,
      "y": 259.95,
      "r": -0.0002449999999999952
    },
    {
      "x": 652.06,
      "y": 259.95,
      "r": -0.0002449999999999952
    },
    {
      "x": 652.46,
      "y": 260.1,
      "r": -0.00021217959183675306
    },
    {
      "x": 652.46,
      "y": 260.1,
      "r": -0.00021217959183675306
    },
    {
      "x": 652.85,
      "y": 260.25,
      "r": -0.00018171836734692803
    },
    {
      "x": 652.85,
      "y": 260.25,
      "r": -0.00018171836734692803
    },
    {
      "x": 653.22,
      "y": 260.39,
      "r": -0.00015520408163266497
    },
    {
      "x": 653.24,
      "y": 260.4,
      "r": -0.00015361632653060342
    },
    {
      "x": 653.61,
      "y": 260.54,
      "r": -0.00012932244897959078
    },
    {
      "x": 653.61,
      "y": 260.54,
      "r": -0.00012932244897959078
    },
    {
      "x": 654.01,
      "y": 260.69,
      "r": -0.00010579999999998924
    },
    {
      "x": 654.01,
      "y": 260.69,
      "r": -0.00010579999999998924
    },
    {
      "x": 654.38,
      "y": 260.84,
      "r": -0.00008581632653062443
    },
    {
      "x": 654.4,
      "y": 260.85,
      "r": -0.0000846367346938881
    },
    {
      "x": 654.77,
      "y": 260.99,
      "r": -0.00006687346938777372
    },
    {
      "x": 654.77,
      "y": 260.99,
      "r": -0.00006687346938777372
    },
    {
      "x": 655.16,
      "y": 261.14,
      "r": -0.00005028979591836791
    },
    {
      "x": 655.16,
      "y": 261.14,
      "r": -0.00005028979591836791
    },
    {
      "x": 655.53,
      "y": 261.28,
      "r": -0.00003683673469387361
    },
    {
      "x": 655.55,
      "y": 261.29,
      "r": -0.000036065306122462504
    },
    {
      "x": 655.92,
      "y": 261.43,
      "r": -0.000024832653061218624
    },
    {
      "x": 655.92,
      "y": 261.43,
      "r": -0.000024832653061218624
    },
    {
      "x": 656.31,
      "y": 261.58,
      "r": -0.000015187755102036293
    },
    {
      "x": 656.31,
      "y": 261.58,
      "r": -0.000015187755102036293
    },
    {
      "x": 656.68,
      "y": 261.72,
      "r": -0.000008265306122468008
    },
    {
      "x": 656.7,
      "y": 261.73,
      "r": -0.000007902040816326616
    },
    {
      "x": 657.09,
      "y": 261.88,
      "r": -0.0000029755102040618375
    },
    {
      "x": 657.11,
      "y": 261.89,
      "r": -0.0000027591836734841557
    },
    {
      "x": 657.45,
      "y": 262.02,
      "r": -4.938775510221483e-7
    },
    {
      "x": 657.48,
      "y": 262.03,
      "r": -4.081632652974676e-7
    },
    {
      "x": 657.84,
      "y": 262.17,
      "r": 0
    },
    {
      "x": 657.84,
      "y": 262.17,
      "r": 0
    },
    {
      "x": 658.21,
      "y": 262.31,
      "r": 0
    },
    {
      "x": 658.21,
      "y": 262.31,
      "r": 0
    },
    {
      "x": 658.59,
      "y": 262.46,
      "r": 0
    },
    {
      "x": 658.59,
      "y": 262.46,
      "r": 0
    },
    {
      "x": 658.98,
      "y": 262.61,
      "r": 0
    },
    {
      "x": 658.98,
      "y": 262.61,
      "r": 0
    },
    {
      "x": 659.35,
      "y": 262.75,
      "r": 0
    },
    {
      "x": 659.35,
      "y": 262.75,
      "r": 0
    },
    {
      "x": 659.73,
      "y": 262.9,
      "r": 0
    },
    {
      "x": 659.75,
      "y": 262.91,
      "r": 0
    },
    {
      "x": 660.12,
      "y": 263.05,
      "r": 0
    },
    {
      "x": 660.12,
      "y": 263.05,
      "r": 0
    },
    {
      "x": 660.48,
      "y": 263.18,
      "r": 0
    },
    {
      "x": 660.5,
      "y": 263.19,
      "r": 0
    },
    {
      "x": 660.87,
      "y": 263.33,
      "r": 0
    },
    {
      "x": 660.87,
      "y": 263.33,
      "r": 0
    },
    {
      "x": 661.25,
      "y": 263.48,
      "r": 0
    },
    {
      "x": 661.25,
      "y": 263.48,
      "r": 0
    },
    {
      "x": 661.61,
      "y": 263.62,
      "r": 0
    },
    {
      "x": 661.63,
      "y": 263.63,
      "r": 0
    },
    {
      "x": 662.02,
      "y": 263.78,
      "r": 0
    },
    {
      "x": 662.02,
      "y": 263.78,
      "r": 0
    },
    {
      "x": 662.38,
      "y": 263.91,
      "r": 0
    },
    {
      "x": 662.38,
      "y": 263.91,
      "r": 0
    },
    {
      "x": 662.74,
      "y": 264.05,
      "r": 0
    },
    {
      "x": 662.76,
      "y": 264.06,
      "r": 0
    },
    {
      "x": 663.12,
      "y": 264.2,
      "r": 0
    },
    {
      "x": 663.12,
      "y": 264.2,
      "r": 0
    },
    {
      "x": 663.5,
      "y": 264.35,
      "r": 0
    },
    {
      "x": 663.5,
      "y": 264.35,
      "r": 0
    },
    {
      "x": 663.86,
      "y": 264.49,
      "r": 0
    },
    {
      "x": 663.88,
      "y": 264.49,
      "r": 0
    },
    {
      "x": 664.24,
      "y": 264.63,
      "r": 0
    },
    {
      "x": 664.27,
      "y": 264.64,
      "r": 0
    },
    {
      "x": 664.62,
      "y": 264.78,
      "r": 0
    },
    {
      "x": 664.62,
      "y": 264.78,
      "r": 0
    },
    {
      "x": 664.98,
      "y": 264.92,
      "r": 0
    },
    {
      "x": 665,
      "y": 264.92,
      "r": 0
    },
    {
      "x": 665.36,
      "y": 265.06,
      "r": 0
    },
    {
      "x": 665.36,
      "y": 265.06,
      "r": 0
    },
    {
      "x": 665.74,
      "y": 265.21,
      "r": 0
    },
    {
      "x": 665.74,
      "y": 265.21,
      "r": 0
    },
    {
      "x": 666.1,
      "y": 265.35,
      "r": 0
    },
    {
      "x": 666.12,
      "y": 265.35,
      "r": 0
    },
    {
      "x": 666.48,
      "y": 265.49,
      "r": 0
    },
    {
      "x": 666.5,
      "y": 265.5,
      "r": 0
    },
    {
      "x": 666.85,
      "y": 265.64,
      "r": 0
    },
    {
      "x": 666.85,
      "y": 265.64,
      "r": 0
    },
    {
      "x": 667.21,
      "y": 265.77,
      "r": 0
    },
    {
      "x": 667.23,
      "y": 265.78,
      "r": 0
    },
    {
      "x": 667.59,
      "y": 265.92,
      "r": 0
    },
    {
      "x": 667.61,
      "y": 265.93,
      "r": 0
    },
    {
      "x": 667.96,
      "y": 266.06,
      "r": 0
    },
    {
      "x": 667.96,
      "y": 266.06,
      "r": 0
    },
    {
      "x": 668.34,
      "y": 266.21,
      "r": 0
    },
    {
      "x": 668.34,
      "y": 266.21,
      "r": 0
    },
    {
      "x": 668.72,
      "y": 266.35,
      "r": 0
    },
    {
      "x": 668.74,
      "y": 266.36,
      "r": 0
    },
    {
      "x": 669.07,
      "y": 266.49,
      "r": 0
    },
    {
      "x": 669.07,
      "y": 266.49,
      "r": 0
    },
    {
      "x": 669.44,
      "y": 266.63,
      "r": 0
    },
    {
      "x": 669.44,
      "y": 266.63,
      "r": 0
    },
    {
      "x": 669.8,
      "y": 266.77,
      "r": 0
    },
    {
      "x": 669.82,
      "y": 266.78,
      "r": 0
    },
    {
      "x": 670.17,
      "y": 266.91,
      "r": 0
    },
    {
      "x": 670.17,
      "y": 266.91,
      "r": 0
    },
    {
      "x": 670.55,
      "y": 267.06,
      "r": 0
    },
    {
      "x": 670.55,
      "y": 267.06,
      "r": 0
    },
    {
      "x": 670.9,
      "y": 267.19,
      "r": 0
    },
    {
      "x": 670.92,
      "y": 267.2,
      "r": 0
    },
    {
      "x": 671.27,
      "y": 267.33,
      "r": 0
    },
    {
      "x": 671.27,
      "y": 267.33,
      "r": 0
    },
    {
      "x": 671.64,
      "y": 267.48,
      "r": 0
    },
    {
      "x": 671.64,
      "y": 267.48,
      "r": 0
    },
    {
      "x": 671.99,
      "y": 267.61,
      "r": 0
    },
    {
      "x": 672.01,
      "y": 267.62,
      "r": 0
    },
    {
      "x": 672.36,
      "y": 267.76,
      "r": 0
    },
    {
      "x": 672.36,
      "y": 267.76,
      "r": 0
    },
    {
      "x": 672.73,
      "y": 267.9,
      "r": 0
    },
    {
      "x": 672.73,
      "y": 267.9,
      "r": 0
    },
    {
      "x": 673.08,
      "y": 268.03,
      "r": 0
    },
    {
      "x": 673.11,
      "y": 268.04,
      "r": 0
    },
    {
      "x": 673.45,
      "y": 268.17,
      "r": 0
    },
    {
      "x": 673.45,
      "y": 268.17,
      "r": 0
    },
    {
      "x": 673.82,
      "y": 268.32,
      "r": 0
    },
    {
      "x": 673.82,
      "y": 268.32,
      "r": 0
    },
    {
      "x": 674.17,
      "y": 268.45,
      "r": 0
    },
    {
      "x": 674.19,
      "y": 268.46,
      "r": 0
    },
    {
      "x": 674.54,
      "y": 268.59,
      "r": 0
    },
    {
      "x": 674.54,
      "y": 268.59,
      "r": 0
    },
    {
      "x": 674.91,
      "y": 268.73,
      "r": 0
    },
    {
      "x": 674.91,
      "y": 268.73,
      "r": 0
    },
    {
      "x": 675.26,
      "y": 268.87,
      "r": 0
    },
    {
      "x": 675.28,
      "y": 268.88,
      "r": 0
    },
    {
      "x": 675.62,
      "y": 269.01,
      "r": 0
    },
    {
      "x": 675.62,
      "y": 269.01,
      "r": 0
    },
    {
      "x": 675.99,
      "y": 269.15,
      "r": 0
    },
    {
      "x": 675.99,
      "y": 269.15,
      "r": 0
    },
    {
      "x": 676.36,
      "y": 269.29,
      "r": 0
    },
    {
      "x": 676.36,
      "y": 269.29,
      "r": 0
    },
    {
      "x": 676.7,
      "y": 269.42,
      "r": 0
    },
    {
      "x": 676.7,
      "y": 269.42,
      "r": 0
    },
    {
      "x": 677.07,
      "y": 269.56,
      "r": 0
    },
    {
      "x": 677.07,
      "y": 269.56,
      "r": 0
    },
    {
      "x": 677.43,
      "y": 269.71,
      "r": 0
    },
    {
      "x": 677.43,
      "y": 269.71,
      "r": 0
    },
    {
      "x": 677.78,
      "y": 269.84,
      "r": 0
    },
    {
      "x": 677.8,
      "y": 269.85,
      "r": 0
    },
    {
      "x": 678.14,
      "y": 269.98,
      "r": 0
    },
    {
      "x": 678.14,
      "y": 269.98,
      "r": 0
    },
    {
      "x": 678.51,
      "y": 270.12,
      "r": 0
    },
    {
      "x": 678.51,
      "y": 270.12,
      "r": 0
    },
    {
      "x": 678.85,
      "y": 270.25,
      "r": 0
    },
    {
      "x": 678.87,
      "y": 270.26,
      "r": 0
    },
    {
      "x": 679.21,
      "y": 270.39,
      "r": 0
    },
    {
      "x": 679.21,
      "y": 270.39,
      "r": 0
    },
    {
      "x": 679.58,
      "y": 270.53,
      "r": 0
    },
    {
      "x": 679.58,
      "y": 270.53,
      "r": 0
    },
    {
      "x": 679.94,
      "y": 270.67,
      "r": 0
    },
    {
      "x": 679.94,
      "y": 270.67,
      "r": 0
    },
    {
      "x": 680.28,
      "y": 270.8,
      "r": 0
    },
    {
      "x": 680.28,
      "y": 270.8,
      "r": 0
    },
    {
      "x": 680.64,
      "y": 270.94,
      "r": 0
    },
    {
      "x": 680.64,
      "y": 270.94,
      "r": 0
    },
    {
      "x": 680.98,
      "y": 271.07,
      "r": 0
    },
    {
      "x": 681,
      "y": 271.08,
      "r": 0
    },
    {
      "x": 681.34,
      "y": 271.21,
      "r": 0
    },
    {
      "x": 681.34,
      "y": 271.21,
      "r": 0
    },
    {
      "x": 681.7,
      "y": 271.35,
      "r": 0
    },
    {
      "x": 681.7,
      "y": 271.35,
      "r": 0
    },
    {
      "x": 682.04,
      "y": 271.48,
      "r": 0
    },
    {
      "x": 682.06,
      "y": 271.49,
      "r": 0
    },
    {
      "x": 682.4,
      "y": 271.62,
      "r": 0
    },
    {
      "x": 682.4,
      "y": 271.62,
      "r": 0
    },
    {
      "x": 682.76,
      "y": 271.75,
      "r": 0
    },
    {
      "x": 682.76,
      "y": 271.75,
      "r": 0
    },
    {
      "x": 683.1,
      "y": 271.88,
      "r": 0
    },
    {
      "x": 683.12,
      "y": 271.89,
      "r": 0
    },
    {
      "x": 683.45,
      "y": 272.02,
      "r": 0
    },
    {
      "x": 683.45,
      "y": 272.02,
      "r": 0
    },
    {
      "x": 683.81,
      "y": 272.16,
      "r": 0
    },
    {
      "x": 683.81,
      "y": 272.16,
      "r": 0
    },
    {
      "x": 684.15,
      "y": 272.29,
      "r": 0
    },
    {
      "x": 684.17,
      "y": 272.3,
      "r": 0
    },
    {
      "x": 684.51,
      "y": 272.43,
      "r": 0
    },
    {
      "x": 684.51,
      "y": 272.43,
      "r": 0
    },
    {
      "x": 684.86,
      "y": 272.56,
      "r": 0
    },
    {
      "x": 684.86,
      "y": 272.56,
      "r": 0
    },
    {
      "x": 685.2,
      "y": 272.69,
      "r": 0
    },
    {
      "x": 685.22,
      "y": 272.7,
      "r": 0
    },
    {
      "x": 685.55,
      "y": 272.83,
      "r": 0
    },
    {
      "x": 685.55,
      "y": 272.83,
      "r": 0
    },
    {
      "x": 685.91,
      "y": 272.96,
      "r": 0
    },
    {
      "x": 685.91,
      "y": 272.96,
      "r": 0
    },
    {
      "x": 686.26,
      "y": 273.1,
      "r": 0
    },
    {
      "x": 686.26,
      "y": 273.1,
      "r": 0
    },
    {
      "x": 686.6,
      "y": 273.23,
      "r": 0
    },
    {
      "x": 686.62,
      "y": 273.24,
      "r": 0
    },
    {
      "x": 686.95,
      "y": 273.37,
      "r": 0
    },
    {
      "x": 686.95,
      "y": 273.37,
      "r": 0
    },
    {
      "x": 687.3,
      "y": 273.5,
      "r": 0
    },
    {
      "x": 687.3,
      "y": 273.5,
      "r": 0
    },
    {
      "x": 687.64,
      "y": 273.63,
      "r": 0
    },
    {
      "x": 687.66,
      "y": 273.64,
      "r": 0
    },
    {
      "x": 687.99,
      "y": 273.76,
      "r": 0
    },
    {
      "x": 688.01,
      "y": 273.77,
      "r": 0
    },
    {
      "x": 688.34,
      "y": 273.9,
      "r": 0
    },
    {
      "x": 688.34,
      "y": 273.9,
      "r": 0
    },
    {
      "x": 688.67,
      "y": 274.03,
      "r": 0
    },
    {
      "x": 688.69,
      "y": 274.04,
      "r": 0
    },
    {
      "x": 689.02,
      "y": 274.16,
      "r": 0
    },
    {
      "x": 689.02,
      "y": 274.16,
      "r": 0
    },
    {
      "x": 689.37,
      "y": 274.3,
      "r": 0
    },
    {
      "x": 689.37,
      "y": 274.3,
      "r": 0
    },
    {
      "x": 689.7,
      "y": 274.42,
      "r": 0
    },
    {
      "x": 689.72,
      "y": 274.43,
      "r": 0
    },
    {
      "x": 690.05,
      "y": 274.56,
      "r": 0
    },
    {
      "x": 690.07,
      "y": 274.57,
      "r": 0
    },
    {
      "x": 690.4,
      "y": 274.69,
      "r": 0
    },
    {
      "x": 690.4,
      "y": 274.69,
      "r": 0
    },
    {
      "x": 690.73,
      "y": 274.82,
      "r": 0
    },
    {
      "x": 690.75,
      "y": 274.83,
      "r": 0
    },
    {
      "x": 691.08,
      "y": 274.95,
      "r": 0
    },
    {
      "x": 691.08,
      "y": 274.95,
      "r": 0
    },
    {
      "x": 691.43,
      "y": 275.09,
      "r": 0
    },
    {
      "x": 691.43,
      "y": 275.09,
      "r": 0
    },
    {
      "x": 691.76,
      "y": 275.21,
      "r": 0
    },
    {
      "x": 691.78,
      "y": 275.22,
      "r": 0
    },
    {
      "x": 692.1,
      "y": 275.35,
      "r": 0
    },
    {
      "x": 692.12,
      "y": 275.36,
      "r": 0
    },
    {
      "x": 692.45,
      "y": 275.48,
      "r": 0
    },
    {
      "x": 692.45,
      "y": 275.48,
      "r": 0
    },
    {
      "x": 692.78,
      "y": 275.61,
      "r": 0
    },
    {
      "x": 692.8,
      "y": 275.61,
      "r": 0
    },
    {
      "x": 693.12,
      "y": 275.74,
      "r": 0
    },
    {
      "x": 693.12,
      "y": 275.74,
      "r": 0
    },
    {
      "x": 693.47,
      "y": 275.87,
      "r": 0
    },
    {
      "x": 693.47,
      "y": 275.87,
      "r": 0
    },
    {
      "x": 693.81,
      "y": 276.01,
      "r": 0
    },
    {
      "x": 693.81,
      "y": 276.01,
      "r": 0
    },
    {
      "x": 694.16,
      "y": 276.14,
      "r": 0
    },
    {
      "x": 694.18,
      "y": 276.15,
      "r": 0
    },
    {
      "x": 694.48,
      "y": 276.26,
      "r": 0
    },
    {
      "x": 694.48,
      "y": 276.26,
      "r": 0
    },
    {
      "x": 694.83,
      "y": 276.39,
      "r": 0
    },
    {
      "x": 694.83,
      "y": 276.39,
      "r": 0
    },
    {
      "x": 695.15,
      "y": 276.52,
      "r": 0
    },
    {
      "x": 695.17,
      "y": 276.53,
      "r": 0
    },
    {
      "x": 695.49,
      "y": 276.65,
      "r": 0
    },
    {
      "x": 695.49,
      "y": 276.65,
      "r": 0
    },
    {
      "x": 695.84,
      "y": 276.78,
      "r": 0
    },
    {
      "x": 695.84,
      "y": 276.78,
      "r": 0
    },
    {
      "x": 696.16,
      "y": 276.91,
      "r": 0
    },
    {
      "x": 696.18,
      "y": 276.91,
      "r": 0
    },
    {
      "x": 696.5,
      "y": 277.04,
      "r": 0
    },
    {
      "x": 696.5,
      "y": 277.04,
      "r": 0
    },
    {
      "x": 696.84,
      "y": 277.17,
      "r": 0
    },
    {
      "x": 696.84,
      "y": 277.17,
      "r": 0
    },
    {
      "x": 697.16,
      "y": 277.29,
      "r": 0
    },
    {
      "x": 697.18,
      "y": 277.3,
      "r": 0
    },
    {
      "x": 697.5,
      "y": 277.42,
      "r": 0
    },
    {
      "x": 697.5,
      "y": 277.42,
      "r": 0
    },
    {
      "x": 697.84,
      "y": 277.55,
      "r": 0
    },
    {
      "x": 697.84,
      "y": 277.55,
      "r": 0
    },
    {
      "x": 698.16,
      "y": 277.68,
      "r": 0
    },
    {
      "x": 698.18,
      "y": 277.69,
      "r": 0
    },
    {
      "x": 698.5,
      "y": 277.81,
      "r": 0
    },
    {
      "x": 698.5,
      "y": 277.81,
      "r": 0
    },
    {
      "x": 698.84,
      "y": 277.94,
      "r": 0
    },
    {
      "x": 698.84,
      "y": 277.94,
      "r": 0
    },
    {
      "x": 699.16,
      "y": 278.06,
      "r": 0
    },
    {
      "x": 699.18,
      "y": 278.07,
      "r": 0
    },
    {
      "x": 699.5,
      "y": 278.19,
      "r": 0
    },
    {
      "x": 699.5,
      "y": 278.19,
      "r": 0
    },
    {
      "x": 699.83,
      "y": 278.32,
      "r": 0
    },
    {
      "x": 699.83,
      "y": 278.32,
      "r": 0
    },
    {
      "x": 700.15,
      "y": 278.44,
      "r": 0
    },
    {
      "x": 700.17,
      "y": 278.45,
      "r": 0
    },
    {
      "x": 700.51,
      "y": 278.58,
      "r": 0
    },
    {
      "x": 700.51,
      "y": 278.58,
      "r": 0
    },
    {
      "x": 700.82,
      "y": 278.7,
      "r": 0
    },
    {
      "x": 700.82,
      "y": 278.7,
      "r": 0
    },
    {
      "x": 701.14,
      "y": 278.82,
      "r": 0
    },
    {
      "x": 701.16,
      "y": 278.83,
      "r": 0
    },
    {
      "x": 701.47,
      "y": 278.95,
      "r": 0
    },
    {
      "x": 701.47,
      "y": 278.95,
      "r": 0
    },
    {
      "x": 701.81,
      "y": 279.08,
      "r": 0
    },
    {
      "x": 701.81,
      "y": 279.08,
      "r": 0
    },
    {
      "x": 702.14,
      "y": 279.21,
      "r": 0
    },
    {
      "x": 702.14,
      "y": 279.21,
      "r": 0
    },
    {
      "x": 702.46,
      "y": 279.33,
      "r": 0
    },
    {
      "x": 702.48,
      "y": 279.34,
      "r": 0
    },
    {
      "x": 702.79,
      "y": 279.46,
      "r": 0
    },
    {
      "x": 702.79,
      "y": 279.46,
      "r": 0
    },
    {
      "x": 703.13,
      "y": 279.59,
      "r": 0
    },
    {
      "x": 703.13,
      "y": 279.59,
      "r": 0
    },
    {
      "x": 703.44,
      "y": 279.71,
      "r": 0
    },
    {
      "x": 703.46,
      "y": 279.71,
      "r": 0
    },
    {
      "x": 703.77,
      "y": 279.83,
      "r": 0
    },
    {
      "x": 703.77,
      "y": 279.83,
      "r": 0
    },
    {
      "x": 704.1,
      "y": 279.96,
      "r": 0
    },
    {
      "x": 704.1,
      "y": 279.96,
      "r": 0
    },
    {
      "x": 704.41,
      "y": 280.08,
      "r": 0
    },
    {
      "x": 704.43,
      "y": 280.09,
      "r": 0
    },
    {
      "x": 704.75,
      "y": 280.21,
      "r": 0
    },
    {
      "x": 704.75,
      "y": 280.21,
      "r": 0
    },
    {
      "x": 705.08,
      "y": 280.34,
      "r": 0
    },
    {
      "x": 705.08,
      "y": 280.34,
      "r": 0
    },
    {
      "x": 705.39,
      "y": 280.46,
      "r": 0
    },
    {
      "x": 705.41,
      "y": 280.46,
      "r": 0
    },
    {
      "x": 705.72,
      "y": 280.58,
      "r": 0
    },
    {
      "x": 705.72,
      "y": 280.58,
      "r": 0
    },
    {
      "x": 706.05,
      "y": 280.71,
      "r": 0
    },
    {
      "x": 706.05,
      "y": 280.71,
      "r": 0
    },
    {
      "x": 706.36,
      "y": 280.83,
      "r": 0
    },
    {
      "x": 706.37,
      "y": 280.84,
      "r": 0
    },
    {
      "x": 706.68,
      "y": 280.96,
      "r": 0
    },
    {
      "x": 706.68,
      "y": 280.96,
      "r": 0
    },
    {
      "x": 707.01,
      "y": 281.08,
      "r": 0
    },
    {
      "x": 707.05,
      "y": 281.1,
      "r": 0
    },
    {
      "x": 707.32,
      "y": 281.2,
      "r": 0
    },
    {
      "x": 707.34,
      "y": 281.21,
      "r": 0
    },
    {
      "x": 707.65,
      "y": 281.33,
      "r": 0
    },
    {
      "x": 707.65,
      "y": 281.33,
      "r": 0
    },
    {
      "x": 707.97,
      "y": 281.45,
      "r": 0
    },
    {
      "x": 707.99,
      "y": 281.46,
      "r": 0
    },
    {
      "x": 708.28,
      "y": 281.57,
      "r": 0
    },
    {
      "x": 708.3,
      "y": 281.58,
      "r": 0
    },
    {
      "x": 708.61,
      "y": 281.69,
      "r": 0
    },
    {
      "x": 708.61,
      "y": 281.69,
      "r": 0
    },
    {
      "x": 708.93,
      "y": 281.82,
      "r": 0
    },
    {
      "x": 708.93,
      "y": 281.82,
      "r": 0
    },
    {
      "x": 709.24,
      "y": 281.94,
      "r": 0
    },
    {
      "x": 709.26,
      "y": 281.94,
      "r": 0
    },
    {
      "x": 709.56,
      "y": 282.06,
      "r": 0
    },
    {
      "x": 709.58,
      "y": 282.07,
      "r": 0
    },
    {
      "x": 709.89,
      "y": 282.19,
      "r": 0
    },
    {
      "x": 709.91,
      "y": 282.19,
      "r": 0
    },
    {
      "x": 710.21,
      "y": 282.31,
      "r": 0
    },
    {
      "x": 710.21,
      "y": 282.31,
      "r": 0
    },
    {
      "x": 710.51,
      "y": 282.43,
      "r": 0
    },
    {
      "x": 710.51,
      "y": 282.43,
      "r": 0
    },
    {
      "x": 710.84,
      "y": 282.55,
      "r": 0
    },
    {
      "x": 710.84,
      "y": 282.55,
      "r": 0
    },
    {
      "x": 711.16,
      "y": 282.68,
      "r": 0
    },
    {
      "x": 711.16,
      "y": 282.68,
      "r": 0
    },
    {
      "x": 711.46,
      "y": 282.79,
      "r": 0
    },
    {
      "x": 711.48,
      "y": 282.8,
      "r": 0
    },
    {
      "x": 711.78,
      "y": 282.92,
      "r": 0
    },
    {
      "x": 711.8,
      "y": 282.92,
      "r": 0
    },
    {
      "x": 712.1,
      "y": 283.04,
      "r": 0
    },
    {
      "x": 712.1,
      "y": 283.04,
      "r": 0
    },
    {
      "x": 712.41,
      "y": 283.16,
      "r": 0
    },
    {
      "x": 712.43,
      "y": 283.16,
      "r": 0
    },
    {
      "x": 712.73,
      "y": 283.28,
      "r": 0
    },
    {
      "x": 712.73,
      "y": 283.28,
      "r": 0
    },
    {
      "x": 713.05,
      "y": 283.4,
      "r": 0
    },
    {
      "x": 713.05,
      "y": 283.4,
      "r": 0
    },
    {
      "x": 713.35,
      "y": 283.52,
      "r": 0
    },
    {
      "x": 713.37,
      "y": 283.53,
      "r": 0
    },
    {
      "x": 713.67,
      "y": 283.64,
      "r": 0
    },
    {
      "x": 713.68,
      "y": 283.65,
      "r": 0
    },
    {
      "x": 713.98,
      "y": 283.76,
      "r": 0
    },
    {
      "x": 713.98,
      "y": 283.76,
      "r": 0
    },
    {
      "x": 714.28,
      "y": 283.88,
      "r": 0
    },
    {
      "x": 714.3,
      "y": 283.89,
      "r": 0
    },
    {
      "x": 714.6,
      "y": 284,
      "r": 0
    },
    {
      "x": 714.6,
      "y": 284,
      "r": 0
    },
    {
      "x": 714.92,
      "y": 284.12,
      "r": 0
    },
    {
      "x": 714.92,
      "y": 284.12,
      "r": 0
    },
    {
      "x": 715.22,
      "y": 284.24,
      "r": 0
    },
    {
      "x": 715.24,
      "y": 284.24,
      "r": 0
    },
    {
      "x": 715.53,
      "y": 284.36,
      "r": 0
    },
    {
      "x": 715.55,
      "y": 284.37,
      "r": 0
    },
    {
      "x": 715.85,
      "y": 284.48,
      "r": 0
    },
    {
      "x": 715.85,
      "y": 284.48,
      "r": 0
    },
    {
      "x": 716.15,
      "y": 284.59,
      "r": 0
    },
    {
      "x": 716.16,
      "y": 284.6,
      "r": 0
    },
    {
      "x": 716.46,
      "y": 284.72,
      "r": 0
    },
    {
      "x": 716.48,
      "y": 284.72,
      "r": 0
    },
    {
      "x": 716.78,
      "y": 284.84,
      "r": 0
    },
    {
      "x": 716.79,
      "y": 284.84,
      "r": 0
    },
    {
      "x": 717.09,
      "y": 284.96,
      "r": 0
    },
    {
      "x": 717.09,
      "y": 284.96,
      "r": 0
    },
    {
      "x": 717.42,
      "y": 285.09,
      "r": 0
    },
    {
      "x": 717.44,
      "y": 285.09,
      "r": 0
    },
    {
      "x": 717.7,
      "y": 285.19,
      "r": 0
    },
    {
      "x": 717.7,
      "y": 285.19,
      "r": 0
    },
    {
      "x": 718.01,
      "y": 285.31,
      "r": 0
    },
    {
      "x": 718.01,
      "y": 285.31,
      "r": 0
    },
    {
      "x": 718.3,
      "y": 285.42,
      "r": 0
    },
    {
      "x": 718.32,
      "y": 285.43,
      "r": 0
    },
    {
      "x": 718.62,
      "y": 285.54,
      "r": 0
    },
    {
      "x": 718.62,
      "y": 285.54,
      "r": 0
    },
    {
      "x": 718.93,
      "y": 285.66,
      "r": 0
    },
    {
      "x": 718.93,
      "y": 285.66,
      "r": 0
    },
    {
      "x": 719.22,
      "y": 285.78,
      "r": 0
    },
    {
      "x": 719.24,
      "y": 285.78,
      "r": 0
    },
    {
      "x": 719.53,
      "y": 285.9,
      "r": 0
    },
    {
      "x": 719.55,
      "y": 285.9,
      "r": 0
    },
    {
      "x": 719.84,
      "y": 286.02,
      "r": 0
    },
    {
      "x": 719.84,
      "y": 286.02,
      "r": 0
    },
    {
      "x": 720.13,
      "y": 286.13,
      "r": 0
    },
    {
      "x": 720.15,
      "y": 286.14,
      "r": 0
    },
    {
      "x": 720.44,
      "y": 286.25,
      "r": 0
    },
    {
      "x": 720.44,
      "y": 286.25,
      "r": 0
    },
    {
      "x": 720.75,
      "y": 286.37,
      "r": 0
    },
    {
      "x": 720.75,
      "y": 286.37,
      "r": 0
    },
    {
      "x": 721.04,
      "y": 286.48,
      "r": 0
    },
    {
      "x": 721.06,
      "y": 286.48,
      "r": 0
    },
    {
      "x": 721.35,
      "y": 286.6,
      "r": 0
    },
    {
      "x": 721.37,
      "y": 286.6,
      "r": 0
    },
    {
      "x": 721.66,
      "y": 286.71,
      "r": 0
    },
    {
      "x": 721.66,
      "y": 286.71,
      "r": 0
    },
    {
      "x": 721.95,
      "y": 286.83,
      "r": 0
    },
    {
      "x": 721.97,
      "y": 286.83,
      "r": 0
    },
    {
      "x": 722.25,
      "y": 286.94,
      "r": 0
    },
    {
      "x": 722.27,
      "y": 286.95,
      "r": 0
    },
    {
      "x": 722.56,
      "y": 287.06,
      "r": 0
    },
    {
      "x": 722.56,
      "y": 287.06,
      "r": 0
    },
    {
      "x": 722.85,
      "y": 287.17,
      "r": 0
    },
    {
      "x": 722.87,
      "y": 287.18,
      "r": 0
    },
    {
      "x": 723.15,
      "y": 287.29,
      "r": 0
    },
    {
      "x": 723.15,
      "y": 287.29,
      "r": 0
    },
    {
      "x": 723.46,
      "y": 287.41,
      "r": 0
    },
    {
      "x": 723.46,
      "y": 287.41,
      "r": 0
    },
    {
      "x": 723.75,
      "y": 287.52,
      "r": 0
    },
    {
      "x": 723.76,
      "y": 287.52,
      "r": 0
    },
    {
      "x": 724.05,
      "y": 287.63,
      "r": 0
    },
    {
      "x": 724.05,
      "y": 287.63,
      "r": 0
    },
    {
      "x": 724.35,
      "y": 287.75,
      "r": 0
    },
    {
      "x": 724.35,
      "y": 287.75,
      "r": 0
    },
    {
      "x": 724.64,
      "y": 287.86,
      "r": 0
    },
    {
      "x": 724.66,
      "y": 287.87,
      "r": 0
    },
    {
      "x": 724.94,
      "y": 287.98,
      "r": 0
    },
    {
      "x": 724.96,
      "y": 287.98,
      "r": 0
    },
    {
      "x": 725.24,
      "y": 288.09,
      "r": 0
    },
    {
      "x": 725.24,
      "y": 288.09,
      "r": 0
    },
    {
      "x": 725.55,
      "y": 288.21,
      "r": 0
    },
    {
      "x": 725.55,
      "y": 288.21,
      "r": 0
    },
    {
      "x": 725.83,
      "y": 288.32,
      "r": 0
    },
    {
      "x": 725.85,
      "y": 288.33,
      "r": 0
    },
    {
      "x": 726.13,
      "y": 288.44,
      "r": 0
    },
    {
      "x": 726.13,
      "y": 288.44,
      "r": 0
    },
    {
      "x": 726.43,
      "y": 288.55,
      "r": 0
    },
    {
      "x": 726.43,
      "y": 288.55,
      "r": 0
    },
    {
      "x": 726.72,
      "y": 288.66,
      "r": 0
    },
    {
      "x": 726.73,
      "y": 288.67,
      "r": 0
    },
    {
      "x": 727.01,
      "y": 288.77,
      "r": 0
    },
    {
      "x": 727.01,
      "y": 288.77,
      "r": 0
    },
    {
      "x": 727.31,
      "y": 288.89,
      "r": 0
    },
    {
      "x": 727.31,
      "y": 288.89,
      "r": 0
    },
    {
      "x": 727.68,
      "y": 289.03,
      "r": 0
    },
    {
      "x": 727.68,
      "y": 289.03,
      "r": 0
    },
    {
      "x": 727.89,
      "y": 289.11,
      "r": 0
    },
    {
      "x": 727.89,
      "y": 289.11,
      "r": 0
    },
    {
      "x": 728.19,
      "y": 289.23,
      "r": 0
    },
    {
      "x": 728.19,
      "y": 289.23,
      "r": 0
    },
    {
      "x": 728.47,
      "y": 289.34,
      "r": 0
    },
    {
      "x": 728.49,
      "y": 289.34,
      "r": 0
    },
    {
      "x": 728.77,
      "y": 289.45,
      "r": 0
    },
    {
      "x": 728.79,
      "y": 289.46,
      "r": 0
    },
    {
      "x": 729.07,
      "y": 289.56,
      "r": 0
    },
    {
      "x": 729.07,
      "y": 289.56,
      "r": 0
    },
    {
      "x": 729.35,
      "y": 289.67,
      "r": 0
    },
    {
      "x": 729.36,
      "y": 289.68,
      "r": 0
    },
    {
      "x": 729.64,
      "y": 289.79,
      "r": 0
    },
    {
      "x": 729.64,
      "y": 289.79,
      "r": 0
    },
    {
      "x": 729.94,
      "y": 289.9,
      "r": 0
    },
    {
      "x": 729.94,
      "y": 289.9,
      "r": 0
    },
    {
      "x": 730.22,
      "y": 290.01,
      "r": 0
    },
    {
      "x": 730.23,
      "y": 290.01,
      "r": 0
    },
    {
      "x": 730.51,
      "y": 290.12,
      "r": 0
    },
    {
      "x": 730.53,
      "y": 290.13,
      "r": 0
    },
    {
      "x": 730.8,
      "y": 290.23,
      "r": 0
    },
    {
      "x": 730.8,
      "y": 290.23,
      "r": 0
    },
    {
      "x": 731.08,
      "y": 290.34,
      "r": 0
    },
    {
      "x": 731.1,
      "y": 290.35,
      "r": 0
    },
    {
      "x": 731.37,
      "y": 290.45,
      "r": 0
    },
    {
      "x": 731.37,
      "y": 290.45,
      "r": 0
    },
    {
      "x": 731.67,
      "y": 290.56,
      "r": 0
    },
    {
      "x": 731.67,
      "y": 290.56,
      "r": 0
    },
    {
      "x": 731.94,
      "y": 290.67,
      "r": 0
    },
    {
      "x": 731.96,
      "y": 290.68,
      "r": 0
    },
    {
      "x": 732.23,
      "y": 290.78,
      "r": 0
    },
    {
      "x": 732.23,
      "y": 290.78,
      "r": 0
    },
    {
      "x": 732.53,
      "y": 290.89,
      "r": 0
    },
    {
      "x": 732.53,
      "y": 290.89,
      "r": 0
    },
    {
      "x": 732.82,
      "y": 291.01,
      "r": 0
    },
    {
      "x": 732.82,
      "y": 291.01,
      "r": 0
    },
    {
      "x": 733.09,
      "y": 291.11,
      "r": 0
    },
    {
      "x": 733.11,
      "y": 291.12,
      "r": 0
    },
    {
      "x": 733.38,
      "y": 291.22,
      "r": 0
    },
    {
      "x": 733.4,
      "y": 291.23,
      "r": 0
    },
    {
      "x": 733.67,
      "y": 291.34,
      "r": 0
    },
    {
      "x": 733.67,
      "y": 291.34,
      "r": 0
    },
    {
      "x": 733.94,
      "y": 291.44,
      "r": 0
    },
    {
      "x": 733.96,
      "y": 291.45,
      "r": 0
    },
    {
      "x": 734.23,
      "y": 291.55,
      "r": 0
    },
    {
      "x": 734.23,
      "y": 291.55,
      "r": 0
    },
    {
      "x": 734.52,
      "y": 291.66,
      "r": 0
    },
    {
      "x": 734.52,
      "y": 291.66,
      "r": 0
    },
    {
      "x": 734.79,
      "y": 291.77,
      "r": 0
    },
    {
      "x": 734.81,
      "y": 291.77,
      "r": 0
    },
    {
      "x": 735.08,
      "y": 291.88,
      "r": 0
    },
    {
      "x": 735.1,
      "y": 291.88,
      "r": 0
    },
    {
      "x": 735.37,
      "y": 291.99,
      "r": 0
    },
    {
      "x": 735.37,
      "y": 291.99,
      "r": 0
    },
    {
      "x": 735.64,
      "y": 292.09,
      "r": 0
    },
    {
      "x": 735.66,
      "y": 292.1,
      "r": 0
    },
    {
      "x": 735.92,
      "y": 292.2,
      "r": 0
    },
    {
      "x": 735.92,
      "y": 292.2,
      "r": 0
    },
    {
      "x": 736.21,
      "y": 292.31,
      "r": 0
    },
    {
      "x": 736.21,
      "y": 292.31,
      "r": 0
    },
    {
      "x": 736.48,
      "y": 292.42,
      "r": 0
    },
    {
      "x": 736.5,
      "y": 292.42,
      "r": 0
    },
    {
      "x": 736.76,
      "y": 292.52,
      "r": 0
    },
    {
      "x": 736.78,
      "y": 292.53,
      "r": 0
    },
    {
      "x": 737.05,
      "y": 292.63,
      "r": 0
    },
    {
      "x": 737.07,
      "y": 292.64,
      "r": 0
    },
    {
      "x": 737.32,
      "y": 292.74,
      "r": 0
    },
    {
      "x": 737.33,
      "y": 292.74,
      "r": 0
    },
    {
      "x": 737.6,
      "y": 292.85,
      "r": 0
    },
    {
      "x": 737.6,
      "y": 292.85,
      "r": 0
    },
    {
      "x": 737.88,
      "y": 292.96,
      "r": 0
    },
    {
      "x": 737.88,
      "y": 292.96,
      "r": 0
    },
    {
      "x": 738.15,
      "y": 293.06,
      "r": 0
    },
    {
      "x": 738.17,
      "y": 293.06,
      "r": 0
    },
    {
      "x": 738.43,
      "y": 293.17,
      "r": 0
    },
    {
      "x": 738.45,
      "y": 293.17,
      "r": 0
    },
    {
      "x": 738.72,
      "y": 293.28,
      "r": 0
    },
    {
      "x": 738.73,
      "y": 293.28,
      "r": 0
    },
    {
      "x": 739,
      "y": 293.38,
      "r": 0
    },
    {
      "x": 739,
      "y": 293.38,
      "r": 0
    },
    {
      "x": 739.26,
      "y": 293.49,
      "r": 0
    },
    {
      "x": 739.28,
      "y": 293.49,
      "r": 0
    },
    {
      "x": 739.54,
      "y": 293.59,
      "r": 0
    },
    {
      "x": 739.54,
      "y": 293.59,
      "r": 0
    },
    {
      "x": 739.82,
      "y": 293.7,
      "r": 0
    },
    {
      "x": 739.82,
      "y": 293.7,
      "r": 0
    },
    {
      "x": 740.09,
      "y": 293.8,
      "r": 0
    },
    {
      "x": 740.1,
      "y": 293.81,
      "r": 0
    },
    {
      "x": 740.37,
      "y": 293.91,
      "r": 0
    },
    {
      "x": 740.37,
      "y": 293.91,
      "r": 0
    },
    {
      "x": 740.65,
      "y": 294.02,
      "r": 0
    },
    {
      "x": 740.65,
      "y": 294.02,
      "r": 0
    },
    {
      "x": 740.91,
      "y": 294.12,
      "r": 0
    },
    {
      "x": 740.92,
      "y": 294.12,
      "r": 0
    },
    {
      "x": 741.19,
      "y": 294.23,
      "r": 0
    },
    {
      "x": 741.19,
      "y": 294.23,
      "r": 0
    },
    {
      "x": 741.46,
      "y": 294.33,
      "r": 0
    },
    {
      "x": 741.46,
      "y": 294.33,
      "r": 0
    },
    {
      "x": 741.73,
      "y": 294.43,
      "r": 0
    },
    {
      "x": 741.74,
      "y": 294.44,
      "r": 0
    },
    {
      "x": 742,
      "y": 294.54,
      "r": 0
    },
    {
      "x": 742,
      "y": 294.54,
      "r": 0
    },
    {
      "x": 742.28,
      "y": 294.65,
      "r": 0
    },
    {
      "x": 742.28,
      "y": 294.65,
      "r": 0
    },
    {
      "x": 742.54,
      "y": 294.75,
      "r": 0
    },
    {
      "x": 742.56,
      "y": 294.75,
      "r": 0
    },
    {
      "x": 742.81,
      "y": 294.85,
      "r": 0
    },
    {
      "x": 742.81,
      "y": 294.85,
      "r": 0
    },
    {
      "x": 743.09,
      "y": 294.96,
      "r": 0
    },
    {
      "x": 743.09,
      "y": 294.96,
      "r": 0
    },
    {
      "x": 743.38,
      "y": 295.07,
      "r": 0
    },
    {
      "x": 743.4,
      "y": 295.08,
      "r": 0
    },
    {
      "x": 743.62,
      "y": 295.16,
      "r": 0
    },
    {
      "x": 743.62,
      "y": 295.16,
      "r": 0
    },
    {
      "x": 743.9,
      "y": 295.27,
      "r": 0
    },
    {
      "x": 743.9,
      "y": 295.27,
      "r": 0
    },
    {
      "x": 744.15,
      "y": 295.37,
      "r": 0
    },
    {
      "x": 744.17,
      "y": 295.37,
      "r": 0
    },
    {
      "x": 744.43,
      "y": 295.47,
      "r": 0
    },
    {
      "x": 744.43,
      "y": 295.47,
      "r": 0
    },
    {
      "x": 744.7,
      "y": 295.58,
      "r": 0
    },
    {
      "x": 744.7,
      "y": 295.58,
      "r": 0
    },
    {
      "x": 744.96,
      "y": 295.68,
      "r": 0
    },
    {
      "x": 745.05,
      "y": 295.71,
      "r": 0
    },
    {
      "x": 745.23,
      "y": 295.78,
      "r": 0
    },
    {
      "x": 745.24,
      "y": 295.79,
      "r": 0
    },
    {
      "x": 745.5,
      "y": 295.88,
      "r": 0
    },
    {
      "x": 745.52,
      "y": 295.89,
      "r": 0
    },
    {
      "x": 745.77,
      "y": 295.99,
      "r": 0
    },
    {
      "x": 745.77,
      "y": 295.99,
      "r": 0
    },
    {
      "x": 746.03,
      "y": 296.09,
      "r": 0
    },
    {
      "x": 746.04,
      "y": 296.09,
      "r": 0
    },
    {
      "x": 746.3,
      "y": 296.19,
      "r": 0
    },
    {
      "x": 746.3,
      "y": 296.19,
      "r": 0
    },
    {
      "x": 746.56,
      "y": 296.29,
      "r": 0
    },
    {
      "x": 746.56,
      "y": 296.29,
      "r": 0
    },
    {
      "x": 746.82,
      "y": 296.39,
      "r": 0
    },
    {
      "x": 746.83,
      "y": 296.4,
      "r": 0
    },
    {
      "x": 747.09,
      "y": 296.5,
      "r": 0
    },
    {
      "x": 747.09,
      "y": 296.5,
      "r": 0
    },
    {
      "x": 747.36,
      "y": 296.6,
      "r": 0
    },
    {
      "x": 747.36,
      "y": 296.6,
      "r": 0
    },
    {
      "x": 747.61,
      "y": 296.7,
      "r": 0
    },
    {
      "x": 747.62,
      "y": 296.7,
      "r": 0
    },
    {
      "x": 747.88,
      "y": 296.8,
      "r": 0
    },
    {
      "x": 747.88,
      "y": 296.8,
      "r": 0
    },
    {
      "x": 748.14,
      "y": 296.9,
      "r": 0
    },
    {
      "x": 748.14,
      "y": 296.9,
      "r": 0
    },
    {
      "x": 748.39,
      "y": 297,
      "r": 0
    },
    {
      "x": 748.41,
      "y": 297,
      "r": 0
    },
    {
      "x": 748.66,
      "y": 297.1,
      "r": 0
    },
    {
      "x": 748.66,
      "y": 297.1,
      "r": 0
    },
    {
      "x": 748.93,
      "y": 297.2,
      "r": 0
    },
    {
      "x": 748.93,
      "y": 297.2,
      "r": 0
    },
    {
      "x": 749.17,
      "y": 297.3,
      "r": 0
    },
    {
      "x": 749.19,
      "y": 297.3,
      "r": 0
    },
    {
      "x": 749.44,
      "y": 297.4,
      "r": 0
    },
    {
      "x": 749.44,
      "y": 297.4,
      "r": 0
    },
    {
      "x": 749.7,
      "y": 297.5,
      "r": 0
    },
    {
      "x": 749.7,
      "y": 297.5,
      "r": 0
    },
    {
      "x": 749.95,
      "y": 297.6,
      "r": 0
    },
    {
      "x": 749.97,
      "y": 297.6,
      "r": 0
    },
    {
      "x": 750.22,
      "y": 297.7,
      "r": 0
    },
    {
      "x": 750.22,
      "y": 297.7,
      "r": 0
    },
    {
      "x": 750.48,
      "y": 297.8,
      "r": 0
    },
    {
      "x": 750.48,
      "y": 297.8,
      "r": 0
    },
    {
      "x": 750.74,
      "y": 297.9,
      "r": 0
    },
    {
      "x": 750.74,
      "y": 297.9,
      "r": 0
    },
    {
      "x": 750.99,
      "y": 298,
      "r": 0
    },
    {
      "x": 750.99,
      "y": 298,
      "r": 0
    },
    {
      "x": 751.25,
      "y": 298.1,
      "r": 0
    },
    {
      "x": 751.27,
      "y": 298.1,
      "r": 0
    },
    {
      "x": 751.5,
      "y": 298.19,
      "r": 0
    },
    {
      "x": 751.51,
      "y": 298.2,
      "r": 0
    },
    {
      "x": 751.76,
      "y": 298.29,
      "r": 0
    },
    {
      "x": 751.76,
      "y": 298.29,
      "r": 0
    },
    {
      "x": 752.02,
      "y": 298.39,
      "r": 0
    },
    {
      "x": 752.02,
      "y": 298.39,
      "r": 0
    },
    {
      "x": 752.28,
      "y": 298.49,
      "r": 0
    },
    {
      "x": 752.28,
      "y": 298.49,
      "r": 0
    },
    {
      "x": 752.52,
      "y": 298.59,
      "r": 0
    },
    {
      "x": 752.54,
      "y": 298.59,
      "r": 0
    },
    {
      "x": 752.78,
      "y": 298.69,
      "r": 0
    },
    {
      "x": 752.8,
      "y": 298.69,
      "r": 0
    },
    {
      "x": 753.04,
      "y": 298.79,
      "r": 0
    },
    {
      "x": 753.04,
      "y": 298.79,
      "r": 0
    },
    {
      "x": 753.28,
      "y": 298.88,
      "r": 0
    },
    {
      "x": 753.3,
      "y": 298.88,
      "r": 0
    },
    {
      "x": 753.54,
      "y": 298.98,
      "r": 0
    },
    {
      "x": 753.54,
      "y": 298.98,
      "r": 0
    },
    {
      "x": 753.8,
      "y": 299.08,
      "r": 0
    },
    {
      "x": 753.8,
      "y": 299.08,
      "r": 0
    },
    {
      "x": 754.04,
      "y": 299.17,
      "r": 0
    },
    {
      "x": 754.06,
      "y": 299.18,
      "r": 0
    },
    {
      "x": 754.3,
      "y": 299.27,
      "r": 0
    },
    {
      "x": 754.31,
      "y": 299.27,
      "r": 0
    },
    {
      "x": 754.55,
      "y": 299.37,
      "r": 0
    },
    {
      "x": 754.55,
      "y": 299.37,
      "r": 0
    },
    {
      "x": 754.8,
      "y": 299.46,
      "r": 0
    },
    {
      "x": 754.81,
      "y": 299.47,
      "r": 0
    },
    {
      "x": 755.05,
      "y": 299.56,
      "r": 0
    },
    {
      "x": 755.05,
      "y": 299.56,
      "r": 0
    },
    {
      "x": 755.31,
      "y": 299.66,
      "r": 0
    },
    {
      "x": 755.31,
      "y": 299.66,
      "r": 0
    },
    {
      "x": 755.55,
      "y": 299.75,
      "r": 0
    },
    {
      "x": 755.56,
      "y": 299.75,
      "r": 0
    },
    {
      "x": 755.8,
      "y": 299.85,
      "r": 0
    },
    {
      "x": 755.81,
      "y": 299.85,
      "r": 0
    },
    {
      "x": 756.05,
      "y": 299.94,
      "r": 0
    },
    {
      "x": 756.05,
      "y": 299.94,
      "r": 0
    },
    {
      "x": 756.29,
      "y": 300.04,
      "r": 0
    },
    {
      "x": 756.31,
      "y": 300.04,
      "r": 0
    },
    {
      "x": 756.54,
      "y": 300.13,
      "r": 0
    },
    {
      "x": 756.54,
      "y": 300.13,
      "r": 0
    },
    {
      "x": 756.8,
      "y": 300.23,
      "r": 0
    },
    {
      "x": 756.8,
      "y": 300.23,
      "r": 0
    },
    {
      "x": 757.03,
      "y": 300.32,
      "r": 0
    },
    {
      "x": 757.05,
      "y": 300.33,
      "r": 0
    },
    {
      "x": 757.29,
      "y": 300.42,
      "r": 0
    },
    {
      "x": 757.3,
      "y": 300.42,
      "r": 0
    },
    {
      "x": 757.54,
      "y": 300.51,
      "r": 0
    },
    {
      "x": 757.54,
      "y": 300.51,
      "r": 0
    },
    {
      "x": 757.79,
      "y": 300.61,
      "r": 0
    },
    {
      "x": 757.79,
      "y": 300.61,
      "r": 0
    },
    {
      "x": 758.02,
      "y": 300.7,
      "r": 0
    },
    {
      "x": 758.04,
      "y": 300.71,
      "r": 0
    },
    {
      "x": 758.27,
      "y": 300.8,
      "r": 0
    },
    {
      "x": 758.27,
      "y": 300.8,
      "r": 0
    },
    {
      "x": 758.52,
      "y": 300.89,
      "r": 0
    },
    {
      "x": 758.52,
      "y": 300.89,
      "r": 0
    },
    {
      "x": 758.76,
      "y": 300.98,
      "r": 0
    },
    {
      "x": 758.77,
      "y": 300.99,
      "r": 0
    },
    {
      "x": 759,
      "y": 301.08,
      "r": 0
    },
    {
      "x": 759,
      "y": 301.08,
      "r": 0
    },
    {
      "x": 759.25,
      "y": 301.17,
      "r": 0
    },
    {
      "x": 759.25,
      "y": 301.17,
      "r": 0
    },
    {
      "x": 759.49,
      "y": 301.26,
      "r": 0
    },
    {
      "x": 759.5,
      "y": 301.27,
      "r": 0
    },
    {
      "x": 759.73,
      "y": 301.36,
      "r": 0
    },
    {
      "x": 759.73,
      "y": 301.36,
      "r": 0
    },
    {
      "x": 759.98,
      "y": 301.45,
      "r": 0
    },
    {
      "x": 759.98,
      "y": 301.45,
      "r": 0
    },
    {
      "x": 760.21,
      "y": 301.54,
      "r": 0
    },
    {
      "x": 760.23,
      "y": 301.55,
      "r": 0
    },
    {
      "x": 760.46,
      "y": 301.64,
      "r": 0
    },
    {
      "x": 760.46,
      "y": 301.64,
      "r": 0
    },
    {
      "x": 760.7,
      "y": 301.73,
      "r": 0
    },
    {
      "x": 760.7,
      "y": 301.73,
      "r": 0
    },
    {
      "x": 760.93,
      "y": 301.82,
      "r": 0
    },
    {
      "x": 760.95,
      "y": 301.83,
      "r": 0
    },
    {
      "x": 761.18,
      "y": 301.91,
      "r": 0
    },
    {
      "x": 761.18,
      "y": 301.91,
      "r": 0
    },
    {
      "x": 761.42,
      "y": 302.01,
      "r": 0
    },
    {
      "x": 761.42,
      "y": 302.01,
      "r": 0
    },
    {
      "x": 761.65,
      "y": 302.1,
      "r": 0
    },
    {
      "x": 761.71,
      "y": 302.12,
      "r": 0
    },
    {
      "x": 761.89,
      "y": 302.19,
      "r": 0
    },
    {
      "x": 761.91,
      "y": 302.2,
      "r": 0
    },
    {
      "x": 762.14,
      "y": 302.28,
      "r": 0
    },
    {
      "x": 762.14,
      "y": 302.28,
      "r": 0
    },
    {
      "x": 762.37,
      "y": 302.37,
      "r": 0
    },
    {
      "x": 762.38,
      "y": 302.38,
      "r": 0
    },
    {
      "x": 762.61,
      "y": 302.46,
      "r": 0
    },
    {
      "x": 762.61,
      "y": 302.46,
      "r": 0
    },
    {
      "x": 762.85,
      "y": 302.56,
      "r": 0
    },
    {
      "x": 762.85,
      "y": 302.56,
      "r": 0
    },
    {
      "x": 763.08,
      "y": 302.64,
      "r": 0
    },
    {
      "x": 763.09,
      "y": 302.65,
      "r": 0
    },
    {
      "x": 763.32,
      "y": 302.74,
      "r": 0
    },
    {
      "x": 763.32,
      "y": 302.74,
      "r": 0
    },
    {
      "x": 763.56,
      "y": 302.83,
      "r": 0
    },
    {
      "x": 763.56,
      "y": 302.83,
      "r": 0
    },
    {
      "x": 763.78,
      "y": 302.92,
      "r": 0
    },
    {
      "x": 763.8,
      "y": 302.92,
      "r": 0
    },
    {
      "x": 764.02,
      "y": 303.01,
      "r": 0
    },
    {
      "x": 764.04,
      "y": 303.01,
      "r": 0
    },
    {
      "x": 764.26,
      "y": 303.1,
      "r": 0
    },
    {
      "x": 764.26,
      "y": 303.1,
      "r": 0
    },
    {
      "x": 764.5,
      "y": 303.19,
      "r": 0
    },
    {
      "x": 764.5,
      "y": 303.19,
      "r": 0
    },
    {
      "x": 764.72,
      "y": 303.28,
      "r": 0
    },
    {
      "x": 764.74,
      "y": 303.28,
      "r": 0
    },
    {
      "x": 764.96,
      "y": 303.37,
      "r": 0
    },
    {
      "x": 764.96,
      "y": 303.37,
      "r": 0
    },
    {
      "x": 765.2,
      "y": 303.46,
      "r": 0
    },
    {
      "x": 765.2,
      "y": 303.46,
      "r": 0
    },
    {
      "x": 765.42,
      "y": 303.55,
      "r": 0
    },
    {
      "x": 765.44,
      "y": 303.55,
      "r": 0
    },
    {
      "x": 765.66,
      "y": 303.64,
      "r": 0
    },
    {
      "x": 765.66,
      "y": 303.64,
      "r": 0
    },
    {
      "x": 765.89,
      "y": 303.73,
      "r": 0
    },
    {
      "x": 765.89,
      "y": 303.73,
      "r": 0
    },
    {
      "x": 766.12,
      "y": 303.81,
      "r": 0
    },
    {
      "x": 766.13,
      "y": 303.82,
      "r": 0
    },
    {
      "x": 766.35,
      "y": 303.9,
      "r": 0
    },
    {
      "x": 766.35,
      "y": 303.9,
      "r": 0
    },
    {
      "x": 766.59,
      "y": 303.99,
      "r": 0
    },
    {
      "x": 766.59,
      "y": 303.99,
      "r": 0
    },
    {
      "x": 766.81,
      "y": 304.08,
      "r": 0
    },
    {
      "x": 766.82,
      "y": 304.08,
      "r": 0
    },
    {
      "x": 767.04,
      "y": 304.17,
      "r": 0
    },
    {
      "x": 767.04,
      "y": 304.17,
      "r": 0
    },
    {
      "x": 767.27,
      "y": 304.26,
      "r": 0
    },
    {
      "x": 767.27,
      "y": 304.26,
      "r": 0
    },
    {
      "x": 767.51,
      "y": 304.35,
      "r": 0
    },
    {
      "x": 767.51,
      "y": 304.35,
      "r": 0
    },
    {
      "x": 767.73,
      "y": 304.43,
      "r": 0
    },
    {
      "x": 767.73,
      "y": 304.43,
      "r": 0
    },
    {
      "x": 767.96,
      "y": 304.52,
      "r": 0
    },
    {
      "x": 767.96,
      "y": 304.52,
      "r": 0
    },
    {
      "x": 768.18,
      "y": 304.61,
      "r": 0
    },
    {
      "x": 768.19,
      "y": 304.61,
      "r": 0
    },
    {
      "x": 768.41,
      "y": 304.69,
      "r": 0
    },
    {
      "x": 768.41,
      "y": 304.69,
      "r": 0
    },
    {
      "x": 768.64,
      "y": 304.78,
      "r": 0
    },
    {
      "x": 768.65,
      "y": 304.79,
      "r": 0
    },
    {
      "x": 768.85,
      "y": 304.87,
      "r": 0
    },
    {
      "x": 768.87,
      "y": 304.87,
      "r": 0
    },
    {
      "x": 769.08,
      "y": 304.96,
      "r": 0
    },
    {
      "x": 769.08,
      "y": 304.96,
      "r": 0
    },
    {
      "x": 769.31,
      "y": 305.04,
      "r": 0
    },
    {
      "x": 769.31,
      "y": 305.04,
      "r": 0
    },
    {
      "x": 769.54,
      "y": 305.13,
      "r": 0
    },
    {
      "x": 769.54,
      "y": 305.13,
      "r": 0
    },
    {
      "x": 769.76,
      "y": 305.21,
      "r": 0
    },
    {
      "x": 769.77,
      "y": 305.22,
      "r": 0
    },
    {
      "x": 769.99,
      "y": 305.3,
      "r": 0
    },
    {
      "x": 770,
      "y": 305.31,
      "r": 0
    },
    {
      "x": 770.21,
      "y": 305.39,
      "r": 0
    },
    {
      "x": 770.21,
      "y": 305.39,
      "r": 0
    },
    {
      "x": 770.43,
      "y": 305.47,
      "r": 0
    },
    {
      "x": 770.44,
      "y": 305.48,
      "r": 0
    },
    {
      "x": 770.65,
      "y": 305.56,
      "r": 0
    },
    {
      "x": 770.65,
      "y": 305.56,
      "r": 0
    },
    {
      "x": 770.88,
      "y": 305.65,
      "r": 0
    },
    {
      "x": 770.88,
      "y": 305.65,
      "r": 0
    },
    {
      "x": 771.09,
      "y": 305.73,
      "r": 0
    },
    {
      "x": 771.11,
      "y": 305.73,
      "r": 0
    },
    {
      "x": 771.32,
      "y": 305.81,
      "r": 0
    },
    {
      "x": 771.33,
      "y": 305.82,
      "r": 0
    },
    {
      "x": 771.54,
      "y": 305.9,
      "r": 0
    },
    {
      "x": 771.54,
      "y": 305.9,
      "r": 0
    },
    {
      "x": 771.76,
      "y": 305.98,
      "r": 0
    },
    {
      "x": 771.77,
      "y": 305.99,
      "r": 0
    },
    {
      "x": 771.98,
      "y": 306.07,
      "r": 0
    },
    {
      "x": 771.98,
      "y": 306.07,
      "r": 0
    },
    {
      "x": 772.2,
      "y": 306.16,
      "r": 0
    },
    {
      "x": 772.2,
      "y": 306.16,
      "r": 0
    },
    {
      "x": 772.41,
      "y": 306.24,
      "r": 0
    },
    {
      "x": 772.43,
      "y": 306.24,
      "r": 0
    },
    {
      "x": 772.64,
      "y": 306.32,
      "r": 0
    },
    {
      "x": 772.65,
      "y": 306.33,
      "r": 0
    },
    {
      "x": 772.86,
      "y": 306.41,
      "r": 0
    },
    {
      "x": 772.86,
      "y": 306.41,
      "r": 0
    },
    {
      "x": 773.07,
      "y": 306.49,
      "r": 0
    },
    {
      "x": 773.08,
      "y": 306.49,
      "r": 0
    },
    {
      "x": 773.29,
      "y": 306.57,
      "r": 0
    },
    {
      "x": 773.29,
      "y": 306.57,
      "r": 0
    },
    {
      "x": 773.51,
      "y": 306.66,
      "r": 0
    },
    {
      "x": 773.51,
      "y": 306.66,
      "r": 0
    },
    {
      "x": 773.72,
      "y": 306.74,
      "r": 0
    },
    {
      "x": 773.73,
      "y": 306.74,
      "r": 0
    },
    {
      "x": 773.94,
      "y": 306.82,
      "r": 0
    },
    {
      "x": 773.95,
      "y": 306.83,
      "r": 0
    },
    {
      "x": 774.16,
      "y": 306.91,
      "r": 0
    },
    {
      "x": 774.16,
      "y": 306.91,
      "r": 0
    },
    {
      "x": 774.37,
      "y": 306.99,
      "r": 0
    },
    {
      "x": 774.38,
      "y": 306.99,
      "r": 0
    },
    {
      "x": 774.59,
      "y": 307.07,
      "r": 0
    },
    {
      "x": 774.59,
      "y": 307.07,
      "r": 0
    },
    {
      "x": 774.8,
      "y": 307.16,
      "r": 0
    },
    {
      "x": 774.8,
      "y": 307.16,
      "r": 0
    },
    {
      "x": 775.02,
      "y": 307.24,
      "r": 0
    },
    {
      "x": 775.02,
      "y": 307.24,
      "r": 0
    },
    {
      "x": 775.23,
      "y": 307.32,
      "r": 0
    },
    {
      "x": 775.24,
      "y": 307.32,
      "r": 0
    },
    {
      "x": 775.44,
      "y": 307.4,
      "r": 0
    },
    {
      "x": 775.44,
      "y": 307.4,
      "r": 0
    },
    {
      "x": 775.66,
      "y": 307.49,
      "r": 0
    },
    {
      "x": 775.66,
      "y": 307.49,
      "r": 0
    },
    {
      "x": 775.87,
      "y": 307.56,
      "r": 0
    },
    {
      "x": 775.88,
      "y": 307.57,
      "r": 0
    },
    {
      "x": 776.08,
      "y": 307.65,
      "r": 0
    },
    {
      "x": 776.08,
      "y": 307.65,
      "r": 0
    },
    {
      "x": 776.3,
      "y": 307.73,
      "r": 0
    },
    {
      "x": 776.3,
      "y": 307.73,
      "r": 0
    },
    {
      "x": 776.5,
      "y": 307.81,
      "r": 0
    },
    {
      "x": 776.51,
      "y": 307.81,
      "r": 0
    },
    {
      "x": 776.71,
      "y": 307.89,
      "r": 0
    },
    {
      "x": 776.71,
      "y": 307.89,
      "r": 0
    },
    {
      "x": 776.93,
      "y": 307.97,
      "r": 0
    },
    {
      "x": 776.93,
      "y": 307.97,
      "r": 0
    },
    {
      "x": 777.13,
      "y": 308.05,
      "r": 0
    },
    {
      "x": 777.14,
      "y": 308.05,
      "r": 0
    },
    {
      "x": 777.34,
      "y": 308.13,
      "r": 0
    },
    {
      "x": 777.34,
      "y": 308.13,
      "r": 0
    },
    {
      "x": 777.56,
      "y": 308.21,
      "r": 0
    },
    {
      "x": 777.56,
      "y": 308.21,
      "r": 0
    },
    {
      "x": 777.76,
      "y": 308.29,
      "r": 0
    },
    {
      "x": 777.78,
      "y": 308.3,
      "r": 0
    },
    {
      "x": 777.97,
      "y": 308.37,
      "r": 0
    },
    {
      "x": 777.98,
      "y": 308.38,
      "r": 0
    },
    {
      "x": 778.18,
      "y": 308.45,
      "r": 0
    },
    {
      "x": 778.18,
      "y": 308.45,
      "r": 0
    },
    {
      "x": 778.38,
      "y": 308.53,
      "r": 0
    },
    {
      "x": 778.39,
      "y": 308.54,
      "r": 0
    },
    {
      "x": 778.59,
      "y": 308.61,
      "r": 0
    },
    {
      "x": 778.6,
      "y": 308.62,
      "r": 0
    },
    {
      "x": 778.8,
      "y": 308.69,
      "r": 0
    },
    {
      "x": 778.8,
      "y": 308.69,
      "r": 0
    },
    {
      "x": 779.01,
      "y": 308.77,
      "r": 0
    },
    {
      "x": 779.01,
      "y": 308.77,
      "r": 0
    },
    {
      "x": 779.21,
      "y": 308.85,
      "r": 0
    },
    {
      "x": 779.22,
      "y": 308.85,
      "r": 0
    },
    {
      "x": 779.42,
      "y": 308.93,
      "r": 0
    },
    {
      "x": 779.42,
      "y": 308.93,
      "r": 0
    },
    {
      "x": 779.61,
      "y": 309.01,
      "r": 0
    },
    {
      "x": 779.63,
      "y": 309.01,
      "r": 0
    },
    {
      "x": 779.82,
      "y": 309.09,
      "r": 0
    },
    {
      "x": 779.83,
      "y": 309.09,
      "r": 0
    },
    {
      "x": 780.03,
      "y": 309.17,
      "r": 0
    },
    {
      "x": 780.04,
      "y": 309.17,
      "r": 0
    },
    {
      "x": 780.23,
      "y": 309.24,
      "r": 0
    },
    {
      "x": 780.24,
      "y": 309.25,
      "r": 0
    },
    {
      "x": 780.43,
      "y": 309.32,
      "r": 0
    },
    {
      "x": 780.44,
      "y": 309.32,
      "r": 0
    },
    {
      "x": 780.64,
      "y": 309.4,
      "r": 0
    },
    {
      "x": 780.64,
      "y": 309.4,
      "r": 0
    },
    {
      "x": 780.85,
      "y": 309.48,
      "r": 0
    },
    {
      "x": 780.85,
      "y": 309.48,
      "r": 0
    },
    {
      "x": 781.04,
      "y": 309.55,
      "r": 0
    },
    {
      "x": 781.05,
      "y": 309.56,
      "r": 0
    },
    {
      "x": 781.26,
      "y": 309.64,
      "r": 0
    },
    {
      "x": 781.27,
      "y": 309.64,
      "r": 0
    },
    {
      "x": 781.45,
      "y": 309.71,
      "r": 0
    },
    {
      "x": 781.45,
      "y": 309.71,
      "r": 0
    },
    {
      "x": 781.64,
      "y": 309.79,
      "r": 0
    },
    {
      "x": 781.65,
      "y": 309.79,
      "r": 0
    },
    {
      "x": 781.85,
      "y": 309.86,
      "r": 0
    },
    {
      "x": 781.85,
      "y": 309.86,
      "r": 0
    },
    {
      "x": 782.05,
      "y": 309.94,
      "r": 0
    },
    {
      "x": 782.05,
      "y": 309.94,
      "r": 0
    },
    {
      "x": 782.24,
      "y": 310.02,
      "r": 0
    },
    {
      "x": 782.25,
      "y": 310.02,
      "r": 0
    },
    {
      "x": 782.44,
      "y": 310.09,
      "r": 0
    },
    {
      "x": 782.45,
      "y": 310.1,
      "r": 0
    },
    {
      "x": 782.65,
      "y": 310.17,
      "r": 0
    },
    {
      "x": 782.65,
      "y": 310.17,
      "r": 0
    },
    {
      "x": 782.84,
      "y": 310.24,
      "r": 0
    },
    {
      "x": 782.85,
      "y": 310.25,
      "r": 0
    },
    {
      "x": 783.04,
      "y": 310.32,
      "r": 0
    },
    {
      "x": 783.04,
      "y": 310.32,
      "r": 0
    },
    {
      "x": 783.24,
      "y": 310.4,
      "r": 0
    },
    {
      "x": 783.24,
      "y": 310.4,
      "r": 0
    },
    {
      "x": 783.43,
      "y": 310.47,
      "r": 0
    },
    {
      "x": 783.44,
      "y": 310.48,
      "r": 0
    },
    {
      "x": 783.63,
      "y": 310.55,
      "r": 0
    },
    {
      "x": 783.64,
      "y": 310.55,
      "r": 0
    },
    {
      "x": 783.83,
      "y": 310.63,
      "r": 0
    },
    {
      "x": 783.83,
      "y": 310.63,
      "r": 0
    },
    {
      "x": 784.01,
      "y": 310.7,
      "r": 0
    },
    {
      "x": 784.03,
      "y": 310.7,
      "r": 0
    },
    {
      "x": 784.21,
      "y": 310.77,
      "r": 0
    },
    {
      "x": 784.22,
      "y": 310.78,
      "r": 0
    },
    {
      "x": 784.41,
      "y": 310.85,
      "r": 0
    },
    {
      "x": 784.41,
      "y": 310.85,
      "r": 0
    },
    {
      "x": 784.61,
      "y": 310.93,
      "r": 0
    },
    {
      "x": 784.61,
      "y": 310.93,
      "r": 0
    },
    {
      "x": 784.81,
      "y": 311,
      "r": 0
    },
    {
      "x": 784.82,
      "y": 311.01,
      "r": 0
    },
    {
      "x": 784.99,
      "y": 311.07,
      "r": 0
    },
    {
      "x": 784.99,
      "y": 311.07,
      "r": 0
    },
    {
      "x": 785.18,
      "y": 311.14,
      "r": 0
    },
    {
      "x": 785.19,
      "y": 311.15,
      "r": 0
    },
    {
      "x": 785.38,
      "y": 311.22,
      "r": 0
    },
    {
      "x": 785.4,
      "y": 311.23,
      "r": 0
    },
    {
      "x": 785.57,
      "y": 311.3,
      "r": 0
    },
    {
      "x": 785.58,
      "y": 311.3,
      "r": 0
    },
    {
      "x": 785.76,
      "y": 311.37,
      "r": 0
    },
    {
      "x": 785.76,
      "y": 311.37,
      "r": 0
    },
    {
      "x": 785.95,
      "y": 311.44,
      "r": 0
    },
    {
      "x": 785.96,
      "y": 311.45,
      "r": 0
    },
    {
      "x": 786.14,
      "y": 311.52,
      "r": 0
    },
    {
      "x": 786.14,
      "y": 311.52,
      "r": 0
    },
    {
      "x": 786.34,
      "y": 311.59,
      "r": 0
    },
    {
      "x": 786.34,
      "y": 311.59,
      "r": 0
    },
    {
      "x": 786.52,
      "y": 311.66,
      "r": 0
    },
    {
      "x": 786.53,
      "y": 311.67,
      "r": 0
    },
    {
      "x": 786.71,
      "y": 311.74,
      "r": 0
    },
    {
      "x": 786.71,
      "y": 311.74,
      "r": 0
    },
    {
      "x": 786.9,
      "y": 311.81,
      "r": 0
    },
    {
      "x": 786.9,
      "y": 311.81,
      "r": 0
    },
    {
      "x": 787.09,
      "y": 311.88,
      "r": 0
    },
    {
      "x": 787.1,
      "y": 311.88,
      "r": 0
    },
    {
      "x": 787.28,
      "y": 311.95,
      "r": 0
    },
    {
      "x": 787.28,
      "y": 311.95,
      "r": 0
    },
    {
      "x": 787.47,
      "y": 312.03,
      "r": 0
    },
    {
      "x": 787.47,
      "y": 312.03,
      "r": 0
    },
    {
      "x": 787.65,
      "y": 312.1,
      "r": 0
    },
    {
      "x": 787.66,
      "y": 312.1,
      "r": 0
    },
    {
      "x": 787.84,
      "y": 312.17,
      "r": 0
    },
    {
      "x": 787.84,
      "y": 312.17,
      "r": 0
    },
    {
      "x": 788.03,
      "y": 312.24,
      "r": 0
    },
    {
      "x": 788.03,
      "y": 312.24,
      "r": 0
    },
    {
      "x": 788.23,
      "y": 312.32,
      "r": 0
    },
    {
      "x": 788.24,
      "y": 312.32,
      "r": 0
    },
    {
      "x": 788.4,
      "y": 312.38,
      "r": 0
    },
    {
      "x": 788.4,
      "y": 312.38,
      "r": 0
    },
    {
      "x": 788.59,
      "y": 312.46,
      "r": 0
    },
    {
      "x": 788.59,
      "y": 312.46,
      "r": 0
    },
    {
      "x": 788.76,
      "y": 312.52,
      "r": 0
    },
    {
      "x": 788.77,
      "y": 312.53,
      "r": 0
    },
    {
      "x": 788.95,
      "y": 312.6,
      "r": 0
    },
    {
      "x": 788.96,
      "y": 312.6,
      "r": 0
    },
    {
      "x": 789.14,
      "y": 312.67,
      "r": 0
    },
    {
      "x": 789.14,
      "y": 312.67,
      "r": 0
    },
    {
      "x": 789.33,
      "y": 312.74,
      "r": 0
    },
    {
      "x": 789.33,
      "y": 312.74,
      "r": 0
    },
    {
      "x": 789.5,
      "y": 312.81,
      "r": 0
    },
    {
      "x": 789.51,
      "y": 312.81,
      "r": 0
    },
    {
      "x": 789.69,
      "y": 312.88,
      "r": 0
    },
    {
      "x": 789.69,
      "y": 312.88,
      "r": 0
    },
    {
      "x": 789.87,
      "y": 312.95,
      "r": 0
    },
    {
      "x": 789.87,
      "y": 312.95,
      "r": 0
    },
    {
      "x": 790.05,
      "y": 313.02,
      "r": 0
    },
    {
      "x": 790.06,
      "y": 313.02,
      "r": 0
    },
    {
      "x": 790.23,
      "y": 313.09,
      "r": 0
    },
    {
      "x": 790.23,
      "y": 313.09,
      "r": 0
    },
    {
      "x": 790.42,
      "y": 313.16,
      "r": 0
    },
    {
      "x": 790.42,
      "y": 313.16,
      "r": 0
    },
    {
      "x": 790.59,
      "y": 313.23,
      "r": 0
    },
    {
      "x": 790.6,
      "y": 313.23,
      "r": 0
    },
    {
      "x": 790.77,
      "y": 313.3,
      "r": 0
    },
    {
      "x": 790.77,
      "y": 313.3,
      "r": 0
    },
    {
      "x": 790.96,
      "y": 313.37,
      "r": 0
    },
    {
      "x": 790.96,
      "y": 313.37,
      "r": 0
    },
    {
      "x": 791.13,
      "y": 313.43,
      "r": 0
    },
    {
      "x": 791.14,
      "y": 313.44,
      "r": 0
    },
    {
      "x": 791.31,
      "y": 313.5,
      "r": 0
    },
    {
      "x": 791.31,
      "y": 313.5,
      "r": 0
    },
    {
      "x": 791.5,
      "y": 313.58,
      "r": 0
    },
    {
      "x": 791.52,
      "y": 313.58,
      "r": 0
    },
    {
      "x": 791.67,
      "y": 313.64,
      "r": 0
    },
    {
      "x": 791.68,
      "y": 313.64,
      "r": 0
    },
    {
      "x": 791.85,
      "y": 313.71,
      "r": 0
    },
    {
      "x": 791.86,
      "y": 313.71,
      "r": 0
    },
    {
      "x": 792.03,
      "y": 313.78,
      "r": 0
    },
    {
      "x": 792.03,
      "y": 313.78,
      "r": 0
    },
    {
      "x": 792.2,
      "y": 313.84,
      "r": 0
    },
    {
      "x": 792.21,
      "y": 313.85,
      "r": 0
    },
    {
      "x": 792.38,
      "y": 313.91,
      "r": 0
    },
    {
      "x": 792.38,
      "y": 313.91,
      "r": 0
    },
    {
      "x": 792.56,
      "y": 313.98,
      "r": 0
    },
    {
      "x": 792.56,
      "y": 313.98,
      "r": 0
    },
    {
      "x": 792.72,
      "y": 314.05,
      "r": 0
    },
    {
      "x": 792.73,
      "y": 314.05,
      "r": 0
    },
    {
      "x": 792.9,
      "y": 314.12,
      "r": 0
    },
    {
      "x": 792.91,
      "y": 314.12,
      "r": 0
    },
    {
      "x": 793.08,
      "y": 314.18,
      "r": 0
    },
    {
      "x": 793.08,
      "y": 314.18,
      "r": 0
    },
    {
      "x": 793.25,
      "y": 314.25,
      "r": 0
    },
    {
      "x": 793.26,
      "y": 314.25,
      "r": 0
    },
    {
      "x": 793.43,
      "y": 314.32,
      "r": 0
    },
    {
      "x": 793.44,
      "y": 314.32,
      "r": 0
    },
    {
      "x": 793.6,
      "y": 314.39,
      "r": 0
    },
    {
      "x": 793.61,
      "y": 314.39,
      "r": 0
    },
    {
      "x": 793.78,
      "y": 314.45,
      "r": 0
    },
    {
      "x": 793.78,
      "y": 314.45,
      "r": 0
    },
    {
      "x": 793.94,
      "y": 314.52,
      "r": 0
    },
    {
      "x": 793.95,
      "y": 314.52,
      "r": 0
    },
    {
      "x": 794.12,
      "y": 314.58,
      "r": 0
    },
    {
      "x": 794.12,
      "y": 314.58,
      "r": 0
    },
    {
      "x": 794.29,
      "y": 314.65,
      "r": 0
    },
    {
      "x": 794.29,
      "y": 314.65,
      "r": 0
    },
    {
      "x": 794.46,
      "y": 314.71,
      "r": 0
    },
    {
      "x": 794.47,
      "y": 314.72,
      "r": 0
    },
    {
      "x": 794.64,
      "y": 314.79,
      "r": 0
    },
    {
      "x": 794.65,
      "y": 314.79,
      "r": 0
    },
    {
      "x": 794.81,
      "y": 314.85,
      "r": 0
    },
    {
      "x": 794.81,
      "y": 314.85,
      "r": 0
    },
    {
      "x": 794.97,
      "y": 314.91,
      "r": 0
    },
    {
      "x": 794.98,
      "y": 314.92,
      "r": 0
    },
    {
      "x": 795.14,
      "y": 314.98,
      "r": 0
    },
    {
      "x": 795.14,
      "y": 314.98,
      "r": 0
    },
    {
      "x": 795.31,
      "y": 315.04,
      "r": 0
    },
    {
      "x": 795.31,
      "y": 315.04,
      "r": 0
    },
    {
      "x": 795.48,
      "y": 315.11,
      "r": 0
    },
    {
      "x": 795.49,
      "y": 315.11,
      "r": 0
    },
    {
      "x": 795.65,
      "y": 315.17,
      "r": 0
    },
    {
      "x": 795.66,
      "y": 315.18,
      "r": 0
    },
    {
      "x": 795.82,
      "y": 315.24,
      "r": 0
    },
    {
      "x": 795.82,
      "y": 315.24,
      "r": 0
    },
    {
      "x": 795.98,
      "y": 315.3,
      "r": 0
    },
    {
      "x": 795.99,
      "y": 315.3,
      "r": 0
    },
    {
      "x": 796.15,
      "y": 315.37,
      "r": 0
    },
    {
      "x": 796.15,
      "y": 315.37,
      "r": 0
    },
    {
      "x": 796.32,
      "y": 315.43,
      "r": 0
    },
    {
      "x": 796.32,
      "y": 315.43,
      "r": 0
    },
    {
      "x": 796.48,
      "y": 315.49,
      "r": 0
    },
    {
      "x": 796.49,
      "y": 315.5,
      "r": 0
    },
    {
      "x": 796.65,
      "y": 315.56,
      "r": 0
    },
    {
      "x": 796.66,
      "y": 315.56,
      "r": 0
    },
    {
      "x": 796.82,
      "y": 315.62,
      "r": 0
    },
    {
      "x": 796.82,
      "y": 315.62,
      "r": 0
    },
    {
      "x": 796.98,
      "y": 315.68,
      "r": 0
    },
    {
      "x": 796.99,
      "y": 315.69,
      "r": 0
    },
    {
      "x": 797.14,
      "y": 315.75,
      "r": 0
    },
    {
      "x": 797.15,
      "y": 315.75,
      "r": 0
    },
    {
      "x": 797.31,
      "y": 315.81,
      "r": 0
    },
    {
      "x": 797.31,
      "y": 315.81,
      "r": 0
    },
    {
      "x": 797.47,
      "y": 315.87,
      "r": 0
    },
    {
      "x": 797.48,
      "y": 315.88,
      "r": 0
    },
    {
      "x": 797.65,
      "y": 315.94,
      "r": 0
    },
    {
      "x": 797.66,
      "y": 315.95,
      "r": 0
    },
    {
      "x": 797.8,
      "y": 316,
      "r": 0
    },
    {
      "x": 797.8,
      "y": 316,
      "r": 0
    },
    {
      "x": 797.97,
      "y": 316.06,
      "r": 0
    },
    {
      "x": 797.97,
      "y": 316.06,
      "r": 0
    },
    {
      "x": 798.12,
      "y": 316.12,
      "r": 0
    },
    {
      "x": 798.13,
      "y": 316.13,
      "r": 0
    },
    {
      "x": 798.29,
      "y": 316.19,
      "r": 0
    },
    {
      "x": 798.29,
      "y": 316.19,
      "r": 0
    },
    {
      "x": 798.45,
      "y": 316.25,
      "r": 0
    },
    {
      "x": 798.45,
      "y": 316.25,
      "r": 0
    },
    {
      "x": 798.6,
      "y": 316.31,
      "r": 0
    },
    {
      "x": 798.61,
      "y": 316.31,
      "r": 0
    },
    {
      "x": 798.77,
      "y": 316.37,
      "r": 0
    },
    {
      "x": 798.77,
      "y": 316.37,
      "r": 0
    },
    {
      "x": 798.93,
      "y": 316.43,
      "r": 0
    },
    {
      "x": 798.93,
      "y": 316.43,
      "r": 0
    },
    {
      "x": 799.08,
      "y": 316.49,
      "r": 0
    },
    {
      "x": 799.09,
      "y": 316.5,
      "r": 0
    },
    {
      "x": 799.25,
      "y": 316.56,
      "r": 0
    },
    {
      "x": 799.25,
      "y": 316.56,
      "r": 0
    },
    {
      "x": 799.41,
      "y": 316.62,
      "r": 0
    },
    {
      "x": 799.41,
      "y": 316.62,
      "r": 0
    },
    {
      "x": 799.56,
      "y": 316.68,
      "r": 0
    },
    {
      "x": 799.57,
      "y": 316.68,
      "r": 0
    },
    {
      "x": 799.72,
      "y": 316.74,
      "r": 0
    },
    {
      "x": 799.72,
      "y": 316.74,
      "r": 0
    },
    {
      "x": 799.88,
      "y": 316.8,
      "r": 0
    },
    {
      "x": 799.88,
      "y": 316.8,
      "r": 0
    },
    {
      "x": 800.03,
      "y": 316.86,
      "r": 0
    },
    {
      "x": 800.04,
      "y": 316.86,
      "r": 0
    },
    {
      "x": 800.19,
      "y": 316.92,
      "r": 0
    },
    {
      "x": 800.19,
      "y": 316.92,
      "r": 0
    },
    {
      "x": 800.35,
      "y": 316.98,
      "r": 0
    },
    {
      "x": 800.35,
      "y": 316.98,
      "r": 0
    },
    {
      "x": 800.52,
      "y": 317.04,
      "r": 0
    },
    {
      "x": 800.53,
      "y": 317.05,
      "r": 0
    },
    {
      "x": 800.66,
      "y": 317.1,
      "r": 0
    },
    {
      "x": 800.66,
      "y": 317.1,
      "r": 0
    },
    {
      "x": 800.81,
      "y": 317.16,
      "r": 0
    },
    {
      "x": 800.81,
      "y": 317.16,
      "r": 0
    },
    {
      "x": 800.96,
      "y": 317.22,
      "r": 0
    },
    {
      "x": 800.97,
      "y": 317.22,
      "r": 0
    },
    {
      "x": 801.12,
      "y": 317.28,
      "r": 0
    },
    {
      "x": 801.12,
      "y": 317.28,
      "r": 0
    },
    {
      "x": 801.28,
      "y": 317.34,
      "r": 0
    },
    {
      "x": 801.28,
      "y": 317.34,
      "r": 0
    },
    {
      "x": 801.43,
      "y": 317.4,
      "r": 0
    },
    {
      "x": 801.43,
      "y": 317.4,
      "r": 0
    },
    {
      "x": 801.58,
      "y": 317.45,
      "r": 0
    },
    {
      "x": 801.59,
      "y": 317.46,
      "r": 0
    },
    {
      "x": 801.73,
      "y": 317.51,
      "r": 0
    },
    {
      "x": 801.73,
      "y": 317.51,
      "r": 0
    },
    {
      "x": 801.89,
      "y": 317.57,
      "r": 0
    },
    {
      "x": 801.89,
      "y": 317.57,
      "r": 0
    },
    {
      "x": 802.03,
      "y": 317.63,
      "r": 0
    },
    {
      "x": 802.04,
      "y": 317.63,
      "r": 0
    },
    {
      "x": 802.19,
      "y": 317.69,
      "r": 0
    },
    {
      "x": 802.19,
      "y": 317.69,
      "r": 0
    },
    {
      "x": 802.34,
      "y": 317.75,
      "r": 0
    },
    {
      "x": 802.34,
      "y": 317.75,
      "r": 0
    },
    {
      "x": 802.48,
      "y": 317.8,
      "r": 0
    },
    {
      "x": 802.49,
      "y": 317.81,
      "r": 0
    },
    {
      "x": 802.64,
      "y": 317.86,
      "r": 0
    },
    {
      "x": 802.64,
      "y": 317.86,
      "r": 0
    },
    {
      "x": 802.79,
      "y": 317.92,
      "r": 0
    },
    {
      "x": 802.79,
      "y": 317.92,
      "r": 0
    },
    {
      "x": 802.93,
      "y": 317.97,
      "r": 0
    },
    {
      "x": 802.94,
      "y": 317.98,
      "r": 0
    },
    {
      "x": 803.08,
      "y": 318.03,
      "r": 0
    },
    {
      "x": 803.08,
      "y": 318.03,
      "r": 0
    },
    {
      "x": 803.24,
      "y": 318.09,
      "r": 0
    },
    {
      "x": 803.25,
      "y": 318.1,
      "r": 0
    },
    {
      "x": 803.38,
      "y": 318.14,
      "r": 0
    },
    {
      "x": 803.38,
      "y": 318.15,
      "r": 0
    },
    {
      "x": 803.53,
      "y": 318.2,
      "r": 0
    },
    {
      "x": 803.53,
      "y": 318.2,
      "r": 0
    },
    {
      "x": 803.68,
      "y": 318.26,
      "r": 0
    },
    {
      "x": 803.68,
      "y": 318.26,
      "r": 0
    },
    {
      "x": 803.82,
      "y": 318.31,
      "r": 0
    },
    {
      "x": 803.82,
      "y": 318.32,
      "r": 0
    },
    {
      "x": 803.96,
      "y": 318.37,
      "r": 0
    },
    {
      "x": 803.96,
      "y": 318.37,
      "r": 0
    },
    {
      "x": 804.11,
      "y": 318.43,
      "r": 0
    },
    {
      "x": 804.11,
      "y": 318.43,
      "r": 0
    },
    {
      "x": 804.25,
      "y": 318.48,
      "r": 0
    },
    {
      "x": 804.26,
      "y": 318.48,
      "r": 0
    },
    {
      "x": 804.4,
      "y": 318.54,
      "r": 0
    },
    {
      "x": 804.4,
      "y": 318.54,
      "r": 0
    },
    {
      "x": 804.55,
      "y": 318.59,
      "r": 0
    },
    {
      "x": 804.55,
      "y": 318.59,
      "r": 0
    },
    {
      "x": 804.68,
      "y": 318.65,
      "r": 0
    },
    {
      "x": 804.69,
      "y": 318.65,
      "r": 0
    },
    {
      "x": 804.83,
      "y": 318.7,
      "r": 0
    },
    {
      "x": 804.83,
      "y": 318.7,
      "r": 0
    },
    {
      "x": 804.98,
      "y": 318.76,
      "r": 0
    },
    {
      "x": 804.98,
      "y": 318.76,
      "r": 0
    },
    {
      "x": 805.11,
      "y": 318.81,
      "r": 0
    },
    {
      "x": 805.12,
      "y": 318.82,
      "r": 0
    },
    {
      "x": 805.26,
      "y": 318.87,
      "r": 0
    },
    {
      "x": 805.27,
      "y": 318.87,
      "r": 0
    },
    {
      "x": 805.4,
      "y": 318.92,
      "r": 0
    },
    {
      "x": 805.4,
      "y": 318.92,
      "r": 0
    },
    {
      "x": 805.55,
      "y": 318.98,
      "r": 0
    },
    {
      "x": 805.55,
      "y": 318.98,
      "r": 0
    },
    {
      "x": 805.68,
      "y": 319.03,
      "r": 0
    },
    {
      "x": 805.69,
      "y": 319.03,
      "r": 0
    },
    {
      "x": 805.87,
      "y": 319.11,
      "r": 0
    },
    {
      "x": 805.89,
      "y": 319.11,
      "r": 0
    },
    {
      "x": 805.97,
      "y": 319.14,
      "r": 0
    },
    {
      "x": 805.97,
      "y": 319.14,
      "r": 0
    },
    {
      "x": 806.1,
      "y": 319.19,
      "r": 0
    },
    {
      "x": 806.11,
      "y": 319.2,
      "r": 0
    },
    {
      "x": 806.24,
      "y": 319.25,
      "r": 0
    },
    {
      "x": 806.24,
      "y": 319.25,
      "r": 0
    },
    {
      "x": 806.38,
      "y": 319.3,
      "r": 0
    },
    {
      "x": 806.38,
      "y": 319.3,
      "r": 0
    },
    {
      "x": 806.52,
      "y": 319.35,
      "r": 0
    },
    {
      "x": 806.52,
      "y": 319.36,
      "r": 0
    },
    {
      "x": 806.66,
      "y": 319.41,
      "r": 0
    },
    {
      "x": 806.66,
      "y": 319.41,
      "r": 0
    },
    {
      "x": 806.8,
      "y": 319.46,
      "r": 0
    },
    {
      "x": 806.8,
      "y": 319.46,
      "r": 0
    },
    {
      "x": 806.93,
      "y": 319.51,
      "r": 0
    },
    {
      "x": 806.94,
      "y": 319.51,
      "r": 0
    },
    {
      "x": 807.07,
      "y": 319.56,
      "r": 0
    },
    {
      "x": 807.07,
      "y": 319.56,
      "r": 0
    },
    {
      "x": 807.21,
      "y": 319.62,
      "r": 0
    },
    {
      "x": 807.21,
      "y": 319.62,
      "r": 0
    },
    {
      "x": 807.34,
      "y": 319.67,
      "r": 0
    },
    {
      "x": 807.34,
      "y": 319.67,
      "r": 0
    },
    {
      "x": 807.47,
      "y": 319.72,
      "r": 0
    },
    {
      "x": 807.48,
      "y": 319.72,
      "r": 0
    },
    {
      "x": 807.61,
      "y": 319.77,
      "r": 0
    },
    {
      "x": 807.61,
      "y": 319.77,
      "r": 0
    },
    {
      "x": 807.75,
      "y": 319.83,
      "r": 0
    },
    {
      "x": 807.75,
      "y": 319.83,
      "r": 0
    },
    {
      "x": 807.88,
      "y": 319.88,
      "r": 0
    },
    {
      "x": 807.88,
      "y": 319.88,
      "r": 0
    },
    {
      "x": 808.01,
      "y": 319.93,
      "r": 0
    },
    {
      "x": 808.01,
      "y": 319.93,
      "r": 0
    },
    {
      "x": 808.14,
      "y": 319.98,
      "r": 0
    },
    {
      "x": 808.15,
      "y": 319.98,
      "r": 0
    },
    {
      "x": 808.29,
      "y": 320.04,
      "r": 0
    },
    {
      "x": 808.3,
      "y": 320.04,
      "r": 0
    },
    {
      "x": 808.41,
      "y": 320.08,
      "r": 0
    },
    {
      "x": 808.41,
      "y": 320.08,
      "r": 0
    },
    {
      "x": 808.54,
      "y": 320.13,
      "r": 0
    },
    {
      "x": 808.55,
      "y": 320.13,
      "r": 0
    },
    {
      "x": 808.67,
      "y": 320.18,
      "r": 0
    },
    {
      "x": 808.68,
      "y": 320.18,
      "r": 0
    },
    {
      "x": 808.81,
      "y": 320.23,
      "r": 0
    },
    {
      "x": 808.81,
      "y": 320.23,
      "r": 0
    },
    {
      "x": 808.94,
      "y": 320.28,
      "r": 0
    },
    {
      "x": 808.94,
      "y": 320.28,
      "r": 0
    },
    {
      "x": 809.06,
      "y": 320.33,
      "r": 0
    },
    {
      "x": 809.07,
      "y": 320.33,
      "r": 0
    },
    {
      "x": 809.2,
      "y": 320.38,
      "r": 0
    },
    {
      "x": 809.2,
      "y": 320.38,
      "r": 0
    },
    {
      "x": 809.33,
      "y": 320.43,
      "r": 0
    },
    {
      "x": 809.33,
      "y": 320.43,
      "r": 0
    },
    {
      "x": 809.45,
      "y": 320.48,
      "r": 0
    },
    {
      "x": 809.46,
      "y": 320.48,
      "r": 0
    },
    {
      "x": 809.58,
      "y": 320.53,
      "r": 0
    },
    {
      "x": 809.58,
      "y": 320.53,
      "r": 0
    },
    {
      "x": 809.71,
      "y": 320.58,
      "r": 0
    },
    {
      "x": 809.71,
      "y": 320.58,
      "r": 0
    },
    {
      "x": 809.83,
      "y": 320.63,
      "r": 0
    },
    {
      "x": 809.84,
      "y": 320.63,
      "r": 0
    },
    {
      "x": 809.96,
      "y": 320.68,
      "r": 0
    },
    {
      "x": 809.96,
      "y": 320.68,
      "r": 0
    },
    {
      "x": 810.09,
      "y": 320.73,
      "r": 0
    },
    {
      "x": 810.09,
      "y": 320.73,
      "r": 0
    },
    {
      "x": 810.22,
      "y": 320.78,
      "r": 0
    },
    {
      "x": 810.22,
      "y": 320.78,
      "r": 0
    },
    {
      "x": 810.34,
      "y": 320.82,
      "r": 0
    },
    {
      "x": 810.34,
      "y": 320.82,
      "r": 0
    },
    {
      "x": 810.47,
      "y": 320.87,
      "r": 0
    },
    {
      "x": 810.47,
      "y": 320.87,
      "r": 0
    },
    {
      "x": 810.61,
      "y": 320.93,
      "r": 0
    },
    {
      "x": 810.61,
      "y": 320.93,
      "r": 0
    },
    {
      "x": 810.72,
      "y": 320.97,
      "r": 0
    },
    {
      "x": 810.72,
      "y": 320.97,
      "r": 0
    },
    {
      "x": 810.85,
      "y": 321.02,
      "r": 0
    },
    {
      "x": 810.85,
      "y": 321.02,
      "r": 0
    },
    {
      "x": 810.97,
      "y": 321.07,
      "r": 0
    },
    {
      "x": 810.97,
      "y": 321.07,
      "r": 0
    },
    {
      "x": 811.09,
      "y": 321.11,
      "r": 0
    },
    {
      "x": 811.09,
      "y": 321.11,
      "r": 0
    },
    {
      "x": 811.22,
      "y": 321.16,
      "r": 0
    },
    {
      "x": 811.22,
      "y": 321.16,
      "r": 0
    },
    {
      "x": 811.34,
      "y": 321.21,
      "r": 0
    },
    {
      "x": 811.34,
      "y": 321.21,
      "r": 0
    },
    {
      "x": 811.46,
      "y": 321.25,
      "r": 0
    },
    {
      "x": 811.46,
      "y": 321.25,
      "r": 0
    },
    {
      "x": 811.58,
      "y": 321.3,
      "r": 0
    },
    {
      "x": 811.58,
      "y": 321.3,
      "r": 0
    },
    {
      "x": 811.71,
      "y": 321.35,
      "r": 0
    },
    {
      "x": 811.71,
      "y": 321.35,
      "r": 0
    },
    {
      "x": 811.82,
      "y": 321.39,
      "r": 0
    },
    {
      "x": 811.83,
      "y": 321.4,
      "r": 0
    },
    {
      "x": 811.94,
      "y": 321.44,
      "r": 0
    },
    {
      "x": 811.95,
      "y": 321.44,
      "r": 0
    },
    {
      "x": 812.07,
      "y": 321.49,
      "r": 0
    },
    {
      "x": 812.07,
      "y": 321.49,
      "r": 0
    },
    {
      "x": 812.18,
      "y": 321.53,
      "r": 0
    },
    {
      "x": 812.19,
      "y": 321.53,
      "r": 0
    },
    {
      "x": 812.3,
      "y": 321.58,
      "r": 0
    },
    {
      "x": 812.3,
      "y": 321.58,
      "r": 0
    },
    {
      "x": 812.42,
      "y": 321.62,
      "r": 0
    },
    {
      "x": 812.42,
      "y": 321.62,
      "r": 0
    },
    {
      "x": 812.54,
      "y": 321.67,
      "r": 0
    },
    {
      "x": 812.54,
      "y": 321.67,
      "r": 0
    },
    {
      "x": 812.66,
      "y": 321.71,
      "r": 0
    },
    {
      "x": 812.66,
      "y": 321.71,
      "r": 0
    },
    {
      "x": 812.78,
      "y": 321.76,
      "r": 0
    },
    {
      "x": 812.79,
      "y": 321.77,
      "r": 0
    },
    {
      "x": 812.9,
      "y": 321.81,
      "r": 0
    },
    {
      "x": 812.9,
      "y": 321.81,
      "r": 0
    },
    {
      "x": 813.01,
      "y": 321.85,
      "r": 0
    },
    {
      "x": 813.01,
      "y": 321.85,
      "r": 0
    },
    {
      "x": 813.13,
      "y": 321.89,
      "r": 0
    },
    {
      "x": 813.13,
      "y": 321.89,
      "r": 0
    },
    {
      "x": 813.24,
      "y": 321.94,
      "r": 0
    },
    {
      "x": 813.24,
      "y": 321.94,
      "r": 0
    },
    {
      "x": 813.36,
      "y": 321.98,
      "r": 0
    },
    {
      "x": 813.36,
      "y": 321.98,
      "r": 0
    },
    {
      "x": 813.47,
      "y": 322.03,
      "r": 0
    },
    {
      "x": 813.48,
      "y": 322.03,
      "r": 0
    },
    {
      "x": 813.58,
      "y": 322.07,
      "r": 0
    },
    {
      "x": 813.59,
      "y": 322.07,
      "r": 0
    },
    {
      "x": 813.7,
      "y": 322.11,
      "r": 0
    },
    {
      "x": 813.71,
      "y": 322.12,
      "r": 0
    },
    {
      "x": 813.81,
      "y": 322.16,
      "r": 0
    },
    {
      "x": 813.81,
      "y": 322.16,
      "r": 0
    },
    {
      "x": 813.92,
      "y": 322.2,
      "r": 0
    },
    {
      "x": 813.93,
      "y": 322.2,
      "r": 0
    },
    {
      "x": 814.04,
      "y": 322.25,
      "r": 0
    },
    {
      "x": 814.04,
      "y": 322.25,
      "r": 0
    },
    {
      "x": 814.15,
      "y": 322.29,
      "r": 0
    },
    {
      "x": 814.15,
      "y": 322.29,
      "r": 0
    },
    {
      "x": 814.26,
      "y": 322.33,
      "r": 0
    },
    {
      "x": 814.27,
      "y": 322.33,
      "r": 0
    },
    {
      "x": 814.37,
      "y": 322.37,
      "r": 0
    },
    {
      "x": 814.37,
      "y": 322.37,
      "r": 0
    },
    {
      "x": 814.49,
      "y": 322.42,
      "r": 0
    },
    {
      "x": 814.49,
      "y": 322.42,
      "r": 0
    },
    {
      "x": 814.6,
      "y": 322.46,
      "r": 0
    },
    {
      "x": 814.6,
      "y": 322.46,
      "r": 0
    },
    {
      "x": 814.71,
      "y": 322.5,
      "r": 0
    },
    {
      "x": 814.71,
      "y": 322.5,
      "r": 0
    },
    {
      "x": 814.83,
      "y": 322.55,
      "r": 0
    },
    {
      "x": 814.84,
      "y": 322.55,
      "r": 0
    },
    {
      "x": 814.93,
      "y": 322.59,
      "r": 0
    },
    {
      "x": 814.93,
      "y": 322.59,
      "r": 0
    },
    {
      "x": 815.03,
      "y": 322.63,
      "r": 0
    },
    {
      "x": 815.04,
      "y": 322.63,
      "r": 0
    },
    {
      "x": 815.14,
      "y": 322.67,
      "r": 0
    },
    {
      "x": 815.14,
      "y": 322.67,
      "r": 0
    },
    {
      "x": 815.25,
      "y": 322.71,
      "r": 0
    },
    {
      "x": 815.25,
      "y": 322.71,
      "r": 0
    },
    {
      "x": 815.36,
      "y": 322.75,
      "r": 0
    },
    {
      "x": 815.36,
      "y": 322.76,
      "r": 0
    },
    {
      "x": 815.47,
      "y": 322.8,
      "r": 0
    },
    {
      "x": 815.47,
      "y": 322.8,
      "r": 0
    },
    {
      "x": 815.58,
      "y": 322.84,
      "r": 0
    },
    {
      "x": 815.58,
      "y": 322.84,
      "r": 0
    },
    {
      "x": 815.68,
      "y": 322.88,
      "r": 0
    },
    {
      "x": 815.68,
      "y": 322.88,
      "r": 0
    },
    {
      "x": 815.79,
      "y": 322.92,
      "r": 0
    },
    {
      "x": 815.79,
      "y": 322.92,
      "r": 0
    },
    {
      "x": 815.89,
      "y": 322.96,
      "r": 0
    },
    {
      "x": 815.89,
      "y": 322.96,
      "r": 0
    },
    {
      "x": 815.99,
      "y": 323,
      "r": 0
    },
    {
      "x": 816,
      "y": 323,
      "r": 0
    },
    {
      "x": 816.1,
      "y": 323.04,
      "r": 0
    },
    {
      "x": 816.11,
      "y": 323.04,
      "r": 0
    },
    {
      "x": 816.21,
      "y": 323.08,
      "r": 0
    },
    {
      "x": 816.21,
      "y": 323.08,
      "r": 0
    },
    {
      "x": 816.31,
      "y": 323.12,
      "r": 0
    },
    {
      "x": 816.31,
      "y": 323.12,
      "r": 0
    },
    {
      "x": 816.41,
      "y": 323.16,
      "r": 0
    },
    {
      "x": 816.41,
      "y": 323.16,
      "r": 0
    },
    {
      "x": 816.52,
      "y": 323.2,
      "r": 0
    },
    {
      "x": 816.52,
      "y": 323.2,
      "r": 0
    },
    {
      "x": 816.62,
      "y": 323.24,
      "r": 0
    },
    {
      "x": 816.62,
      "y": 323.24,
      "r": 0
    },
    {
      "x": 816.73,
      "y": 323.28,
      "r": 0
    },
    {
      "x": 816.73,
      "y": 323.28,
      "r": 0
    },
    {
      "x": 816.82,
      "y": 323.32,
      "r": 0
    },
    {
      "x": 816.82,
      "y": 323.32,
      "r": 0
    },
    {
      "x": 816.93,
      "y": 323.36,
      "r": 0
    },
    {
      "x": 816.93,
      "y": 323.36,
      "r": 0
    },
    {
      "x": 817.02,
      "y": 323.39,
      "r": 0
    },
    {
      "x": 817.03,
      "y": 323.4,
      "r": 0
    },
    {
      "x": 817.13,
      "y": 323.43,
      "r": 0
    },
    {
      "x": 817.13,
      "y": 323.43,
      "r": 0
    },
    {
      "x": 817.23,
      "y": 323.47,
      "r": 0
    },
    {
      "x": 817.23,
      "y": 323.47,
      "r": 0
    },
    {
      "x": 817.32,
      "y": 323.51,
      "r": 0
    },
    {
      "x": 817.33,
      "y": 323.51,
      "r": 0
    },
    {
      "x": 817.43,
      "y": 323.55,
      "r": 0
    },
    {
      "x": 817.43,
      "y": 323.55,
      "r": 0
    },
    {
      "x": 817.53,
      "y": 323.59,
      "r": 0
    },
    {
      "x": 817.53,
      "y": 323.59,
      "r": 0
    },
    {
      "x": 817.62,
      "y": 323.62,
      "r": 0
    },
    {
      "x": 817.63,
      "y": 323.63,
      "r": 0
    },
    {
      "x": 817.72,
      "y": 323.66,
      "r": 0
    },
    {
      "x": 817.73,
      "y": 323.66,
      "r": 0
    },
    {
      "x": 817.82,
      "y": 323.7,
      "r": 0
    },
    {
      "x": 817.82,
      "y": 323.7,
      "r": 0
    },
    {
      "x": 817.91,
      "y": 323.74,
      "r": 0
    },
    {
      "x": 817.92,
      "y": 323.74,
      "r": 0
    },
    {
      "x": 818.01,
      "y": 323.77,
      "r": 0
    },
    {
      "x": 818.01,
      "y": 323.77,
      "r": 0
    },
    {
      "x": 818.11,
      "y": 323.81,
      "r": 0
    },
    {
      "x": 818.11,
      "y": 323.81,
      "r": 0
    },
    {
      "x": 818.2,
      "y": 323.85,
      "r": 0
    },
    {
      "x": 818.21,
      "y": 323.85,
      "r": 0
    },
    {
      "x": 818.3,
      "y": 323.88,
      "r": 0
    },
    {
      "x": 818.3,
      "y": 323.88,
      "r": 0
    },
    {
      "x": 818.4,
      "y": 323.92,
      "r": 0
    },
    {
      "x": 818.4,
      "y": 323.92,
      "r": 0
    },
    {
      "x": 818.5,
      "y": 323.96,
      "r": 0
    },
    {
      "x": 818.53,
      "y": 323.97,
      "r": 0
    },
    {
      "x": 818.58,
      "y": 323.99,
      "r": 0
    },
    {
      "x": 818.59,
      "y": 324,
      "r": 0
    },
    {
      "x": 818.68,
      "y": 324.03,
      "r": 0
    },
    {
      "x": 818.68,
      "y": 324.03,
      "r": 0
    },
    {
      "x": 818.77,
      "y": 324.06,
      "r": 0
    },
    {
      "x": 818.77,
      "y": 324.07,
      "r": 0
    },
    {
      "x": 818.86,
      "y": 324.1,
      "r": 0
    },
    {
      "x": 818.87,
      "y": 324.1,
      "r": 0
    },
    {
      "x": 818.96,
      "y": 324.14,
      "r": 0
    },
    {
      "x": 818.96,
      "y": 324.14,
      "r": 0
    },
    {
      "x": 819.05,
      "y": 324.17,
      "r": 0
    },
    {
      "x": 819.05,
      "y": 324.17,
      "r": 0
    },
    {
      "x": 819.14,
      "y": 324.21,
      "r": 0
    },
    {
      "x": 819.14,
      "y": 324.21,
      "r": 0
    },
    {
      "x": 819.23,
      "y": 324.24,
      "r": 0
    },
    {
      "x": 819.23,
      "y": 324.24,
      "r": 0
    },
    {
      "x": 819.32,
      "y": 324.28,
      "r": 0
    },
    {
      "x": 819.32,
      "y": 324.28,
      "r": 0
    },
    {
      "x": 819.41,
      "y": 324.31,
      "r": 0
    },
    {
      "x": 819.42,
      "y": 324.31,
      "r": 0
    },
    {
      "x": 819.5,
      "y": 324.35,
      "r": 0
    },
    {
      "x": 819.5,
      "y": 324.35,
      "r": 0
    },
    {
      "x": 819.59,
      "y": 324.38,
      "r": 0
    },
    {
      "x": 819.59,
      "y": 324.38,
      "r": 0
    },
    {
      "x": 819.68,
      "y": 324.42,
      "r": 0
    },
    {
      "x": 819.68,
      "y": 324.42,
      "r": 0
    },
    {
      "x": 819.77,
      "y": 324.45,
      "r": 0
    },
    {
      "x": 819.77,
      "y": 324.45,
      "r": 0
    },
    {
      "x": 819.86,
      "y": 324.48,
      "r": 0
    },
    {
      "x": 819.86,
      "y": 324.48,
      "r": 0
    },
    {
      "x": 819.94,
      "y": 324.52,
      "r": 0
    },
    {
      "x": 819.95,
      "y": 324.52,
      "r": 0
    },
    {
      "x": 820.03,
      "y": 324.55,
      "r": 0
    },
    {
      "x": 820.03,
      "y": 324.55,
      "r": 0
    },
    {
      "x": 820.12,
      "y": 324.59,
      "r": 0
    },
    {
      "x": 820.12,
      "y": 324.59,
      "r": 0
    },
    {
      "x": 820.2,
      "y": 324.62,
      "r": 0
    },
    {
      "x": 820.21,
      "y": 324.62,
      "r": 0
    },
    {
      "x": 820.29,
      "y": 324.65,
      "r": 0
    },
    {
      "x": 820.29,
      "y": 324.65,
      "r": 0
    },
    {
      "x": 820.38,
      "y": 324.68,
      "r": 0
    },
    {
      "x": 820.38,
      "y": 324.68,
      "r": 0
    },
    {
      "x": 820.46,
      "y": 324.72,
      "r": 0
    },
    {
      "x": 820.47,
      "y": 324.72,
      "r": 0
    },
    {
      "x": 820.55,
      "y": 324.75,
      "r": 0
    },
    {
      "x": 820.55,
      "y": 324.75,
      "r": 0
    },
    {
      "x": 820.63,
      "y": 324.78,
      "r": 0
    },
    {
      "x": 820.63,
      "y": 324.78,
      "r": 0
    },
    {
      "x": 820.71,
      "y": 324.81,
      "r": 0
    },
    {
      "x": 820.72,
      "y": 324.82,
      "r": 0
    },
    {
      "x": 820.8,
      "y": 324.85,
      "r": 0
    },
    {
      "x": 820.8,
      "y": 324.85,
      "r": 0
    },
    {
      "x": 820.88,
      "y": 324.88,
      "r": 0
    },
    {
      "x": 820.88,
      "y": 324.88,
      "r": 0
    },
    {
      "x": 820.96,
      "y": 324.91,
      "r": 0
    },
    {
      "x": 820.97,
      "y": 324.91,
      "r": 0
    },
    {
      "x": 821.05,
      "y": 324.94,
      "r": 0
    },
    {
      "x": 821.05,
      "y": 324.94,
      "r": 0
    },
    {
      "x": 821.13,
      "y": 324.97,
      "r": 0
    },
    {
      "x": 821.13,
      "y": 324.97,
      "r": 0
    },
    {
      "x": 821.21,
      "y": 325.01,
      "r": 0
    },
    {
      "x": 821.21,
      "y": 325.01,
      "r": 0
    },
    {
      "x": 821.29,
      "y": 325.04,
      "r": 0
    },
    {
      "x": 821.3,
      "y": 325.04,
      "r": 0
    },
    {
      "x": 821.37,
      "y": 325.07,
      "r": 0
    },
    {
      "x": 821.37,
      "y": 325.07,
      "r": 0
    },
    {
      "x": 821.46,
      "y": 325.1,
      "r": 0
    },
    {
      "x": 821.46,
      "y": 325.1,
      "r": 0
    },
    {
      "x": 821.53,
      "y": 325.13,
      "r": 0
    },
    {
      "x": 821.54,
      "y": 325.13,
      "r": 0
    },
    {
      "x": 821.61,
      "y": 325.16,
      "r": 0
    },
    {
      "x": 821.62,
      "y": 325.16,
      "r": 0
    },
    {
      "x": 821.69,
      "y": 325.19,
      "r": 0
    },
    {
      "x": 821.69,
      "y": 325.19,
      "r": 0
    },
    {
      "x": 821.77,
      "y": 325.22,
      "r": 0
    },
    {
      "x": 821.77,
      "y": 325.22,
      "r": 0
    },
    {
      "x": 821.85,
      "y": 325.25,
      "r": 0
    },
    {
      "x": 821.85,
      "y": 325.25,
      "r": 0
    },
    {
      "x": 821.93,
      "y": 325.28,
      "r": 0
    },
    {
      "x": 821.93,
      "y": 325.28,
      "r": 0
    },
    {
      "x": 822,
      "y": 325.31,
      "r": 0
    },
    {
      "x": 822.01,
      "y": 325.31,
      "r": 0
    },
    {
      "x": 822.08,
      "y": 325.34,
      "r": 0
    },
    {
      "x": 822.08,
      "y": 325.34,
      "r": 0
    },
    {
      "x": 822.16,
      "y": 325.37,
      "r": 0
    },
    {
      "x": 822.16,
      "y": 325.37,
      "r": 0
    },
    {
      "x": 822.23,
      "y": 325.4,
      "r": 0
    },
    {
      "x": 822.24,
      "y": 325.4,
      "r": 0
    },
    {
      "x": 822.31,
      "y": 325.43,
      "r": 0
    },
    {
      "x": 822.31,
      "y": 325.43,
      "r": 0
    },
    {
      "x": 822.38,
      "y": 325.46,
      "r": 0
    },
    {
      "x": 822.38,
      "y": 325.46,
      "r": 0
    },
    {
      "x": 822.46,
      "y": 325.48,
      "r": 0
    },
    {
      "x": 822.46,
      "y": 325.48,
      "r": 0
    },
    {
      "x": 822.53,
      "y": 325.51,
      "r": 0
    },
    {
      "x": 822.54,
      "y": 325.51,
      "r": 0
    },
    {
      "x": 822.61,
      "y": 325.54,
      "r": 0
    },
    {
      "x": 822.61,
      "y": 325.54,
      "r": 0
    },
    {
      "x": 822.68,
      "y": 325.57,
      "r": 0
    },
    {
      "x": 822.68,
      "y": 325.57,
      "r": 0
    },
    {
      "x": 822.75,
      "y": 325.6,
      "r": 0
    },
    {
      "x": 822.76,
      "y": 325.6,
      "r": 0
    },
    {
      "x": 822.83,
      "y": 325.63,
      "r": 0
    },
    {
      "x": 822.83,
      "y": 325.63,
      "r": 0
    },
    {
      "x": 822.9,
      "y": 325.65,
      "r": 0
    },
    {
      "x": 822.9,
      "y": 325.65,
      "r": 0
    },
    {
      "x": 822.97,
      "y": 325.68,
      "r": 0
    },
    {
      "x": 822.98,
      "y": 325.68,
      "r": 0
    },
    {
      "x": 823.04,
      "y": 325.71,
      "r": 0
    },
    {
      "x": 823.04,
      "y": 325.71,
      "r": 0
    },
    {
      "x": 823.11,
      "y": 325.73,
      "r": 0
    },
    {
      "x": 823.11,
      "y": 325.74,
      "r": 0
    },
    {
      "x": 823.18,
      "y": 325.76,
      "r": 0
    },
    {
      "x": 823.18,
      "y": 325.76,
      "r": 0
    },
    {
      "x": 823.25,
      "y": 325.79,
      "r": 0
    },
    {
      "x": 823.25,
      "y": 325.79,
      "r": 0
    },
    {
      "x": 823.32,
      "y": 325.82,
      "r": 0
    },
    {
      "x": 823.32,
      "y": 325.82,
      "r": 0
    },
    {
      "x": 823.39,
      "y": 325.84,
      "r": 0
    },
    {
      "x": 823.39,
      "y": 325.84,
      "r": 0
    },
    {
      "x": 823.46,
      "y": 325.87,
      "r": 0
    },
    {
      "x": 823.46,
      "y": 325.87,
      "r": 0
    },
    {
      "x": 823.53,
      "y": 325.9,
      "r": 0
    },
    {
      "x": 823.53,
      "y": 325.9,
      "r": 0
    },
    {
      "x": 823.59,
      "y": 325.92,
      "r": 0
    },
    {
      "x": 823.6,
      "y": 325.92,
      "r": 0
    },
    {
      "x": 823.66,
      "y": 325.95,
      "r": 0
    },
    {
      "x": 823.66,
      "y": 325.95,
      "r": 0
    },
    {
      "x": 823.73,
      "y": 325.97,
      "r": 0
    },
    {
      "x": 823.73,
      "y": 325.97,
      "r": 0
    },
    {
      "x": 823.8,
      "y": 326,
      "r": 0
    },
    {
      "x": 823.8,
      "y": 326,
      "r": 0
    },
    {
      "x": 823.86,
      "y": 326.02,
      "r": 0
    },
    {
      "x": 823.86,
      "y": 326.02,
      "r": 0
    },
    {
      "x": 823.93,
      "y": 326.05,
      "r": 0
    },
    {
      "x": 823.93,
      "y": 326.05,
      "r": 0
    },
    {
      "x": 823.99,
      "y": 326.07,
      "r": 0
    },
    {
      "x": 824,
      "y": 326.08,
      "r": 0
    },
    {
      "x": 824.06,
      "y": 326.1,
      "r": 0
    },
    {
      "x": 824.06,
      "y": 326.1,
      "r": 0
    },
    {
      "x": 824.12,
      "y": 326.12,
      "r": 0
    },
    {
      "x": 824.12,
      "y": 326.12,
      "r": 0
    },
    {
      "x": 824.19,
      "y": 326.15,
      "r": 0
    },
    {
      "x": 824.2,
      "y": 326.15,
      "r": 0
    },
    {
      "x": 824.25,
      "y": 326.17,
      "r": 0
    },
    {
      "x": 824.25,
      "y": 326.17,
      "r": 0
    },
    {
      "x": 824.32,
      "y": 326.2,
      "r": 0
    },
    {
      "x": 824.32,
      "y": 326.2,
      "r": 0
    },
    {
      "x": 824.38,
      "y": 326.22,
      "r": 0
    },
    {
      "x": 824.38,
      "y": 326.22,
      "r": 0
    },
    {
      "x": 824.44,
      "y": 326.25,
      "r": 0
    },
    {
      "x": 824.44,
      "y": 326.25,
      "r": 0
    },
    {
      "x": 824.5,
      "y": 326.27,
      "r": 0
    },
    {
      "x": 824.5,
      "y": 326.27,
      "r": 0
    },
    {
      "x": 824.56,
      "y": 326.29,
      "r": 0
    },
    {
      "x": 824.56,
      "y": 326.29,
      "r": 0
    },
    {
      "x": 824.62,
      "y": 326.32,
      "r": 0
    },
    {
      "x": 824.62,
      "y": 326.32,
      "r": 0
    },
    {
      "x": 824.69,
      "y": 326.34,
      "r": 0
    },
    {
      "x": 824.69,
      "y": 326.34,
      "r": 0
    },
    {
      "x": 824.74,
      "y": 326.36,
      "r": 0
    },
    {
      "x": 824.75,
      "y": 326.36,
      "r": 0
    },
    {
      "x": 824.8,
      "y": 326.39,
      "r": 0
    },
    {
      "x": 824.8,
      "y": 326.39,
      "r": 0
    },
    {
      "x": 824.86,
      "y": 326.41,
      "r": 0
    },
    {
      "x": 824.86,
      "y": 326.41,
      "r": 0
    },
    {
      "x": 824.92,
      "y": 326.43,
      "r": 0
    },
    {
      "x": 824.92,
      "y": 326.43,
      "r": 0
    },
    {
      "x": 824.98,
      "y": 326.45,
      "r": 0
    },
    {
      "x": 824.98,
      "y": 326.46,
      "r": 0
    },
    {
      "x": 825.04,
      "y": 326.48,
      "r": 0
    },
    {
      "x": 825.04,
      "y": 326.48,
      "r": 0
    },
    {
      "x": 825.1,
      "y": 326.5,
      "r": 0
    },
    {
      "x": 825.1,
      "y": 326.5,
      "r": 0
    },
    {
      "x": 825.15,
      "y": 326.52,
      "r": 0
    },
    {
      "x": 825.16,
      "y": 326.52,
      "r": 0
    },
    {
      "x": 825.21,
      "y": 326.54,
      "r": 0
    },
    {
      "x": 825.21,
      "y": 326.54,
      "r": 0
    },
    {
      "x": 825.28,
      "y": 326.57,
      "r": 0
    },
    {
      "x": 825.28,
      "y": 326.57,
      "r": 0
    },
    {
      "x": 825.32,
      "y": 326.59,
      "r": 0
    },
    {
      "x": 825.33,
      "y": 326.59,
      "r": 0
    },
    {
      "x": 825.38,
      "y": 326.61,
      "r": 0
    },
    {
      "x": 825.38,
      "y": 326.61,
      "r": 0
    },
    {
      "x": 825.44,
      "y": 326.63,
      "r": 0
    },
    {
      "x": 825.44,
      "y": 326.63,
      "r": 0
    },
    {
      "x": 825.49,
      "y": 326.65,
      "r": 0
    },
    {
      "x": 825.49,
      "y": 326.65,
      "r": 0
    },
    {
      "x": 825.54,
      "y": 326.67,
      "r": 0
    },
    {
      "x": 825.54,
      "y": 326.67,
      "r": 0
    },
    {
      "x": 825.6,
      "y": 326.69,
      "r": 0
    },
    {
      "x": 825.6,
      "y": 326.69,
      "r": 0
    },
    {
      "x": 825.65,
      "y": 326.71,
      "r": 0
    },
    {
      "x": 825.65,
      "y": 326.71,
      "r": 0
    },
    {
      "x": 825.7,
      "y": 326.73,
      "r": 0
    },
    {
      "x": 825.7,
      "y": 326.73,
      "r": 0
    },
    {
      "x": 825.76,
      "y": 326.75,
      "r": 0
    },
    {
      "x": 825.76,
      "y": 326.75,
      "r": 0
    },
    {
      "x": 825.81,
      "y": 326.77,
      "r": 0
    },
    {
      "x": 825.81,
      "y": 326.77,
      "r": 0
    },
    {
      "x": 825.86,
      "y": 326.79,
      "r": 0
    },
    {
      "x": 825.86,
      "y": 326.79,
      "r": 0
    },
    {
      "x": 825.91,
      "y": 326.81,
      "r": 0
    },
    {
      "x": 825.93,
      "y": 326.82,
      "r": 0
    },
    {
      "x": 825.96,
      "y": 326.83,
      "r": 0
    },
    {
      "x": 825.97,
      "y": 326.83,
      "r": 0
    },
    {
      "x": 826.01,
      "y": 326.85,
      "r": 0
    },
    {
      "x": 826.02,
      "y": 326.85,
      "r": 0
    },
    {
      "x": 826.06,
      "y": 326.87,
      "r": 0
    },
    {
      "x": 826.06,
      "y": 326.87,
      "r": 0
    },
    {
      "x": 826.11,
      "y": 326.89,
      "r": 0
    },
    {
      "x": 826.12,
      "y": 326.89,
      "r": 0
    },
    {
      "x": 826.16,
      "y": 326.91,
      "r": 0
    },
    {
      "x": 826.17,
      "y": 326.91,
      "r": 0
    },
    {
      "x": 826.22,
      "y": 326.93,
      "r": 0
    },
    {
      "x": 826.22,
      "y": 326.93,
      "r": 0
    },
    {
      "x": 826.26,
      "y": 326.95,
      "r": 0
    },
    {
      "x": 826.26,
      "y": 326.95,
      "r": 0
    },
    {
      "x": 826.31,
      "y": 326.96,
      "r": 0
    },
    {
      "x": 826.31,
      "y": 326.97,
      "r": 0
    },
    {
      "x": 826.36,
      "y": 326.98,
      "r": 0
    },
    {
      "x": 826.36,
      "y": 326.98,
      "r": 0
    },
    {
      "x": 826.4,
      "y": 327,
      "r": 0
    },
    {
      "x": 826.4,
      "y": 327,
      "r": 0
    },
    {
      "x": 826.45,
      "y": 327.02,
      "r": 0
    },
    {
      "x": 826.45,
      "y": 327.02,
      "r": 0
    },
    {
      "x": 826.5,
      "y": 327.04,
      "r": 0
    },
    {
      "x": 826.5,
      "y": 327.04,
      "r": 0
    },
    {
      "x": 826.54,
      "y": 327.05,
      "r": 0
    },
    {
      "x": 826.54,
      "y": 327.05,
      "r": 0
    },
    {
      "x": 826.59,
      "y": 327.07,
      "r": 0
    },
    {
      "x": 826.59,
      "y": 327.07,
      "r": 0
    },
    {
      "x": 826.63,
      "y": 327.09,
      "r": 0
    },
    {
      "x": 826.64,
      "y": 327.09,
      "r": 0
    },
    {
      "x": 826.68,
      "y": 327.11,
      "r": 0
    },
    {
      "x": 826.68,
      "y": 327.11,
      "r": 0
    },
    {
      "x": 826.72,
      "y": 327.12,
      "r": 0
    },
    {
      "x": 826.72,
      "y": 327.12,
      "r": 0
    },
    {
      "x": 826.76,
      "y": 327.14,
      "r": 0
    },
    {
      "x": 826.77,
      "y": 327.14,
      "r": 0
    },
    {
      "x": 826.81,
      "y": 327.16,
      "r": 0
    },
    {
      "x": 826.81,
      "y": 327.16,
      "r": 0
    },
    {
      "x": 826.85,
      "y": 327.17,
      "r": 0
    },
    {
      "x": 826.85,
      "y": 327.17,
      "r": 0
    },
    {
      "x": 826.89,
      "y": 327.19,
      "r": 0
    },
    {
      "x": 826.89,
      "y": 327.19,
      "r": 0
    },
    {
      "x": 826.94,
      "y": 327.21,
      "r": 0
    },
    {
      "x": 826.94,
      "y": 327.21,
      "r": 0
    },
    {
      "x": 826.98,
      "y": 327.22,
      "r": 0
    },
    {
      "x": 826.98,
      "y": 327.22,
      "r": 0
    },
    {
      "x": 827.02,
      "y": 327.24,
      "r": 0
    },
    {
      "x": 827.02,
      "y": 327.24,
      "r": 0
    },
    {
      "x": 827.06,
      "y": 327.25,
      "r": 0
    },
    {
      "x": 827.06,
      "y": 327.25,
      "r": 0
    },
    {
      "x": 827.1,
      "y": 327.27,
      "r": 0
    },
    {
      "x": 827.1,
      "y": 327.27,
      "r": 0
    },
    {
      "x": 827.14,
      "y": 327.28,
      "r": 0
    },
    {
      "x": 827.14,
      "y": 327.28,
      "r": 0
    },
    {
      "x": 827.18,
      "y": 327.3,
      "r": 0
    },
    {
      "x": 827.18,
      "y": 327.3,
      "r": 0
    },
    {
      "x": 827.22,
      "y": 327.31,
      "r": 0
    },
    {
      "x": 827.22,
      "y": 327.32,
      "r": 0
    },
    {
      "x": 827.26,
      "y": 327.33,
      "r": 0
    },
    {
      "x": 827.26,
      "y": 327.33,
      "r": 0
    },
    {
      "x": 827.3,
      "y": 327.34,
      "r": 0
    },
    {
      "x": 827.3,
      "y": 327.35,
      "r": 0
    },
    {
      "x": 827.33,
      "y": 327.36,
      "r": 0
    },
    {
      "x": 827.33,
      "y": 327.36,
      "r": 0
    },
    {
      "x": 827.37,
      "y": 327.37,
      "r": 0
    },
    {
      "x": 827.37,
      "y": 327.37,
      "r": 0
    },
    {
      "x": 827.41,
      "y": 327.39,
      "r": 0
    },
    {
      "x": 827.41,
      "y": 327.39,
      "r": 0
    },
    {
      "x": 827.44,
      "y": 327.4,
      "r": 0
    },
    {
      "x": 827.44,
      "y": 327.4,
      "r": 0
    },
    {
      "x": 827.48,
      "y": 327.42,
      "r": 0
    },
    {
      "x": 827.48,
      "y": 327.42,
      "r": 0
    },
    {
      "x": 827.52,
      "y": 327.43,
      "r": 0
    },
    {
      "x": 827.52,
      "y": 327.43,
      "r": 0
    },
    {
      "x": 827.55,
      "y": 327.44,
      "r": 0
    },
    {
      "x": 827.55,
      "y": 327.44,
      "r": 0
    },
    {
      "x": 827.58,
      "y": 327.46,
      "r": 0
    },
    {
      "x": 827.59,
      "y": 327.46,
      "r": 0
    },
    {
      "x": 827.62,
      "y": 327.47,
      "r": 0
    },
    {
      "x": 827.62,
      "y": 327.47,
      "r": 0
    },
    {
      "x": 827.65,
      "y": 327.48,
      "r": 0
    },
    {
      "x": 827.65,
      "y": 327.48,
      "r": 0
    },
    {
      "x": 827.69,
      "y": 327.5,
      "r": 0
    },
    {
      "x": 827.7,
      "y": 327.5,
      "r": 0
    },
    {
      "x": 827.72,
      "y": 327.51,
      "r": 0
    },
    {
      "x": 827.72,
      "y": 327.51,
      "r": 0
    },
    {
      "x": 827.75,
      "y": 327.52,
      "r": 0
    },
    {
      "x": 827.75,
      "y": 327.52,
      "r": 0
    },
    {
      "x": 827.78,
      "y": 327.53,
      "r": 0
    },
    {
      "x": 827.79,
      "y": 327.53,
      "r": 0
    },
    {
      "x": 827.82,
      "y": 327.55,
      "r": 0
    },
    {
      "x": 827.82,
      "y": 327.55,
      "r": 0
    },
    {
      "x": 827.85,
      "y": 327.56,
      "r": 0
    },
    {
      "x": 827.85,
      "y": 327.56,
      "r": 0
    },
    {
      "x": 827.88,
      "y": 327.57,
      "r": 0
    },
    {
      "x": 827.88,
      "y": 327.57,
      "r": 0
    },
    {
      "x": 827.91,
      "y": 327.58,
      "r": 0
    },
    {
      "x": 827.91,
      "y": 327.58,
      "r": 0
    },
    {
      "x": 827.94,
      "y": 327.59,
      "r": 0
    },
    {
      "x": 827.94,
      "y": 327.59,
      "r": 0
    },
    {
      "x": 827.97,
      "y": 327.6,
      "r": 0
    },
    {
      "x": 827.97,
      "y": 327.6,
      "r": 0
    },
    {
      "x": 828,
      "y": 327.62,
      "r": 0
    },
    {
      "x": 828,
      "y": 327.62,
      "r": 0
    },
    {
      "x": 828.03,
      "y": 327.63,
      "r": 0
    },
    {
      "x": 828.03,
      "y": 327.63,
      "r": 0
    },
    {
      "x": 828.06,
      "y": 327.64,
      "r": 0
    },
    {
      "x": 828.06,
      "y": 327.64,
      "r": 0
    },
    {
      "x": 828.09,
      "y": 327.65,
      "r": 0
    },
    {
      "x": 828.09,
      "y": 327.65,
      "r": 0
    },
    {
      "x": 828.11,
      "y": 327.66,
      "r": 0
    },
    {
      "x": 828.11,
      "y": 327.66,
      "r": 0
    },
    {
      "x": 828.14,
      "y": 327.67,
      "r": 0
    },
    {
      "x": 828.14,
      "y": 327.67,
      "r": 0
    },
    {
      "x": 828.17,
      "y": 327.68,
      "r": 0
    },
    {
      "x": 828.17,
      "y": 327.68,
      "r": 0
    },
    {
      "x": 828.19,
      "y": 327.69,
      "r": 0
    },
    {
      "x": 828.19,
      "y": 327.69,
      "r": 0
    },
    {
      "x": 828.22,
      "y": 327.7,
      "r": 0
    },
    {
      "x": 828.22,
      "y": 327.7,
      "r": 0
    },
    {
      "x": 828.24,
      "y": 327.71,
      "r": 0
    },
    {
      "x": 828.25,
      "y": 327.71,
      "r": 0
    },
    {
      "x": 828.27,
      "y": 327.72,
      "r": 0
    },
    {
      "x": 828.27,
      "y": 327.72,
      "r": 0
    },
    {
      "x": 828.3,
      "y": 327.73,
      "r": 0
    },
    {
      "x": 828.3,
      "y": 327.73,
      "r": 0
    },
    {
      "x": 828.32,
      "y": 327.74,
      "r": 0
    },
    {
      "x": 828.32,
      "y": 327.74,
      "r": 0
    },
    {
      "x": 828.34,
      "y": 327.75,
      "r": 0
    },
    {
      "x": 828.34,
      "y": 327.75,
      "r": 0
    },
    {
      "x": 828.37,
      "y": 327.76,
      "r": 0
    },
    {
      "x": 828.37,
      "y": 327.76,
      "r": 0
    },
    {
      "x": 828.39,
      "y": 327.76,
      "r": 0
    },
    {
      "x": 828.39,
      "y": 327.77,
      "r": 0
    },
    {
      "x": 828.41,
      "y": 327.77,
      "r": 0
    },
    {
      "x": 828.41,
      "y": 327.77,
      "r": 0
    },
    {
      "x": 828.43,
      "y": 327.78,
      "r": 0
    },
    {
      "x": 828.43,
      "y": 327.78,
      "r": 0
    },
    {
      "x": 828.45,
      "y": 327.79,
      "r": 0
    },
    {
      "x": 828.46,
      "y": 327.79,
      "r": 0
    },
    {
      "x": 828.48,
      "y": 327.8,
      "r": 0
    },
    {
      "x": 828.48,
      "y": 327.8,
      "r": 0
    },
    {
      "x": 828.5,
      "y": 327.81,
      "r": 0
    },
    {
      "x": 828.5,
      "y": 327.81,
      "r": 0
    },
    {
      "x": 828.52,
      "y": 327.81,
      "r": 0
    },
    {
      "x": 828.52,
      "y": 327.81,
      "r": 0
    },
    {
      "x": 828.54,
      "y": 327.82,
      "r": 0
    },
    {
      "x": 828.54,
      "y": 327.82,
      "r": 0
    },
    {
      "x": 828.56,
      "y": 327.83,
      "r": 0
    },
    {
      "x": 828.56,
      "y": 327.83,
      "r": 0
    },
    {
      "x": 828.58,
      "y": 327.84,
      "r": 0
    },
    {
      "x": 828.58,
      "y": 327.84,
      "r": 0
    },
    {
      "x": 828.6,
      "y": 327.84,
      "r": 0
    },
    {
      "x": 828.6,
      "y": 327.84,
      "r": 0
    },
    {
      "x": 828.61,
      "y": 327.85,
      "r": 0
    },
    {
      "x": 828.62,
      "y": 327.85,
      "r": 0
    },
    {
      "x": 828.63,
      "y": 327.86,
      "r": 0
    },
    {
      "x": 828.63,
      "y": 327.86,
      "r": 0
    },
    {
      "x": 828.65,
      "y": 327.86,
      "r": 0
    },
    {
      "x": 828.65,
      "y": 327.87,
      "r": 0
    },
    {
      "x": 828.67,
      "y": 327.87,
      "r": 0
    },
    {
      "x": 828.67,
      "y": 327.87,
      "r": 0
    },
    {
      "x": 828.68,
      "y": 327.88,
      "r": 0
    },
    {
      "x": 828.68,
      "y": 327.88,
      "r": 0
    },
    {
      "x": 828.7,
      "y": 327.88,
      "r": 0
    },
    {
      "x": 828.7,
      "y": 327.88,
      "r": 0
    },
    {
      "x": 828.71,
      "y": 327.89,
      "r": 0
    },
    {
      "x": 828.72,
      "y": 327.89,
      "r": 0
    },
    {
      "x": 828.73,
      "y": 327.9,
      "r": 0
    },
    {
      "x": 828.73,
      "y": 327.9,
      "r": 0
    },
    {
      "x": 828.74,
      "y": 327.9,
      "r": 0
    },
    {
      "x": 828.75,
      "y": 327.9,
      "r": 0
    },
    {
      "x": 828.76,
      "y": 327.91,
      "r": 0
    },
    {
      "x": 828.76,
      "y": 327.91,
      "r": 0
    },
    {
      "x": 828.77,
      "y": 327.91,
      "r": 0
    },
    {
      "x": 828.77,
      "y": 327.91,
      "r": 0
    },
    {
      "x": 828.79,
      "y": 327.92,
      "r": 0
    },
    {
      "x": 828.79,
      "y": 327.92,
      "r": 0
    },
    {
      "x": 828.8,
      "y": 327.92,
      "r": 0
    },
    {
      "x": 828.8,
      "y": 327.92,
      "r": 0
    },
    {
      "x": 828.81,
      "y": 327.93,
      "r": 0
    },
    {
      "x": 828.81,
      "y": 327.93,
      "r": 0
    },
    {
      "x": 828.83,
      "y": 327.93,
      "r": 0
    },
    {
      "x": 828.83,
      "y": 327.93,
      "r": 0
    },
    {
      "x": 828.84,
      "y": 327.94,
      "r": 0
    },
    {
      "x": 828.84,
      "y": 327.94,
      "r": 0
    },
    {
      "x": 828.85,
      "y": 327.94,
      "r": 0
    },
    {
      "x": 828.85,
      "y": 327.94,
      "r": 0
    },
    {
      "x": 828.86,
      "y": 327.95,
      "r": 0
    },
    {
      "x": 828.86,
      "y": 327.95,
      "r": 0
    },
    {
      "x": 828.87,
      "y": 327.95,
      "r": 0
    },
    {
      "x": 828.87,
      "y": 327.95,
      "r": 0
    },
    {
      "x": 828.88,
      "y": 327.95,
      "r": 0
    },
    {
      "x": 828.88,
      "y": 327.95,
      "r": 0
    },
    {
      "x": 828.89,
      "y": 327.96,
      "r": 0
    },
    {
      "x": 828.89,
      "y": 327.96,
      "r": 0
    },
    {
      "x": 828.9,
      "y": 327.96,
      "r": 0
    },
    {
      "x": 828.9,
      "y": 327.96,
      "r": 0
    },
    {
      "x": 828.91,
      "y": 327.97,
      "r": 0
    },
    {
      "x": 828.91,
      "y": 327.97,
      "r": 0
    },
    {
      "x": 828.92,
      "y": 327.97,
      "r": 0
    },
    {
      "x": 828.92,
      "y": 327.97,
      "r": 0
    },
    {
      "x": 828.93,
      "y": 327.97,
      "r": 0
    },
    {
      "x": 828.93,
      "y": 327.97,
      "r": 0
    },
    {
      "x": 828.93,
      "y": 327.97,
      "r": 0
    },
    {
      "x": 828.93,
      "y": 327.97,
      "r": 0
    },
    {
      "x": 828.94,
      "y": 327.98,
      "r": 0
    },
    {
      "x": 828.94,
      "y": 327.98,
      "r": 0
    },
    {
      "x": 828.95,
      "y": 327.98,
      "r": 0
    },
    {
      "x": 828.95,
      "y": 327.98,
      "r": 0
    }
  ]
}
